(function () {
var $9052383c1c4e5569$var$t = "undefined" != typeof window ? window : void 0, $9052383c1c4e5569$var$i = "undefined" != typeof globalThis ? globalThis : $9052383c1c4e5569$var$t;
"undefined" == typeof self && ($9052383c1c4e5569$var$i.self = $9052383c1c4e5569$var$i), "undefined" == typeof File && ($9052383c1c4e5569$var$i.File = function() {});
var $9052383c1c4e5569$var$e = Array.prototype, $9052383c1c4e5569$var$r = $9052383c1c4e5569$var$e.forEach, $9052383c1c4e5569$var$s = $9052383c1c4e5569$var$e.indexOf, $9052383c1c4e5569$var$n = null == $9052383c1c4e5569$var$i ? void 0 : $9052383c1c4e5569$var$i.navigator, $9052383c1c4e5569$var$o = null == $9052383c1c4e5569$var$i ? void 0 : $9052383c1c4e5569$var$i.document, $9052383c1c4e5569$var$a = null == $9052383c1c4e5569$var$i ? void 0 : $9052383c1c4e5569$var$i.location, $9052383c1c4e5569$var$l = null == $9052383c1c4e5569$var$i ? void 0 : $9052383c1c4e5569$var$i.fetch, $9052383c1c4e5569$var$u = null != $9052383c1c4e5569$var$i && $9052383c1c4e5569$var$i.XMLHttpRequest && "withCredentials" in new $9052383c1c4e5569$var$i.XMLHttpRequest ? $9052383c1c4e5569$var$i.XMLHttpRequest : void 0, $9052383c1c4e5569$var$h = null == $9052383c1c4e5569$var$i ? void 0 : $9052383c1c4e5569$var$i.AbortController, $9052383c1c4e5569$var$d = null == $9052383c1c4e5569$var$n ? void 0 : $9052383c1c4e5569$var$n.userAgent, $9052383c1c4e5569$var$v = null != $9052383c1c4e5569$var$t ? $9052383c1c4e5569$var$t : {}, $9052383c1c4e5569$var$c = {
    DEBUG: !1,
    LIB_VERSION: "1.341.0"
};
function $9052383c1c4e5569$var$f(t, i, e, r, s, n, o) {
    try {
        var a = t[n](o), l = a.value;
    } catch (t) {
        return void e(t);
    }
    a.done ? i(l) : Promise.resolve(l).then(r, s);
}
function $9052383c1c4e5569$var$p(t) {
    return function() {
        var i = this, e = arguments;
        return new Promise(function(r, s) {
            var n = t.apply(i, e);
            function o(t) {
                $9052383c1c4e5569$var$f(n, r, s, o, a, "next", t);
            }
            function a(t) {
                $9052383c1c4e5569$var$f(n, r, s, o, a, "throw", t);
            }
            o(void 0);
        });
    };
}
function $9052383c1c4e5569$var$g() {
    return $9052383c1c4e5569$var$g = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var e = arguments[i];
            for(var r in e)({}).hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, $9052383c1c4e5569$var$g.apply(null, arguments);
}
function $9052383c1c4e5569$var$_(t, i) {
    if (null == t) return {};
    var e = {};
    for(var r in t)if (({}).hasOwnProperty.call(t, r)) {
        if (-1 !== i.indexOf(r)) continue;
        e[r] = t[r];
    }
    return e;
}
var $9052383c1c4e5569$var$m = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $9052383c1c4e5569$var$b = function(t, i) {
    if (void 0 === i && (i = []), !t) return !1;
    var e = t.toLowerCase();
    return $9052383c1c4e5569$var$m.concat(i).some((t)=>{
        var i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
}, $9052383c1c4e5569$var$y = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
];
function $9052383c1c4e5569$var$w(t, i) {
    return -1 !== t.indexOf(i);
}
var $9052383c1c4e5569$var$x = function(t) {
    return t.trim();
}, $9052383c1c4e5569$var$E = function(t) {
    return t.replace(/^\$/, "");
};
var $9052383c1c4e5569$var$S = Array.isArray, $9052383c1c4e5569$var$k = Object.prototype, $9052383c1c4e5569$var$P = $9052383c1c4e5569$var$k.hasOwnProperty, $9052383c1c4e5569$var$T = $9052383c1c4e5569$var$k.toString, $9052383c1c4e5569$var$I = $9052383c1c4e5569$var$S || function(t) {
    return "[object Array]" === $9052383c1c4e5569$var$T.call(t);
}, $9052383c1c4e5569$var$C = (t)=>"function" == typeof t, $9052383c1c4e5569$var$R = (t)=>t === Object(t) && !$9052383c1c4e5569$var$I(t), $9052383c1c4e5569$var$F = (t)=>{
    if ($9052383c1c4e5569$var$R(t)) {
        for(var i in t)if ($9052383c1c4e5569$var$P.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, $9052383c1c4e5569$var$O = (t)=>void 0 === t, $9052383c1c4e5569$var$M = (t)=>"[object String]" == $9052383c1c4e5569$var$T.call(t), $9052383c1c4e5569$var$A = (t)=>$9052383c1c4e5569$var$M(t) && 0 === t.trim().length, $9052383c1c4e5569$var$j = (t)=>null === t, $9052383c1c4e5569$var$D = (t)=>$9052383c1c4e5569$var$O(t) || $9052383c1c4e5569$var$j(t), $9052383c1c4e5569$var$L = (t)=>"[object Number]" == $9052383c1c4e5569$var$T.call(t) && t == t, $9052383c1c4e5569$var$N = (t)=>$9052383c1c4e5569$var$L(t) && t > 0, $9052383c1c4e5569$var$U = (t)=>"[object Boolean]" === $9052383c1c4e5569$var$T.call(t), $9052383c1c4e5569$var$z = (t)=>t instanceof FormData, $9052383c1c4e5569$var$H = (t)=>$9052383c1c4e5569$var$w($9052383c1c4e5569$var$y, t);
function $9052383c1c4e5569$var$B(t) {
    return null === t || "object" != typeof t;
}
function $9052383c1c4e5569$var$q(t, i) {
    return Object.prototype.toString.call(t) === "[object " + i + "]";
}
function $9052383c1c4e5569$var$W(t) {
    return !$9052383c1c4e5569$var$O(Event) && function(t, i) {
        try {
            return t instanceof i;
        } catch (t) {
            return !1;
        }
    }(t, Event);
}
var $9052383c1c4e5569$var$G = [
    !0,
    "true",
    1,
    "1",
    "yes"
], $9052383c1c4e5569$var$V = (t)=>$9052383c1c4e5569$var$w($9052383c1c4e5569$var$G, t), $9052383c1c4e5569$var$J = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function $9052383c1c4e5569$var$K(t, i, e, r, s) {
    return i > e && (r.warn("min cannot be greater than max."), i = e), $9052383c1c4e5569$var$L(t) ? t > e ? (r.warn(" cannot be  greater than max: " + e + ". Using max value instead."), e) : t < i ? (r.warn(" cannot be less than min: " + i + ". Using min value instead."), i) : t : (r.warn(" must be a number. using max or fallback. max: " + e + ", fallback: " + s), $9052383c1c4e5569$var$K(s || e, i, e, r));
}
class $9052383c1c4e5569$var$Y {
    constructor(t){
        this.t = {}, this.i = t.i, this.o = $9052383c1c4e5569$var$K(t.bucketSize, 0, 100, t.h), this.m = $9052383c1c4e5569$var$K(t.refillRate, 0, this.o, t.h), this.$ = $9052383c1c4e5569$var$K(t.refillInterval, 0, 864e5, t.h);
    }
    S(t, i) {
        var e = i - t.lastAccess, r = Math.floor(e / this.$);
        if (r > 0) {
            var s = r * this.m;
            t.tokens = Math.min(t.tokens + s, this.o), t.lastAccess = t.lastAccess + r * this.$;
        }
    }
    consumeRateLimit(t) {
        var i, e = Date.now(), r = String(t), s = this.t[r];
        return s ? this.S(s, e) : (s = {
            tokens: this.o,
            lastAccess: e
        }, this.t[r] = s), 0 === s.tokens || (s.tokens--, 0 === s.tokens && (null == (i = this.i) || i.call(this, t)), 0 === s.tokens);
    }
    stop() {
        this.t = {};
    }
}
var $9052383c1c4e5569$var$X = "Mobile", $9052383c1c4e5569$var$Q = "iOS", $9052383c1c4e5569$var$Z = "Android", $9052383c1c4e5569$var$tt = "Tablet", $9052383c1c4e5569$var$it = $9052383c1c4e5569$var$Z + " " + $9052383c1c4e5569$var$tt, $9052383c1c4e5569$var$et = "iPad", $9052383c1c4e5569$var$rt = "Apple", $9052383c1c4e5569$var$st = $9052383c1c4e5569$var$rt + " Watch", $9052383c1c4e5569$var$nt = "Safari", $9052383c1c4e5569$var$ot = "BlackBerry", $9052383c1c4e5569$var$at = "Samsung", $9052383c1c4e5569$var$lt = $9052383c1c4e5569$var$at + "Browser", $9052383c1c4e5569$var$ut = $9052383c1c4e5569$var$at + " Internet", $9052383c1c4e5569$var$ht = "Chrome", $9052383c1c4e5569$var$dt = $9052383c1c4e5569$var$ht + " OS", $9052383c1c4e5569$var$vt = $9052383c1c4e5569$var$ht + " " + $9052383c1c4e5569$var$Q, $9052383c1c4e5569$var$ct = "Internet Explorer", $9052383c1c4e5569$var$ft = $9052383c1c4e5569$var$ct + " " + $9052383c1c4e5569$var$X, $9052383c1c4e5569$var$pt = "Opera", $9052383c1c4e5569$var$gt = $9052383c1c4e5569$var$pt + " Mini", $9052383c1c4e5569$var$_t = "Edge", $9052383c1c4e5569$var$mt = "Microsoft " + $9052383c1c4e5569$var$_t, $9052383c1c4e5569$var$bt = "Firefox", $9052383c1c4e5569$var$yt = $9052383c1c4e5569$var$bt + " " + $9052383c1c4e5569$var$Q, $9052383c1c4e5569$var$wt = "Nintendo", $9052383c1c4e5569$var$xt = "PlayStation", $9052383c1c4e5569$var$Et = "Xbox", $9052383c1c4e5569$var$$t = $9052383c1c4e5569$var$Z + " " + $9052383c1c4e5569$var$X, $9052383c1c4e5569$var$St = $9052383c1c4e5569$var$X + " " + $9052383c1c4e5569$var$nt, $9052383c1c4e5569$var$kt = "Windows", $9052383c1c4e5569$var$Pt = $9052383c1c4e5569$var$kt + " Phone", $9052383c1c4e5569$var$Tt = "Nokia", $9052383c1c4e5569$var$It = "Ouya", $9052383c1c4e5569$var$Ct = "Generic", $9052383c1c4e5569$var$Rt = $9052383c1c4e5569$var$Ct + " " + $9052383c1c4e5569$var$X.toLowerCase(), $9052383c1c4e5569$var$Ft = $9052383c1c4e5569$var$Ct + " " + $9052383c1c4e5569$var$tt.toLowerCase(), $9052383c1c4e5569$var$Ot = "Konqueror", $9052383c1c4e5569$var$Mt = "(\\d+(\\.\\d+)?)", $9052383c1c4e5569$var$At = new RegExp("Version/" + $9052383c1c4e5569$var$Mt), $9052383c1c4e5569$var$jt = new RegExp($9052383c1c4e5569$var$Et, "i"), $9052383c1c4e5569$var$Dt = new RegExp($9052383c1c4e5569$var$xt + " \\w+", "i"), $9052383c1c4e5569$var$Lt = new RegExp($9052383c1c4e5569$var$wt + " \\w+", "i"), $9052383c1c4e5569$var$Nt = new RegExp($9052383c1c4e5569$var$ot + "|PlayBook|BB10", "i"), $9052383c1c4e5569$var$Ut = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $9052383c1c4e5569$var$zt, $9052383c1c4e5569$var$Ht, $9052383c1c4e5569$var$Bt, $9052383c1c4e5569$var$qt = (t, i)=>i && $9052383c1c4e5569$var$w(i, $9052383c1c4e5569$var$rt) || function(t) {
        return $9052383c1c4e5569$var$w(t, $9052383c1c4e5569$var$nt) && !$9052383c1c4e5569$var$w(t, $9052383c1c4e5569$var$ht) && !$9052383c1c4e5569$var$w(t, $9052383c1c4e5569$var$Z);
    }(t), $9052383c1c4e5569$var$Wt = function(t, i) {
    return i = i || "", $9052383c1c4e5569$var$w(t, " OPR/") && $9052383c1c4e5569$var$w(t, "Mini") ? $9052383c1c4e5569$var$gt : $9052383c1c4e5569$var$w(t, " OPR/") ? $9052383c1c4e5569$var$pt : $9052383c1c4e5569$var$Nt.test(t) ? $9052383c1c4e5569$var$ot : $9052383c1c4e5569$var$w(t, "IE" + $9052383c1c4e5569$var$X) || $9052383c1c4e5569$var$w(t, "WPDesktop") ? $9052383c1c4e5569$var$ft : $9052383c1c4e5569$var$w(t, $9052383c1c4e5569$var$lt) ? $9052383c1c4e5569$var$ut : $9052383c1c4e5569$var$w(t, $9052383c1c4e5569$var$_t) || $9052383c1c4e5569$var$w(t, "Edg/") ? $9052383c1c4e5569$var$mt : $9052383c1c4e5569$var$w(t, "FBIOS") ? "Facebook " + $9052383c1c4e5569$var$X : $9052383c1c4e5569$var$w(t, "UCWEB") || $9052383c1c4e5569$var$w(t, "UCBrowser") ? "UC Browser" : $9052383c1c4e5569$var$w(t, "CriOS") ? $9052383c1c4e5569$var$vt : $9052383c1c4e5569$var$w(t, "CrMo") || $9052383c1c4e5569$var$w(t, $9052383c1c4e5569$var$ht) ? $9052383c1c4e5569$var$ht : $9052383c1c4e5569$var$w(t, $9052383c1c4e5569$var$Z) && $9052383c1c4e5569$var$w(t, $9052383c1c4e5569$var$nt) ? $9052383c1c4e5569$var$$t : $9052383c1c4e5569$var$w(t, "FxiOS") ? $9052383c1c4e5569$var$yt : $9052383c1c4e5569$var$w(t.toLowerCase(), $9052383c1c4e5569$var$Ot.toLowerCase()) ? $9052383c1c4e5569$var$Ot : $9052383c1c4e5569$var$qt(t, i) ? $9052383c1c4e5569$var$w(t, $9052383c1c4e5569$var$X) ? $9052383c1c4e5569$var$St : $9052383c1c4e5569$var$nt : $9052383c1c4e5569$var$w(t, $9052383c1c4e5569$var$bt) ? $9052383c1c4e5569$var$bt : $9052383c1c4e5569$var$w(t, "MSIE") || $9052383c1c4e5569$var$w(t, "Trident/") ? $9052383c1c4e5569$var$ct : $9052383c1c4e5569$var$w(t, "Gecko") ? $9052383c1c4e5569$var$bt : "";
}, $9052383c1c4e5569$var$Gt = {
    [$9052383c1c4e5569$var$ft]: [
        new RegExp("rv:" + $9052383c1c4e5569$var$Mt)
    ],
    [$9052383c1c4e5569$var$mt]: [
        new RegExp($9052383c1c4e5569$var$_t + "?\\/" + $9052383c1c4e5569$var$Mt)
    ],
    [$9052383c1c4e5569$var$ht]: [
        new RegExp("(" + $9052383c1c4e5569$var$ht + "|CrMo)\\/" + $9052383c1c4e5569$var$Mt)
    ],
    [$9052383c1c4e5569$var$vt]: [
        new RegExp("CriOS\\/" + $9052383c1c4e5569$var$Mt)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $9052383c1c4e5569$var$Mt)
    ],
    [$9052383c1c4e5569$var$nt]: [
        $9052383c1c4e5569$var$At
    ],
    [$9052383c1c4e5569$var$St]: [
        $9052383c1c4e5569$var$At
    ],
    [$9052383c1c4e5569$var$pt]: [
        new RegExp("(Opera|OPR)\\/" + $9052383c1c4e5569$var$Mt)
    ],
    [$9052383c1c4e5569$var$bt]: [
        new RegExp($9052383c1c4e5569$var$bt + "\\/" + $9052383c1c4e5569$var$Mt)
    ],
    [$9052383c1c4e5569$var$yt]: [
        new RegExp("FxiOS\\/" + $9052383c1c4e5569$var$Mt)
    ],
    [$9052383c1c4e5569$var$Ot]: [
        new RegExp("Konqueror[:/]?" + $9052383c1c4e5569$var$Mt, "i")
    ],
    [$9052383c1c4e5569$var$ot]: [
        new RegExp($9052383c1c4e5569$var$ot + " " + $9052383c1c4e5569$var$Mt),
        $9052383c1c4e5569$var$At
    ],
    [$9052383c1c4e5569$var$$t]: [
        new RegExp("android\\s" + $9052383c1c4e5569$var$Mt, "i")
    ],
    [$9052383c1c4e5569$var$ut]: [
        new RegExp($9052383c1c4e5569$var$lt + "\\/" + $9052383c1c4e5569$var$Mt)
    ],
    [$9052383c1c4e5569$var$ct]: [
        new RegExp("(rv:|MSIE )" + $9052383c1c4e5569$var$Mt)
    ],
    Mozilla: [
        new RegExp("rv:" + $9052383c1c4e5569$var$Mt)
    ]
}, $9052383c1c4e5569$var$Vt = function(t, i) {
    var e = $9052383c1c4e5569$var$Wt(t, i), r = $9052383c1c4e5569$var$Gt[e];
    if ($9052383c1c4e5569$var$O(r)) return null;
    for(var s = 0; s < r.length; s++){
        var n = r[s], o = t.match(n);
        if (o) return parseFloat(o[o.length - 2]);
    }
    return null;
}, $9052383c1c4e5569$var$Jt = [
    [
        new RegExp($9052383c1c4e5569$var$Et + "; " + $9052383c1c4e5569$var$Et + " (.*?)[);]", "i"),
        (t)=>[
                $9052383c1c4e5569$var$Et,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($9052383c1c4e5569$var$wt, "i"),
        [
            $9052383c1c4e5569$var$wt,
            ""
        ]
    ],
    [
        new RegExp($9052383c1c4e5569$var$xt, "i"),
        [
            $9052383c1c4e5569$var$xt,
            ""
        ]
    ],
    [
        $9052383c1c4e5569$var$Nt,
        [
            $9052383c1c4e5569$var$ot,
            ""
        ]
    ],
    [
        new RegExp($9052383c1c4e5569$var$kt, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                $9052383c1c4e5569$var$Pt,
                ""
            ];
            if (new RegExp($9052383c1c4e5569$var$X).test(i) && !/IEMobile\b/.test(i)) return [
                $9052383c1c4e5569$var$kt + " " + $9052383c1c4e5569$var$X,
                ""
            ];
            var e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                var r = e[1], s = $9052383c1c4e5569$var$Ut[r] || "";
                return /arm/i.test(i) && (s = "RT"), [
                    $9052383c1c4e5569$var$kt,
                    s
                ];
            }
            return [
                $9052383c1c4e5569$var$kt,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>{
            if (t && t[3]) {
                var i = [
                    t[3],
                    t[4],
                    t[5] || "0"
                ];
                return [
                    $9052383c1c4e5569$var$Q,
                    i.join(".")
                ];
            }
            return [
                $9052383c1c4e5569$var$Q,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var i = "";
            return t && t.length >= 3 && (i = $9052383c1c4e5569$var$O(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(" + $9052383c1c4e5569$var$Z + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $9052383c1c4e5569$var$Z + ")", "i"),
        (t)=>{
            if (t && t[2]) {
                var i = [
                    t[2],
                    t[3],
                    t[4] || "0"
                ];
                return [
                    $9052383c1c4e5569$var$Z,
                    i.join(".")
                ];
            }
            return [
                $9052383c1c4e5569$var$Z,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var i = [
                "Mac OS X",
                ""
            ];
            if (t && t[1]) {
                var e = [
                    t[1],
                    t[2],
                    t[3] || "0"
                ];
                i[1] = e.join(".");
            }
            return i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $9052383c1c4e5569$var$dt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $9052383c1c4e5569$var$Kt = function(t) {
    return $9052383c1c4e5569$var$Lt.test(t) ? $9052383c1c4e5569$var$wt : $9052383c1c4e5569$var$Dt.test(t) ? $9052383c1c4e5569$var$xt : $9052383c1c4e5569$var$jt.test(t) ? $9052383c1c4e5569$var$Et : new RegExp($9052383c1c4e5569$var$It, "i").test(t) ? $9052383c1c4e5569$var$It : new RegExp("(" + $9052383c1c4e5569$var$Pt + "|WPDesktop)", "i").test(t) ? $9052383c1c4e5569$var$Pt : /iPad/.test(t) ? $9052383c1c4e5569$var$et : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $9052383c1c4e5569$var$st : $9052383c1c4e5569$var$Nt.test(t) ? $9052383c1c4e5569$var$ot : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($9052383c1c4e5569$var$Tt, "i").test(t) ? $9052383c1c4e5569$var$Tt : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? new RegExp($9052383c1c4e5569$var$X).test(t) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) || /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $9052383c1c4e5569$var$Z : $9052383c1c4e5569$var$it : new RegExp("(pda|" + $9052383c1c4e5569$var$X + ")", "i").test(t) ? $9052383c1c4e5569$var$Rt : new RegExp($9052383c1c4e5569$var$tt, "i").test(t) && !new RegExp($9052383c1c4e5569$var$tt + " pc", "i").test(t) ? $9052383c1c4e5569$var$Ft : "";
}, $9052383c1c4e5569$var$Yt = (t)=>t instanceof Error;
function $9052383c1c4e5569$var$Xt(t) {
    var i = globalThis._posthogChunkIds;
    if (i) {
        var e = Object.keys(i);
        return $9052383c1c4e5569$var$Bt && e.length === $9052383c1c4e5569$var$Ht || ($9052383c1c4e5569$var$Ht = e.length, $9052383c1c4e5569$var$Bt = e.reduce((e, r)=>{
            $9052383c1c4e5569$var$zt || ($9052383c1c4e5569$var$zt = {});
            var s = $9052383c1c4e5569$var$zt[r];
            if (s) e[s[0]] = s[1];
            else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                var a = n[o], l = null == a ? void 0 : a.filename, u = i[r];
                if (l && u) {
                    e[l] = u, $9052383c1c4e5569$var$zt[r] = [
                        l,
                        u
                    ];
                    break;
                }
            }
            return e;
        }, {})), $9052383c1c4e5569$var$Bt;
    }
}
class $9052383c1c4e5569$var$Qt {
    constructor(t, i, e){
        void 0 === e && (e = []), this.coercers = t, this.stackParser = i, this.modifiers = e;
    }
    buildFromUnknown(t, i) {
        void 0 === i && (i = {});
        var e = i && i.mechanism || {
            handled: !0,
            type: "generic"
        }, r = this.buildCoercingContext(e, i, 0).apply(t), s = this.buildParsingContext(), n = this.parseStacktrace(r, s);
        return {
            $exception_list: this.convertToExceptionList(n, e),
            $exception_level: "error"
        };
    }
    modifyFrames(t) {
        var i = this;
        return $9052383c1c4e5569$var$p(function*() {
            for (var e of t)e.stacktrace && e.stacktrace.frames && $9052383c1c4e5569$var$I(e.stacktrace.frames) && (e.stacktrace.frames = yield i.applyModifiers(e.stacktrace.frames));
            return t;
        })();
    }
    coerceFallback(t) {
        var i;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null == (i = t.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, i) {
        var e, r;
        return null != t.cause && (e = this.parseStacktrace(t.cause, i)), "" != t.stack && null != t.stack && (r = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? 1 : 0), i.chunkIdMap)), $9052383c1c4e5569$var$g({}, t, {
            cause: e,
            stack: r
        });
    }
    applyChunkIds(t, i) {
        return t.map((t)=>(t.filename && i && (t.chunk_id = i[t.filename]), t));
    }
    applyCoercers(t, i) {
        for (var e of this.coercers)if (e.match(t)) return e.coerce(t, i);
        return this.coerceFallback(i);
    }
    applyModifiers(t) {
        var i = this;
        return $9052383c1c4e5569$var$p(function*() {
            var e = t;
            for (var r of i.modifiers)e = yield r(e);
            return e;
        })();
    }
    convertToExceptionList(t, i) {
        var e, r, s, n = {
            type: t.type,
            value: t.value,
            mechanism: {
                type: null !== (e = i.type) && void 0 !== e ? e : "generic",
                handled: null === (r = i.handled) || void 0 === r || r,
                synthetic: null !== (s = t.synthetic) && void 0 !== s && s
            }
        };
        t.stack && (n.stacktrace = {
            type: "raw",
            frames: t.stack
        });
        var o = [
            n
        ];
        return null != t.cause && o.push(...this.convertToExceptionList(t.cause, $9052383c1c4e5569$var$g({}, i, {
            handled: !0
        }))), o;
    }
    buildParsingContext() {
        return {
            chunkIdMap: $9052383c1c4e5569$var$Xt(this.stackParser)
        };
    }
    buildCoercingContext(t, i, e) {
        void 0 === e && (e = 0);
        var r = (e, r)=>{
            if (r <= 4) {
                var s = this.buildCoercingContext(t, i, r);
                return this.applyCoercers(e, s);
            }
        };
        return $9052383c1c4e5569$var$g({}, i, {
            syntheticException: 0 == e ? i.syntheticException : void 0,
            mechanism: t,
            apply: (t)=>r(t, e),
            next: (t)=>r(t, e + 1)
        });
    }
}
var $9052383c1c4e5569$var$Zt = "?";
function $9052383c1c4e5569$var$ti(t, i, e, r, s) {
    var n = {
        platform: t,
        filename: i,
        function: "<anonymous>" === e ? $9052383c1c4e5569$var$Zt : e,
        in_app: !0
    };
    return $9052383c1c4e5569$var$O(r) || (n.lineno = r), $9052383c1c4e5569$var$O(s) || (n.colno = s), n;
}
var $9052383c1c4e5569$var$ii = (t, i)=>{
    var e = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return e || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $9052383c1c4e5569$var$Zt,
        e ? "safari-extension:" + i : "safari-web-extension:" + i
    ] : [
        t,
        i
    ];
}, $9052383c1c4e5569$var$ei = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $9052383c1c4e5569$var$ri = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $9052383c1c4e5569$var$si = /\((\S*)(?::(\d+))(?::(\d+))\)/, $9052383c1c4e5569$var$ni = (t, i)=>{
    var e = $9052383c1c4e5569$var$ei.exec(t);
    if (e) {
        var [, r, s, n] = e;
        return $9052383c1c4e5569$var$ti(i, r, $9052383c1c4e5569$var$Zt, +s, +n);
    }
    var o = $9052383c1c4e5569$var$ri.exec(t);
    if (o) {
        if (o[2] && 0 === o[2].indexOf("eval")) {
            var a = $9052383c1c4e5569$var$si.exec(o[2]);
            a && (o[2] = a[1], o[3] = a[2], o[4] = a[3]);
        }
        var [l, u] = $9052383c1c4e5569$var$ii(o[1] || $9052383c1c4e5569$var$Zt, o[2]);
        return $9052383c1c4e5569$var$ti(i, u, l, o[3] ? +o[3] : void 0, o[4] ? +o[4] : void 0);
    }
}, $9052383c1c4e5569$var$oi = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $9052383c1c4e5569$var$ai = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $9052383c1c4e5569$var$li = (t, i)=>{
    var e = $9052383c1c4e5569$var$oi.exec(t);
    if (e) {
        if (e[3] && e[3].indexOf(" > eval") > -1) {
            var r = $9052383c1c4e5569$var$ai.exec(e[3]);
            r && (e[1] = e[1] || "eval", e[3] = r[1], e[4] = r[2], e[5] = "");
        }
        var s = e[3], n = e[1] || $9052383c1c4e5569$var$Zt;
        return [n, s] = $9052383c1c4e5569$var$ii(n, s), $9052383c1c4e5569$var$ti(i, s, n, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
    }
}, $9052383c1c4e5569$var$ui = /\(error: (.*)\)/, $9052383c1c4e5569$var$hi = 50;
function $9052383c1c4e5569$var$di() {
    return function(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        return function(i, r) {
            void 0 === r && (r = 0);
            for(var s = [], n = i.split("\n"), o = r; o < n.length; o++){
                var a = n[o];
                if (!(a.length > 1024)) {
                    var l = $9052383c1c4e5569$var$ui.test(a) ? a.replace($9052383c1c4e5569$var$ui, "$1") : a;
                    if (!l.match(/\S*Error: /)) {
                        for (var u of e){
                            var h = u(l, t);
                            if (h) {
                                s.push(h);
                                break;
                            }
                        }
                        if (s.length >= $9052383c1c4e5569$var$hi) break;
                    }
                }
            }
            return function(t) {
                if (!t.length) return [];
                var i = Array.from(t);
                return i.reverse(), i.slice(0, $9052383c1c4e5569$var$hi).map((t)=>{
                    var e;
                    return $9052383c1c4e5569$var$g({}, t, {
                        filename: t.filename || (e = i, e[e.length - 1] || {}).filename,
                        function: t.function || $9052383c1c4e5569$var$Zt
                    });
                });
            }(s);
        };
    }("web:javascript", $9052383c1c4e5569$var$ni, $9052383c1c4e5569$var$li);
}
class $9052383c1c4e5569$var$vi {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, i) {
        var e = $9052383c1c4e5569$var$M(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: e ? t.stack : void 0,
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        var i = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? i + ": " + t.message : i;
    }
    isDOMException(t) {
        return $9052383c1c4e5569$var$q(t, "DOMException");
    }
    isDOMError(t) {
        return $9052383c1c4e5569$var$q(t, "DOMError");
    }
}
class $9052383c1c4e5569$var$ci {
    match(t) {
        return ((t)=>t instanceof Error)(t);
    }
    coerce(t, i) {
        return {
            type: this.getType(t),
            value: this.getMessage(t, i),
            stack: this.getStack(t),
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, i) {
        var e = t.message;
        return e.error && "string" == typeof e.error.message ? String(e.error.message) : String(e);
    }
    getStack(t) {
        return t.stacktrace || t.stack || void 0;
    }
}
class $9052383c1c4e5569$var$fi {
    constructor(){}
    match(t) {
        return $9052383c1c4e5569$var$q(t, "ErrorEvent") && null != t.error;
    }
    coerce(t, i) {
        var e, r = i.apply(t.error);
        return r || {
            type: "ErrorEvent",
            value: t.message,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
var $9052383c1c4e5569$var$pi = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class $9052383c1c4e5569$var$gi {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, i) {
        var e, [r, s] = this.getInfos(t);
        return {
            type: null != r ? r : "Error",
            value: null != s ? s : t,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        var i = "Error", e = t, r = t.match($9052383c1c4e5569$var$pi);
        return r && (i = r[1], e = r[2]), [
            i,
            e
        ];
    }
}
var $9052383c1c4e5569$var$_i = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $9052383c1c4e5569$var$mi(t, i) {
    void 0 === i && (i = 40);
    var e = Object.keys(t);
    if (e.sort(), !e.length) return "[object has no keys]";
    for(var r = e.length; r > 0; r--){
        var s = e.slice(0, r).join(", ");
        if (!(s.length > i)) return r === e.length || s.length <= i ? s : s.slice(0, i) + "...";
    }
    return "";
}
class $9052383c1c4e5569$var$bi {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, i) {
        var e, r = this.getErrorPropertyFromObject(t);
        return r ? i.apply(r) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        return $9052383c1c4e5569$var$W(t) ? t.constructor.name : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            var i = "'" + t.name + "' captured as exception";
            return "message" in t && "string" == typeof t.message && (i += " with message: '" + t.message + "'"), i;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        var e = this.getObjectClassName(t);
        return (e && "Object" !== e ? "'" + e + "'" : "Object") + " captured as exception with keys: " + $9052383c1c4e5569$var$mi(t);
    }
    isSeverityLevel(t) {
        return $9052383c1c4e5569$var$M(t) && !$9052383c1c4e5569$var$A(t) && $9052383c1c4e5569$var$_i.indexOf(t) >= 0;
    }
    getErrorPropertyFromObject(t) {
        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i)) {
            var e = t[i];
            if ($9052383c1c4e5569$var$Yt(e)) return e;
        }
    }
    getObjectClassName(t) {
        try {
            var i = Object.getPrototypeOf(t);
            return i ? i.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}
class $9052383c1c4e5569$var$yi {
    match(t) {
        return $9052383c1c4e5569$var$W(t);
    }
    coerce(t, i) {
        var e, r = t.constructor.name;
        return {
            type: r,
            value: r + " captured as exception with keys: " + $9052383c1c4e5569$var$mi(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class $9052383c1c4e5569$var$wi {
    match(t) {
        return $9052383c1c4e5569$var$B(t);
    }
    coerce(t, i) {
        var e;
        return {
            type: "Error",
            value: "Primitive value captured as exception: " + String(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class $9052383c1c4e5569$var$xi {
    match(t) {
        return $9052383c1c4e5569$var$q(t, "PromiseRejectionEvent");
    }
    coerce(t, i) {
        var e, r = this.getUnhandledRejectionReason(t);
        return $9052383c1c4e5569$var$B(r) ? {
            type: "UnhandledRejection",
            value: "Non-Error promise rejection captured with value: " + String(r),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        } : i.apply(r);
    }
    getUnhandledRejectionReason(t) {
        if ($9052383c1c4e5569$var$B(t)) return t;
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
}
var $9052383c1c4e5569$var$Ei = function(i, e) {
    var { debugEnabled: r } = void 0 === e ? {} : e, s = {
        k: function(e) {
            if ($9052383c1c4e5569$var$t && ($9052383c1c4e5569$var$c.DEBUG || $9052383c1c4e5569$var$v.POSTHOG_DEBUG || r) && !$9052383c1c4e5569$var$O($9052383c1c4e5569$var$t.console) && $9052383c1c4e5569$var$t.console) {
                for(var s = ("__rrweb_original__" in $9052383c1c4e5569$var$t.console[e]) ? $9052383c1c4e5569$var$t.console[e].__rrweb_original__ : $9052383c1c4e5569$var$t.console[e], n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)o[a - 1] = arguments[a];
                s(i, ...o);
            }
        },
        info: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("log", ...i);
        },
        warn: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("warn", ...i);
        },
        error: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("error", ...i);
        },
        critical: function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            console.error(i, ...e);
        },
        uninitializedWarning: (t)=>{
            s.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (t, e)=>$9052383c1c4e5569$var$Ei(i + " " + t, e)
    };
    return s;
}, $9052383c1c4e5569$var$$i = $9052383c1c4e5569$var$Ei("[PostHog.js]"), $9052383c1c4e5569$var$Si = $9052383c1c4e5569$var$$i.createLogger, $9052383c1c4e5569$var$ki = $9052383c1c4e5569$var$Si("[ExternalScriptsLoader]"), $9052383c1c4e5569$var$Pi = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return $9052383c1c4e5569$var$ki.warn(i + " was requested but loading of external scripts is disabled."), e("Loading of external scripts is disabled");
    var r = null == $9052383c1c4e5569$var$o ? void 0 : $9052383c1c4e5569$var$o.querySelectorAll("script");
    if (r) {
        for(var s, n = function() {
            if (r[a].src === i) {
                var t = r[a];
                return t.__posthog_loading_callback_fired ? {
                    v: e()
                } : (t.addEventListener("load", (i)=>{
                    t.__posthog_loading_callback_fired = !0, e(void 0, i);
                }), t.onerror = (t)=>e(t), {
                    v: void 0
                });
            }
        }, a = 0; a < r.length; a++)if (s = n()) return s.v;
    }
    var l = ()=>{
        if (!$9052383c1c4e5569$var$o) return e("document not found");
        var r = $9052383c1c4e5569$var$o.createElement("script");
        if (r.type = "text/javascript", r.crossOrigin = "anonymous", r.src = i, r.onload = (t)=>{
            r.__posthog_loading_callback_fired = !0, e(void 0, t);
        }, r.onerror = (t)=>e(t), t.config.prepare_external_dependency_script && (r = t.config.prepare_external_dependency_script(r)), !r) return e("prepare_external_dependency_script returned null");
        if ("head" === t.config.external_scripts_inject_target) $9052383c1c4e5569$var$o.head.appendChild(r);
        else {
            var s, n = $9052383c1c4e5569$var$o.querySelectorAll("body > script");
            if (n.length > 0) null == (s = n[0].parentNode) || s.insertBefore(r, n[0]);
            else $9052383c1c4e5569$var$o.body.appendChild(r);
        }
    };
    null != $9052383c1c4e5569$var$o && $9052383c1c4e5569$var$o.body ? l() : null == $9052383c1c4e5569$var$o || $9052383c1c4e5569$var$o.addEventListener("DOMContentLoaded", l);
};
$9052383c1c4e5569$var$v.__PosthogExtensions__ = $9052383c1c4e5569$var$v.__PosthogExtensions__ || {}, $9052383c1c4e5569$var$v.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    var r = "/static/" + i + ".js?v=" + t.version;
    if ("remote-config" === i && (r = "/array/" + t.config.token + "/config.js"), "toolbar" === i) {
        var s = 3e5;
        r = r + "&t=" + Math.floor(Date.now() / s) * s;
    }
    var n = t.requestRouter.endpointFor("assets", r);
    $9052383c1c4e5569$var$Pi(t, n, e);
}, $9052383c1c4e5569$var$v.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    var r = t.requestRouter.endpointFor("api", i);
    $9052383c1c4e5569$var$Pi(t, r, e);
};
var $9052383c1c4e5569$var$Ti = {};
function $9052383c1c4e5569$var$Ii(t, i, e) {
    if ($9052383c1c4e5569$var$I(t)) {
        if ($9052383c1c4e5569$var$r && t.forEach === $9052383c1c4e5569$var$r) t.forEach(i, e);
        else if ("length" in t && t.length === +t.length) {
            for(var s = 0, n = t.length; s < n; s++)if (s in t && i.call(e, t[s], s) === $9052383c1c4e5569$var$Ti) return;
        }
    }
}
function $9052383c1c4e5569$var$Ci(t, i, e) {
    if (!$9052383c1c4e5569$var$D(t)) {
        if ($9052383c1c4e5569$var$I(t)) return $9052383c1c4e5569$var$Ii(t, i, e);
        if ($9052383c1c4e5569$var$z(t)) {
            for (var r of t.entries())if (i.call(e, r[1], r[0]) === $9052383c1c4e5569$var$Ti) return;
        } else for(var s in t)if ($9052383c1c4e5569$var$P.call(t, s) && i.call(e, t[s], s) === $9052383c1c4e5569$var$Ti) return;
    }
}
var $9052383c1c4e5569$var$Ri = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $9052383c1c4e5569$var$Ii(e, function(i) {
        for(var e in i)void 0 !== i[e] && (t[e] = i[e]);
    }), t;
}, $9052383c1c4e5569$var$Fi = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $9052383c1c4e5569$var$Ii(e, function(i) {
        $9052383c1c4e5569$var$Ii(i, function(i) {
            t.push(i);
        });
    }), t;
};
function $9052383c1c4e5569$var$Oi(t) {
    for(var i = Object.keys(t), e = i.length, r = new Array(e); e--;)r[e] = [
        i[e],
        t[i[e]]
    ];
    return r;
}
var $9052383c1c4e5569$var$Mi = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $9052383c1c4e5569$var$Ai = function(t) {
    return function() {
        try {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            return t.apply(this, e);
        } catch (t) {
            $9052383c1c4e5569$var$$i.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $9052383c1c4e5569$var$$i.critical(t);
        }
    };
}, $9052383c1c4e5569$var$ji = function(t) {
    var i = {};
    return $9052383c1c4e5569$var$Ci(t, function(t, e) {
        ($9052383c1c4e5569$var$M(t) && t.length > 0 || $9052383c1c4e5569$var$L(t)) && (i[e] = t);
    }), i;
};
function $9052383c1c4e5569$var$Di(t, i) {
    var e, r, s;
    return e = t, r = (t)=>$9052383c1c4e5569$var$M(t) && !$9052383c1c4e5569$var$j(i) ? t.slice(0, i) : t, s = new Set, function t(i, e) {
        var n;
        return i !== Object(i) ? r ? r(i, e) : i : s.has(i) ? void 0 : (s.add(i), $9052383c1c4e5569$var$I(i) ? (n = [], $9052383c1c4e5569$var$Ii(i, (i)=>{
            n.push(t(i));
        })) : (n = {}, $9052383c1c4e5569$var$Ci(i, (i, e)=>{
            s.has(i) || (n[e] = t(i, e));
        })), n);
    }(e);
}
var $9052383c1c4e5569$var$Li = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $9052383c1c4e5569$var$Ni(t) {
    var i = null == t ? void 0 : t.hostname;
    if (!$9052383c1c4e5569$var$M(i)) return !1;
    var e = i.split(".").slice(-2).join(".");
    for (var r of $9052383c1c4e5569$var$Li)if (e === r) return !1;
    return !0;
}
function $9052383c1c4e5569$var$Ui(t, i) {
    for(var e = 0; e < t.length; e++)if (i(t[e])) return t[e];
}
function $9052383c1c4e5569$var$zi(t, i, e, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(i, e, {
        capture: s,
        passive: n
    });
}
var $9052383c1c4e5569$var$Hi = "$people_distinct_id", $9052383c1c4e5569$var$Bi = "__alias", $9052383c1c4e5569$var$qi = "__timers", $9052383c1c4e5569$var$Wi = "$autocapture_disabled_server_side", $9052383c1c4e5569$var$Gi = "$heatmaps_enabled_server_side", $9052383c1c4e5569$var$Vi = "$exception_capture_enabled_server_side", $9052383c1c4e5569$var$Ji = "$error_tracking_suppression_rules", $9052383c1c4e5569$var$Ki = "$error_tracking_capture_extension_exceptions", $9052383c1c4e5569$var$Yi = "$web_vitals_enabled_server_side", $9052383c1c4e5569$var$Xi = "$dead_clicks_enabled_server_side", $9052383c1c4e5569$var$Qi = "$product_tours_enabled_server_side", $9052383c1c4e5569$var$Zi = "$web_vitals_allowed_metrics", $9052383c1c4e5569$var$te = "$session_recording_remote_config", $9052383c1c4e5569$var$ie = "$sesid", $9052383c1c4e5569$var$ee = "$session_is_sampled", $9052383c1c4e5569$var$re = "$enabled_feature_flags", $9052383c1c4e5569$var$se = "$early_access_features", $9052383c1c4e5569$var$ne = "$feature_flag_details", $9052383c1c4e5569$var$oe = "$stored_person_properties", $9052383c1c4e5569$var$ae = "$stored_group_properties", $9052383c1c4e5569$var$le = "$surveys", $9052383c1c4e5569$var$ue = "$flag_call_reported", $9052383c1c4e5569$var$he = "$user_state", $9052383c1c4e5569$var$de = "$client_session_props", $9052383c1c4e5569$var$ve = "$capture_rate_limit", $9052383c1c4e5569$var$ce = "$initial_campaign_params", $9052383c1c4e5569$var$fe = "$initial_referrer_info", $9052383c1c4e5569$var$pe = "$initial_person_info", $9052383c1c4e5569$var$ge = "$epp", $9052383c1c4e5569$var$_e = "__POSTHOG_TOOLBAR__", $9052383c1c4e5569$var$me = "$posthog_cookieless", $9052383c1c4e5569$var$be = [
    $9052383c1c4e5569$var$Hi,
    $9052383c1c4e5569$var$Bi,
    "__cmpns",
    $9052383c1c4e5569$var$qi,
    "$session_recording_enabled_server_side",
    $9052383c1c4e5569$var$Gi,
    $9052383c1c4e5569$var$ie,
    $9052383c1c4e5569$var$re,
    $9052383c1c4e5569$var$Ji,
    $9052383c1c4e5569$var$he,
    $9052383c1c4e5569$var$se,
    $9052383c1c4e5569$var$ne,
    $9052383c1c4e5569$var$ae,
    $9052383c1c4e5569$var$oe,
    $9052383c1c4e5569$var$le,
    $9052383c1c4e5569$var$ue,
    $9052383c1c4e5569$var$de,
    $9052383c1c4e5569$var$ve,
    $9052383c1c4e5569$var$ce,
    $9052383c1c4e5569$var$fe,
    $9052383c1c4e5569$var$ge,
    $9052383c1c4e5569$var$pe,
    "$conversations_widget_session_id",
    "$conversations_ticket_id",
    "$conversations_widget_state",
    "$conversations_user_traits"
];
function $9052383c1c4e5569$var$ye(t) {
    return t instanceof Element && (t.id === $9052383c1c4e5569$var$_e || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $9052383c1c4e5569$var$we(t) {
    return !!t && 1 === t.nodeType;
}
function $9052383c1c4e5569$var$xe(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $9052383c1c4e5569$var$Ee(t) {
    return !!t && 3 === t.nodeType;
}
function $9052383c1c4e5569$var$$e(t) {
    return !!t && 11 === t.nodeType;
}
function $9052383c1c4e5569$var$Se(t) {
    return t ? $9052383c1c4e5569$var$x(t).split(/\s+/) : [];
}
function $9052383c1c4e5569$var$ke(i) {
    var e = null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.location.href;
    return !!(e && i && i.some((t)=>e.match(t)));
}
function $9052383c1c4e5569$var$Pe(t) {
    var i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return $9052383c1c4e5569$var$Se(i);
}
function $9052383c1c4e5569$var$Te(t) {
    return $9052383c1c4e5569$var$D(t) ? null : $9052383c1c4e5569$var$x(t).split(/(\s+)/).filter((t)=>$9052383c1c4e5569$var$Ke(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $9052383c1c4e5569$var$Ie(t) {
    var i = "";
    return $9052383c1c4e5569$var$ze(t) && !$9052383c1c4e5569$var$He(t) && t.childNodes && t.childNodes.length && $9052383c1c4e5569$var$Ci(t.childNodes, function(t) {
        var e;
        $9052383c1c4e5569$var$Ee(t) && t.textContent && (i += null !== (e = $9052383c1c4e5569$var$Te(t.textContent)) && void 0 !== e ? e : "");
    }), $9052383c1c4e5569$var$x(i);
}
function $9052383c1c4e5569$var$Ce(t) {
    var i;
    return $9052383c1c4e5569$var$O(t.target) ? t.srcElement || null : null != (i = t.target) && i.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $9052383c1c4e5569$var$Re = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $9052383c1c4e5569$var$Fe(t, i) {
    if ($9052383c1c4e5569$var$O(i)) return !0;
    var e, r = function(t) {
        if (i.some((i)=>t.matches(i))) return {
            v: !0
        };
    };
    for (var s of t)if (e = r(s)) return e.v;
    return !1;
}
function $9052383c1c4e5569$var$Oe(t) {
    var i = t.parentNode;
    return !(!i || !$9052383c1c4e5569$var$we(i)) && i;
}
var $9052383c1c4e5569$var$Me = [
    "next",
    "previous",
    "prev",
    ">",
    "<"
], $9052383c1c4e5569$var$Ae = 10;
var $9052383c1c4e5569$var$je = [
    ".ph-no-rageclick",
    ".ph-no-capture"
];
function $9052383c1c4e5569$var$De(i, e) {
    if (!$9052383c1c4e5569$var$t || $9052383c1c4e5569$var$Le(i)) return !1;
    var r, s, n;
    $9052383c1c4e5569$var$U(e) ? (r = !!e && $9052383c1c4e5569$var$je, s = void 0) : (r = null !== (n = null == e ? void 0 : e.css_selector_ignorelist) && void 0 !== n ? n : $9052383c1c4e5569$var$je, s = null == e ? void 0 : e.content_ignorelist);
    if (!1 === r) return !1;
    var { targetElementList: o } = $9052383c1c4e5569$var$Ne(i, !1);
    return !function(t, i) {
        if (!1 === t || $9052383c1c4e5569$var$O(t)) return !1;
        var e;
        if (!0 === t) e = $9052383c1c4e5569$var$Me;
        else {
            if (!$9052383c1c4e5569$var$I(t)) return !1;
            if (t.length > $9052383c1c4e5569$var$Ae) return $9052383c1c4e5569$var$$i.error("[PostHog] content_ignorelist array cannot exceed " + $9052383c1c4e5569$var$Ae + " items. Use css_selector_ignorelist for more complex matching."), !1;
            e = t.map((t)=>t.toLowerCase());
        }
        return i.some((t)=>{
            var { safeText: i, ariaLabel: r } = t;
            return e.some((t)=>i.includes(t) || r.includes(t));
        });
    }(s, o.map((t)=>{
        var i;
        return {
            safeText: $9052383c1c4e5569$var$Ie(t).toLowerCase(),
            ariaLabel: (null == (i = t.getAttribute("aria-label")) ? void 0 : i.toLowerCase().trim()) || ""
        };
    })) && !$9052383c1c4e5569$var$Fe(o, r);
}
var $9052383c1c4e5569$var$Le = (t)=>!t || $9052383c1c4e5569$var$xe(t, "html") || !$9052383c1c4e5569$var$we(t), $9052383c1c4e5569$var$Ne = (i, e)=>{
    if (!$9052383c1c4e5569$var$t || $9052383c1c4e5569$var$Le(i)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    for(var r = !1, s = [
        i
    ], n = i; n.parentNode && !$9052383c1c4e5569$var$xe(n, "body");)if ($9052383c1c4e5569$var$$e(n.parentNode)) s.push(n.parentNode.host), n = n.parentNode.host;
    else {
        var o = $9052383c1c4e5569$var$Oe(n);
        if (!o) break;
        if (e || $9052383c1c4e5569$var$Re.indexOf(o.tagName.toLowerCase()) > -1) r = !0;
        else {
            var a = $9052383c1c4e5569$var$t.getComputedStyle(o);
            a && "pointer" === a.getPropertyValue("cursor") && (r = !0);
        }
        s.push(o), n = o;
    }
    return {
        parentIsUsefulElement: r,
        targetElementList: s
    };
};
function $9052383c1c4e5569$var$Ue(i, e, r, s, n) {
    var o, a, l, u;
    if (void 0 === r && (r = void 0), !$9052383c1c4e5569$var$t || $9052383c1c4e5569$var$Le(i)) return !1;
    if (null != (o = r) && o.url_allowlist && !$9052383c1c4e5569$var$ke(r.url_allowlist)) return !1;
    if (null != (a = r) && a.url_ignorelist && $9052383c1c4e5569$var$ke(r.url_ignorelist)) return !1;
    if (null != (l = r) && l.dom_event_allowlist) {
        var h = r.dom_event_allowlist;
        if (h && !h.some((t)=>e.type === t)) return !1;
    }
    var { parentIsUsefulElement: d, targetElementList: v } = $9052383c1c4e5569$var$Ne(i, s);
    if (!function(t, i) {
        var e = null == i ? void 0 : i.element_allowlist;
        if ($9052383c1c4e5569$var$O(e)) return !0;
        var r, s = function(t) {
            if (e.some((i)=>t.tagName.toLowerCase() === i)) return {
                v: !0
            };
        };
        for (var n of t)if (r = s(n)) return r.v;
        return !1;
    }(v, r)) return !1;
    if (!$9052383c1c4e5569$var$Fe(v, null == (u = r) ? void 0 : u.css_selector_allowlist)) return !1;
    var c = $9052383c1c4e5569$var$t.getComputedStyle(i);
    if (c && "pointer" === c.getPropertyValue("cursor") && "click" === e.type) return !0;
    var f = i.tagName.toLowerCase();
    switch(f){
        case "html":
            return !1;
        case "form":
            return (n || [
                "submit"
            ]).indexOf(e.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (n || [
                "change",
                "click"
            ]).indexOf(e.type) >= 0;
        default:
            return d ? (n || [
                "click"
            ]).indexOf(e.type) >= 0 : (n || [
                "click"
            ]).indexOf(e.type) >= 0 && ($9052383c1c4e5569$var$Re.indexOf(f) > -1 || "true" === i.getAttribute("contenteditable"));
    }
}
function $9052383c1c4e5569$var$ze(t) {
    for(var i = t; i.parentNode && !$9052383c1c4e5569$var$xe(i, "body"); i = i.parentNode){
        var e = $9052383c1c4e5569$var$Pe(i);
        if ($9052383c1c4e5569$var$w(e, "ph-sensitive") || $9052383c1c4e5569$var$w(e, "ph-no-capture")) return !1;
    }
    if ($9052383c1c4e5569$var$w($9052383c1c4e5569$var$Pe(t), "ph-include")) return !0;
    var r = t.type || "";
    if ($9052383c1c4e5569$var$M(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    if ($9052383c1c4e5569$var$M(s)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $9052383c1c4e5569$var$He(t) {
    return !!($9052383c1c4e5569$var$xe(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $9052383c1c4e5569$var$xe(t, "select") || $9052383c1c4e5569$var$xe(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $9052383c1c4e5569$var$Be = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $9052383c1c4e5569$var$qe = new RegExp("^(?:" + $9052383c1c4e5569$var$Be + ")$"), $9052383c1c4e5569$var$We = new RegExp($9052383c1c4e5569$var$Be), $9052383c1c4e5569$var$Ge = "\\d{3}-?\\d{2}-?\\d{4}", $9052383c1c4e5569$var$Ve = new RegExp("^(" + $9052383c1c4e5569$var$Ge + ")$"), $9052383c1c4e5569$var$Je = new RegExp("(" + $9052383c1c4e5569$var$Ge + ")");
function $9052383c1c4e5569$var$Ke(t, i) {
    if (void 0 === i && (i = !0), $9052383c1c4e5569$var$D(t)) return !1;
    if ($9052383c1c4e5569$var$M(t)) {
        if (t = $9052383c1c4e5569$var$x(t), (i ? $9052383c1c4e5569$var$qe : $9052383c1c4e5569$var$We).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((i ? $9052383c1c4e5569$var$Ve : $9052383c1c4e5569$var$Je).test(t)) return !1;
    }
    return !0;
}
function $9052383c1c4e5569$var$Ye(t) {
    var i = $9052383c1c4e5569$var$Ie(t);
    return $9052383c1c4e5569$var$Ke(i = (i + " " + $9052383c1c4e5569$var$Xe(t)).trim()) ? i : "";
}
function $9052383c1c4e5569$var$Xe(t) {
    var i = "";
    return t && t.childNodes && t.childNodes.length && $9052383c1c4e5569$var$Ci(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null == (e = t.tagName) ? void 0 : e.toLowerCase())) try {
            var r = $9052383c1c4e5569$var$Ie(t);
            i = (i + " " + r).trim(), t.childNodes && t.childNodes.length && (i = (i + " " + $9052383c1c4e5569$var$Xe(t)).trim());
        } catch (t) {
            $9052383c1c4e5569$var$$i.error("[AutoCapture]", t);
        }
    }), i;
}
function $9052383c1c4e5569$var$Qe(t) {
    return function(t) {
        var i = t.map((t)=>{
            var i, e, r = "";
            if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
            var n = $9052383c1c4e5569$var$g({}, t.text ? {
                text: t.text
            } : {}, {
                "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
            }, t.href ? {
                href: t.href
            } : {}, t.attr_id ? {
                attr_id: t.attr_id
            } : {}, t.attributes), o = {};
            return $9052383c1c4e5569$var$Oi(n).sort((t, i)=>{
                var [e] = t, [r] = i;
                return e.localeCompare(r);
            }).forEach((t)=>{
                var [i, e] = t;
                return o[$9052383c1c4e5569$var$Ze(i.toString())] = $9052383c1c4e5569$var$Ze(e.toString());
            }), r += ":", r += $9052383c1c4e5569$var$Oi(o).map((t)=>{
                var [i, e] = t;
                return i + '="' + e + '"';
            }).join("");
        });
        return i.join(";");
    }(function(t) {
        return t.map((t)=>{
            var i, e, r = {
                text: null == (i = t.$el_text) ? void 0 : i.slice(0, 400),
                tag_name: t.tag_name,
                href: null == (e = t.attr__href) ? void 0 : e.slice(0, 2048),
                attr_class: $9052383c1c4e5569$var$tr(t),
                attr_id: t.attr__id,
                nth_child: t.nth_child,
                nth_of_type: t.nth_of_type,
                attributes: {}
            };
            return $9052383c1c4e5569$var$Oi(t).filter((t)=>{
                var [i] = t;
                return 0 === i.indexOf("attr__");
            }).forEach((t)=>{
                var [i, e] = t;
                return r.attributes[i] = e;
            }), r;
        });
    }(t));
}
function $9052383c1c4e5569$var$Ze(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $9052383c1c4e5569$var$tr(t) {
    var i = t.attr__class;
    return i ? $9052383c1c4e5569$var$I(i) ? i : $9052383c1c4e5569$var$Se(i) : void 0;
}
class $9052383c1c4e5569$var$ir {
    constructor(t){
        this.disabled = !1 === t;
        var i = $9052383c1c4e5569$var$R(t) ? t : {};
        this.thresholdPx = i.threshold_px || 30, this.timeoutMs = i.timeout_ms || 1e3, this.clickCount = i.click_count || 3, this.clicks = [];
    }
    isRageClick(t, i, e) {
        if (this.disabled) return !1;
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(i - r.y) < this.thresholdPx && e - r.timestamp < this.timeoutMs) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), this.clicks.length === this.clickCount) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
}
var $9052383c1c4e5569$var$er = (t)=>{
    var i = null == $9052383c1c4e5569$var$o ? void 0 : $9052383c1c4e5569$var$o.createElement("a");
    return $9052383c1c4e5569$var$O(i) ? null : (i.href = t, i);
}, $9052383c1c4e5569$var$rr = function(t, i) {
    var e, r;
    void 0 === i && (i = "&");
    var s = [];
    return $9052383c1c4e5569$var$Ci(t, function(t, i) {
        $9052383c1c4e5569$var$O(t) || $9052383c1c4e5569$var$O(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(i), s[s.length] = r + "=" + e);
    }), s.join(i);
}, $9052383c1c4e5569$var$sr = function(t, i) {
    for(var e, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; s < r.length; s++){
        var n = r[s].split("=");
        if (n[0] === i) {
            e = n;
            break;
        }
    }
    if (!$9052383c1c4e5569$var$I(e) || e.length < 2) return "";
    var o = e[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $9052383c1c4e5569$var$$i.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $9052383c1c4e5569$var$nr = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    for(var r = t.split("#"), s = r[0] || "", n = r[1], o = s.split("?"), a = o[1], l = o[0], u = (a || "").split("&"), h = [], d = 0; d < u.length; d++){
        var v = u[d].split("=");
        $9052383c1c4e5569$var$I(v) && (i.includes(v[0]) ? h.push(v[0] + "=" + e) : h.push(u[d]));
    }
    var c = l;
    return null != a && (c += "?" + h.join("&")), null != n && (c += "#" + n), c;
}, $9052383c1c4e5569$var$or = function(t, i) {
    var e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, $9052383c1c4e5569$var$ar = "$copy_autocapture", $9052383c1c4e5569$var$lr = $9052383c1c4e5569$var$Si("[AutoCapture]");
function $9052383c1c4e5569$var$ur(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function $9052383c1c4e5569$var$hr(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var i = t;
    do i = i.previousSibling;
    while (i && !$9052383c1c4e5569$var$we(i));
    return i;
}
function $9052383c1c4e5569$var$dr(t, i, e, r) {
    var s = t.tagName.toLowerCase(), n = {
        tag_name: s
    };
    $9052383c1c4e5569$var$Re.indexOf(s) > -1 && !e && ("a" === s.toLowerCase() || "button" === s.toLowerCase() ? n.$el_text = $9052383c1c4e5569$var$ur(1024, $9052383c1c4e5569$var$Ye(t)) : n.$el_text = $9052383c1c4e5569$var$ur(1024, $9052383c1c4e5569$var$Ie(t)));
    var o = $9052383c1c4e5569$var$Pe(t);
    o.length > 0 && (n.classes = o.filter(function(t) {
        return "" !== t;
    })), $9052383c1c4e5569$var$Ci(t.attributes, function(e) {
        var s;
        if ((!$9052383c1c4e5569$var$He(t) || -1 !== [
            "name",
            "id",
            "class",
            "aria-label"
        ].indexOf(e.name)) && (null == r || !r.includes(e.name)) && !i && $9052383c1c4e5569$var$Ke(e.value) && (s = e.name, !$9052383c1c4e5569$var$M(s) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
            var o = e.value;
            "class" === e.name && (o = $9052383c1c4e5569$var$Se(o).join(" ")), n["attr__" + e.name] = $9052383c1c4e5569$var$ur(1024, o);
        }
    });
    for(var a = 1, l = 1, u = t; u = $9052383c1c4e5569$var$hr(u);)a++, u.tagName === t.tagName && l++;
    return n.nth_child = a, n.nth_of_type = l, n;
}
function $9052383c1c4e5569$var$vr(i, e) {
    for(var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: u } = e, h = [
        i
    ], d = i; d.parentNode && !$9052383c1c4e5569$var$xe(d, "body");)$9052383c1c4e5569$var$$e(d.parentNode) ? (h.push(d.parentNode.host), d = d.parentNode.host) : (h.push(d.parentNode), d = d.parentNode);
    var v, c = [], f = {}, p = !1, g = !1;
    if ($9052383c1c4e5569$var$Ci(h, (t)=>{
        var i = $9052383c1c4e5569$var$ze(t);
        "a" === t.tagName.toLowerCase() && (p = t.getAttribute("href"), p = i && p && $9052383c1c4e5569$var$Ke(p) && p), $9052383c1c4e5569$var$w($9052383c1c4e5569$var$Pe(t), "ph-no-capture") && (g = !0), c.push($9052383c1c4e5569$var$dr(t, o, a, l));
        var e = function(t) {
            if (!$9052383c1c4e5569$var$ze(t)) return {};
            var i = {};
            return $9052383c1c4e5569$var$Ci(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var e = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    e && r && $9052383c1c4e5569$var$Ke(r) && (i[e] = r);
                }
            }), i;
        }(t);
        $9052383c1c4e5569$var$Ri(f, e);
    }), g) return {
        props: {},
        explicitNoCapture: g
    };
    if (a || ("a" === i.tagName.toLowerCase() || "button" === i.tagName.toLowerCase() ? c[0].$el_text = $9052383c1c4e5569$var$Ye(i) : c[0].$el_text = $9052383c1c4e5569$var$Ie(i)), p) {
        var _, m;
        c[0].attr__href = p;
        var b = null == (_ = $9052383c1c4e5569$var$er(p)) ? void 0 : _.host, y = null == $9052383c1c4e5569$var$t || null == (m = $9052383c1c4e5569$var$t.location) ? void 0 : m.host;
        b && y && b !== y && (v = p);
    }
    return {
        props: $9052383c1c4e5569$var$Ri({
            $event_type: n.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: c
        }, {
            $elements_chain: $9052383c1c4e5569$var$Qe(c)
        }, null != (r = c[0]) && r.$el_text ? {
            $el_text: null == (s = c[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, f)
    };
}
class $9052383c1c4e5569$var$cr {
    constructor(t){
        this.P = !1, this.T = null, this.I = !1, this.instance = t, this.rageclicks = new $9052383c1c4e5569$var$ir(t.config.rageclick), this.C = null;
    }
    get R() {
        var t, i, e = $9052383c1c4e5569$var$R(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
        return e.url_allowlist = null == (t = e.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), e.url_ignorelist = null == (i = e.url_ignorelist) ? void 0 : i.map((t)=>new RegExp(t)), e;
    }
    F() {
        if (this.isBrowserSupported()) {
            if ($9052383c1c4e5569$var$t && $9052383c1c4e5569$var$o) {
                var i = (i)=>{
                    i = i || (null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.event);
                    try {
                        this.O(i);
                    } catch (t) {
                        $9052383c1c4e5569$var$lr.error("Failed to capture event", t);
                    }
                };
                if ($9052383c1c4e5569$var$zi($9052383c1c4e5569$var$o, "submit", i, {
                    capture: !0
                }), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$o, "change", i, {
                    capture: !0
                }), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$o, "click", i, {
                    capture: !0
                }), this.R.capture_copied_text) {
                    var e = (i)=>{
                        i = i || (null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.event), this.O(i, $9052383c1c4e5569$var$ar);
                    };
                    $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$o, "copy", e, {
                        capture: !0
                    }), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$o, "cut", e, {
                        capture: !0
                    });
                }
            }
        } else $9052383c1c4e5569$var$lr.info("Disabling Automatic Event Collection because this browser is not supported");
    }
    startIfEnabled() {
        this.isEnabled && !this.P && (this.F(), this.P = !0);
    }
    onRemoteConfig(t) {
        t.elementsChainAsString && (this.I = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
            [$9052383c1c4e5569$var$Wi]: !!t.autocapture_opt_out
        }), this.T = !!t.autocapture_opt_out, this.startIfEnabled();
    }
    setElementSelectors(t) {
        this.C = t;
    }
    getElementSelectors(t) {
        var i, e = [];
        return null == (i = this.C) || i.forEach((i)=>{
            var r = null == $9052383c1c4e5569$var$o ? void 0 : $9052383c1c4e5569$var$o.querySelectorAll(i);
            null == r || r.forEach((r)=>{
                t === r && e.push(i);
            });
        }), e;
    }
    get isEnabled() {
        var t, i, e = null == (t = this.instance.persistence) ? void 0 : t.props[$9052383c1c4e5569$var$Wi], r = this.T;
        if ($9052383c1c4e5569$var$j(r) && !$9052383c1c4e5569$var$U(e) && !this.instance.M()) return !1;
        var s = null !== (i = this.T) && void 0 !== i ? i : !!e;
        return !!this.instance.config.autocapture && !s;
    }
    O(i, e) {
        if (void 0 === e && (e = "$autocapture"), this.isEnabled) {
            var r, s = $9052383c1c4e5569$var$Ce(i);
            if ($9052383c1c4e5569$var$Ee(s) && (s = s.parentNode || null), "$autocapture" === e && "click" === i.type && i instanceof MouseEvent) this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(i.clientX, i.clientY, i.timeStamp || (new Date).getTime()) && $9052383c1c4e5569$var$De(s, this.instance.config.rageclick) && this.O(i, "$rageclick");
            var n = e === $9052383c1c4e5569$var$ar;
            if (s && $9052383c1c4e5569$var$Ue(s, i, this.R, n, n ? [
                "copy",
                "cut"
            ] : void 0)) {
                var { props: o, explicitNoCapture: a } = $9052383c1c4e5569$var$vr(s, {
                    e: i,
                    maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                    maskAllText: this.instance.config.mask_all_text,
                    elementAttributeIgnoreList: this.R.element_attribute_ignorelist,
                    elementsChainAsString: this.I
                });
                if (a) return !1;
                var l = this.getElementSelectors(s);
                if (l && l.length > 0 && (o.$element_selectors = l), e === $9052383c1c4e5569$var$ar) {
                    var u, h = $9052383c1c4e5569$var$Te(null == $9052383c1c4e5569$var$t || null == (u = $9052383c1c4e5569$var$t.getSelection()) ? void 0 : u.toString()), d = i.type || "clipboard";
                    if (!h) return !1;
                    o.$selected_content = h, o.$copy_type = d;
                }
                return this.instance.capture(e, o), !0;
            }
        }
    }
    isBrowserSupported() {
        return $9052383c1c4e5569$var$C(null == $9052383c1c4e5569$var$o ? void 0 : $9052383c1c4e5569$var$o.querySelectorAll);
    }
}
Math.trunc || (Math.trunc = function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $9052383c1c4e5569$var$L(t) && isFinite(t) && Math.floor(t) === t;
});
var $9052383c1c4e5569$var$fr = "0123456789abcdef";
class $9052383c1c4e5569$var$pr {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, i, e, r) {
        if (!Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(r) || t < 0 || i < 0 || e < 0 || r < 0 || t > 0xffffffffffff || i > 4095 || e > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | i >>> 8, s[7] = i, s[8] = 128 | e >>> 24, s[9] = e >>> 16, s[10] = e >>> 8, s[11] = e, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $9052383c1c4e5569$var$pr(s);
    }
    toString() {
        for(var t = "", i = 0; i < this.bytes.length; i++)t = t + $9052383c1c4e5569$var$fr.charAt(this.bytes[i] >>> 4) + $9052383c1c4e5569$var$fr.charAt(15 & this.bytes[i]), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $9052383c1c4e5569$var$pr(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var i = 0; i < 16; i++){
            var e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}
class $9052383c1c4e5569$var$gr {
    constructor(){
        this.A = 0, this.j = 0, this.D = new $9052383c1c4e5569$var$br;
    }
    generate() {
        var t = this.generateOrAbort();
        if ($9052383c1c4e5569$var$O(t)) {
            this.A = 0;
            var i = this.generateOrAbort();
            if ($9052383c1c4e5569$var$O(i)) throw new Error("Could not generate UUID after timestamp reset");
            return i;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.A) this.A = t, this.L();
        else {
            if (!(t + 1e4 > this.A)) return;
            this.j++, this.j > 4398046511103 && (this.A++, this.L());
        }
        return $9052383c1c4e5569$var$pr.fromFieldsV7(this.A, Math.trunc(this.j / Math.pow(2, 30)), this.j & Math.pow(2, 30) - 1, this.D.nextUint32());
    }
    L() {
        this.j = 1024 * this.D.nextUint32() + (1023 & this.D.nextUint32());
    }
}
var $9052383c1c4e5569$var$_r, $9052383c1c4e5569$var$mr = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var i = 0; i < t.length; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$9052383c1c4e5569$var$t && !$9052383c1c4e5569$var$O($9052383c1c4e5569$var$t.crypto) && crypto.getRandomValues && ($9052383c1c4e5569$var$mr = (t)=>crypto.getRandomValues(t));
class $9052383c1c4e5569$var$br {
    constructor(){
        this.N = new Uint32Array(8), this.U = 1 / 0;
    }
    nextUint32() {
        return this.U >= this.N.length && ($9052383c1c4e5569$var$mr(this.N), this.U = 0), this.N[this.U++];
    }
}
var $9052383c1c4e5569$var$yr = ()=>$9052383c1c4e5569$var$wr().toString(), $9052383c1c4e5569$var$wr = ()=>($9052383c1c4e5569$var$_r || ($9052383c1c4e5569$var$_r = new $9052383c1c4e5569$var$gr)).generate(), $9052383c1c4e5569$var$xr = "";
var $9052383c1c4e5569$var$Er = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $9052383c1c4e5569$var$$r(t, i) {
    if (i) {
        var e = function(t, i) {
            if (void 0 === i && (i = $9052383c1c4e5569$var$o), $9052383c1c4e5569$var$xr) return $9052383c1c4e5569$var$xr;
            if (!i) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(t)) return "";
            for(var e = t.split("."), r = Math.min(e.length, 8), s = "dmn_chk_" + $9052383c1c4e5569$var$yr(); !$9052383c1c4e5569$var$xr && r--;){
                var n = e.slice(r).join("."), a = s + "=1;domain=." + n + ";path=/";
                i.cookie = a + ";max-age=3", i.cookie.includes(s) && (i.cookie = a + ";max-age=0", $9052383c1c4e5569$var$xr = n);
            }
            return $9052383c1c4e5569$var$xr;
        }(t);
        if (!e) {
            var r = ((t)=>{
                var i = t.match($9052383c1c4e5569$var$Er);
                return i ? i[0] : "";
            })(t);
            r !== e && $9052383c1c4e5569$var$$i.info("Warning: cookie subdomain discovery mismatch", r, e), e = r;
        }
        return e ? "; domain=." + e : "";
    }
    return "";
}
var $9052383c1c4e5569$var$Sr = {
    H: ()=>!!$9052383c1c4e5569$var$o,
    B: function(t) {
        $9052383c1c4e5569$var$$i.error("cookieStore error: " + t);
    },
    q: function(t) {
        if ($9052383c1c4e5569$var$o) {
            try {
                for(var i = t + "=", e = $9052383c1c4e5569$var$o.cookie.split(";").filter((t)=>t.length), r = 0; r < e.length; r++){
                    for(var s = e[r]; " " == s.charAt(0);)s = s.substring(1, s.length);
                    if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
                }
            } catch (t) {}
            return null;
        }
    },
    W: function(t) {
        var i;
        try {
            i = JSON.parse($9052383c1c4e5569$var$Sr.q(t)) || {};
        } catch (t) {}
        return i;
    },
    G: function(t, i, e, r, s) {
        if ($9052383c1c4e5569$var$o) try {
            var n = "", a = "", l = $9052383c1c4e5569$var$$r($9052383c1c4e5569$var$o.location.hostname, r);
            if (e) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * e * 3600000), n = "; expires=" + u.toUTCString();
            }
            s && (a = "; secure");
            var h = t + "=" + encodeURIComponent(JSON.stringify(i)) + n + "; SameSite=Lax; path=/" + l + a;
            return h.length > 3686.4 && $9052383c1c4e5569$var$$i.warn("cookieStore warning: large cookie, len=" + h.length), $9052383c1c4e5569$var$o.cookie = h, h;
        } catch (t) {
            return;
        }
    },
    V: function(t, i) {
        if (null != $9052383c1c4e5569$var$o && $9052383c1c4e5569$var$o.cookie) try {
            $9052383c1c4e5569$var$Sr.G(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
}, $9052383c1c4e5569$var$kr = null, $9052383c1c4e5569$var$Pr = {
    H: function() {
        if (!$9052383c1c4e5569$var$j($9052383c1c4e5569$var$kr)) return $9052383c1c4e5569$var$kr;
        var i = !0;
        if ($9052383c1c4e5569$var$O($9052383c1c4e5569$var$t)) i = !1;
        else try {
            var e = "__mplssupport__";
            $9052383c1c4e5569$var$Pr.G(e, "xyz"), '"xyz"' !== $9052383c1c4e5569$var$Pr.q(e) && (i = !1), $9052383c1c4e5569$var$Pr.V(e);
        } catch (t) {
            i = !1;
        }
        return i || $9052383c1c4e5569$var$$i.error("localStorage unsupported; falling back to cookie store"), $9052383c1c4e5569$var$kr = i, i;
    },
    B: function(t) {
        $9052383c1c4e5569$var$$i.error("localStorage error: " + t);
    },
    q: function(i) {
        try {
            return null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.localStorage.getItem(i);
        } catch (t) {
            $9052383c1c4e5569$var$Pr.B(t);
        }
        return null;
    },
    W: function(t) {
        try {
            return JSON.parse($9052383c1c4e5569$var$Pr.q(t)) || {};
        } catch (t) {}
        return null;
    },
    G: function(i, e) {
        try {
            null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.localStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $9052383c1c4e5569$var$Pr.B(t);
        }
    },
    V: function(i) {
        try {
            null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.localStorage.removeItem(i);
        } catch (t) {
            $9052383c1c4e5569$var$Pr.B(t);
        }
    }
}, $9052383c1c4e5569$var$Tr = [
    "$device_id",
    "distinct_id",
    $9052383c1c4e5569$var$ie,
    $9052383c1c4e5569$var$ee,
    $9052383c1c4e5569$var$ge,
    $9052383c1c4e5569$var$pe
], $9052383c1c4e5569$var$Ir = {}, $9052383c1c4e5569$var$Cr = {
    H: function() {
        return !0;
    },
    B: function(t) {
        $9052383c1c4e5569$var$$i.error("memoryStorage error: " + t);
    },
    q: function(t) {
        return $9052383c1c4e5569$var$Ir[t] || null;
    },
    W: function(t) {
        return $9052383c1c4e5569$var$Ir[t] || null;
    },
    G: function(t, i) {
        $9052383c1c4e5569$var$Ir[t] = i;
    },
    V: function(t) {
        delete $9052383c1c4e5569$var$Ir[t];
    }
}, $9052383c1c4e5569$var$Rr = null, $9052383c1c4e5569$var$Fr = {
    H: function() {
        if (!$9052383c1c4e5569$var$j($9052383c1c4e5569$var$Rr)) return $9052383c1c4e5569$var$Rr;
        if ($9052383c1c4e5569$var$Rr = !0, $9052383c1c4e5569$var$O($9052383c1c4e5569$var$t)) $9052383c1c4e5569$var$Rr = !1;
        else try {
            var i = "__support__";
            $9052383c1c4e5569$var$Fr.G(i, "xyz"), '"xyz"' !== $9052383c1c4e5569$var$Fr.q(i) && ($9052383c1c4e5569$var$Rr = !1), $9052383c1c4e5569$var$Fr.V(i);
        } catch (t) {
            $9052383c1c4e5569$var$Rr = !1;
        }
        return $9052383c1c4e5569$var$Rr;
    },
    B: function(t) {
        $9052383c1c4e5569$var$$i.error("sessionStorage error: ", t);
    },
    q: function(i) {
        try {
            return null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.sessionStorage.getItem(i);
        } catch (t) {
            $9052383c1c4e5569$var$Fr.B(t);
        }
        return null;
    },
    W: function(t) {
        try {
            return JSON.parse($9052383c1c4e5569$var$Fr.q(t)) || null;
        } catch (t) {}
        return null;
    },
    G: function(i, e) {
        try {
            null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.sessionStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $9052383c1c4e5569$var$Fr.B(t);
        }
    },
    V: function(i) {
        try {
            null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.sessionStorage.removeItem(i);
        } catch (t) {
            $9052383c1c4e5569$var$Fr.B(t);
        }
    }
}, $9052383c1c4e5569$var$Or = function(t) {
    return t[t.PENDING = -1] = "PENDING", t[t.DENIED = 0] = "DENIED", t[t.GRANTED = 1] = "GRANTED", t;
}({});
class $9052383c1c4e5569$var$Mr {
    constructor(t){
        this._instance = t;
    }
    get R() {
        return this._instance.config;
    }
    get consent() {
        return this.J() ? $9052383c1c4e5569$var$Or.DENIED : this.K;
    }
    isOptedOut() {
        return "always" === this.R.cookieless_mode || this.consent === $9052383c1c4e5569$var$Or.DENIED || this.consent === $9052383c1c4e5569$var$Or.PENDING && (this.R.opt_out_capturing_by_default || "on_reject" === this.R.cookieless_mode);
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return this.consent === $9052383c1c4e5569$var$Or.DENIED;
    }
    optInOut(t) {
        this.Y.G(this.X, t ? 1 : 0, this.R.cookie_expiration, this.R.cross_subdomain_cookie, this.R.secure_cookie);
    }
    reset() {
        this.Y.V(this.X, this.R.cross_subdomain_cookie);
    }
    get X() {
        var { token: t, opt_out_capturing_cookie_prefix: i, consent_persistence_name: e } = this._instance.config;
        return e || (i ? i + t : "__ph_opt_in_out_" + t);
    }
    get K() {
        var t = this.Y.q(this.X);
        return $9052383c1c4e5569$var$V(t) ? $9052383c1c4e5569$var$Or.GRANTED : $9052383c1c4e5569$var$w($9052383c1c4e5569$var$J, t) ? $9052383c1c4e5569$var$Or.DENIED : $9052383c1c4e5569$var$Or.PENDING;
    }
    get Y() {
        if (!this.Z) {
            var t = this.R.opt_out_capturing_persistence_type;
            this.Z = "localStorage" === t ? $9052383c1c4e5569$var$Pr : $9052383c1c4e5569$var$Sr;
            var i = "localStorage" === t ? $9052383c1c4e5569$var$Sr : $9052383c1c4e5569$var$Pr;
            i.q(this.X) && (this.Z.q(this.X) || this.optInOut($9052383c1c4e5569$var$V(i.q(this.X))), i.V(this.X, this.R.cross_subdomain_cookie));
        }
        return this.Z;
    }
    J() {
        return !!this.R.respect_dnt && !!$9052383c1c4e5569$var$Ui([
            null == $9052383c1c4e5569$var$n ? void 0 : $9052383c1c4e5569$var$n.doNotTrack,
            null == $9052383c1c4e5569$var$n ? void 0 : $9052383c1c4e5569$var$n.msDoNotTrack,
            $9052383c1c4e5569$var$v.doNotTrack
        ], (t)=>$9052383c1c4e5569$var$V(t));
    }
}
var $9052383c1c4e5569$var$Ar = $9052383c1c4e5569$var$Si("[Dead Clicks]"), $9052383c1c4e5569$var$jr = ()=>!0, $9052383c1c4e5569$var$Dr = (t)=>{
    var i, e = !(null == (i = t.instance.persistence) || !i.get_property($9052383c1c4e5569$var$Xi)), r = t.instance.config.capture_dead_clicks;
    return $9052383c1c4e5569$var$U(r) ? r : !!$9052383c1c4e5569$var$R(r) || e;
};
class $9052383c1c4e5569$var$Lr {
    get lazyLoadedDeadClicksAutocapture() {
        return this.tt;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabled();
    }
    onRemoteConfig(t) {
        this.instance.persistence && this.instance.persistence.register({
            [$9052383c1c4e5569$var$Xi]: null == t ? void 0 : t.captureDeadClicks
        }), this.startIfEnabled();
    }
    startIfEnabled() {
        this.isEnabled(this) && this.it(()=>{
            this.et();
        });
    }
    it(t) {
        var i, e;
        null != (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) && i.initDeadClicksAutocapture && t(), null == (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "dead-clicks-autocapture", (i)=>{
            i ? $9052383c1c4e5569$var$Ar.error("failed to load script", i) : t();
        });
    }
    et() {
        var t;
        if ($9052383c1c4e5569$var$o) {
            if (!this.tt && null != (t = $9052383c1c4e5569$var$v.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var i = $9052383c1c4e5569$var$R(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                i.__onCapture = this.onCapture, this.tt = $9052383c1c4e5569$var$v.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, i), this.tt.start($9052383c1c4e5569$var$o), $9052383c1c4e5569$var$Ar.info("starting...");
            }
        } else $9052383c1c4e5569$var$Ar.error("`document` not found. Cannot start.");
    }
    stop() {
        this.tt && (this.tt.stop(), this.tt = void 0, $9052383c1c4e5569$var$Ar.info("stopping..."));
    }
}
var $9052383c1c4e5569$var$Nr = $9052383c1c4e5569$var$Si("[ExceptionAutocapture]");
class $9052383c1c4e5569$var$Ur {
    constructor(i){
        var e, r, s;
        this.rt = ()=>{
            var i;
            if ($9052383c1c4e5569$var$t && this.isEnabled && null != (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) && i.errorWrappingFunctions) {
                var e = $9052383c1c4e5569$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $9052383c1c4e5569$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $9052383c1c4e5569$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                try {
                    !this.st && this.R.capture_unhandled_errors && (this.st = e(this.captureException.bind(this))), !this.nt && this.R.capture_unhandled_rejections && (this.nt = r(this.captureException.bind(this))), !this.ot && this.R.capture_console_errors && (this.ot = s(this.captureException.bind(this)));
                } catch (t) {
                    $9052383c1c4e5569$var$Nr.error("failed to start", t), this.ut();
                }
            }
        }, this._instance = i, this.ht = !(null == (e = this._instance.persistence) || !e.props[$9052383c1c4e5569$var$Vi]), this.dt = new $9052383c1c4e5569$var$Y({
            refillRate: null !== (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) && void 0 !== r ? r : 1,
            bucketSize: null !== (s = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10,
            refillInterval: 1e4,
            h: $9052383c1c4e5569$var$Nr
        }), this.R = this.vt(), this.startIfEnabledOrStop();
    }
    vt() {
        var t = this._instance.config.capture_exceptions, i = {
            capture_unhandled_errors: !1,
            capture_unhandled_rejections: !1,
            capture_console_errors: !1
        };
        return $9052383c1c4e5569$var$R(t) ? i = $9052383c1c4e5569$var$g({}, i, t) : ($9052383c1c4e5569$var$O(t) ? this.ht : t) && (i = $9052383c1c4e5569$var$g({}, i, {
            capture_unhandled_errors: !0,
            capture_unhandled_rejections: !0
        })), i;
    }
    get isEnabled() {
        return this.R.capture_console_errors || this.R.capture_unhandled_errors || this.R.capture_unhandled_rejections;
    }
    startIfEnabledOrStop() {
        this.isEnabled ? ($9052383c1c4e5569$var$Nr.info("enabled"), this.ut(), this.it(this.rt)) : this.ut();
    }
    it(t) {
        var i, e;
        null != (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) && i.errorWrappingFunctions && t(), null == (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "exception-autocapture", (i)=>{
            if (i) return $9052383c1c4e5569$var$Nr.error("failed to load script", i);
            t();
        });
    }
    ut() {
        var t, i, e;
        null == (t = this.st) || t.call(this), this.st = void 0, null == (i = this.nt) || i.call(this), this.nt = void 0, null == (e = this.ot) || e.call(this), this.ot = void 0;
    }
    onRemoteConfig(t) {
        var i = t.autocaptureExceptions;
        this.ht = !!i || !1, this._instance.persistence && this._instance.persistence.register({
            [$9052383c1c4e5569$var$Vi]: this.ht
        }), this.R = this.vt(), this.startIfEnabledOrStop();
    }
    onConfigChange() {
        this.R = this.vt();
    }
    captureException(t) {
        var i, e, r = null !== (i = null == t || null == (e = t.$exception_list) || null == (e = e[0]) ? void 0 : e.type) && void 0 !== i ? i : "Exception";
        this.dt.consumeRateLimit(r) ? $9052383c1c4e5569$var$Nr.info("Skipping exception capture because of client rate limiting.", {
            exception: r
        }) : this._instance.exceptions.sendExceptionEvent(t);
    }
}
function $9052383c1c4e5569$var$zr(t, i, e) {
    try {
        if (!(i in t)) return ()=>{};
        var r = t[i], s = e(r);
        return $9052383c1c4e5569$var$C(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            }
        })), t[i] = s, ()=>{
            t[i] = r;
        };
    } catch (t) {
        return ()=>{};
    }
}
class $9052383c1c4e5569$var$Hr {
    constructor(i){
        var e;
        this._instance = i, this.ct = (null == $9052383c1c4e5569$var$t || null == (e = $9052383c1c4e5569$var$t.location) ? void 0 : e.pathname) || "";
    }
    get isEnabled() {
        return "history_change" === this._instance.config.capture_pageview;
    }
    startIfEnabled() {
        this.isEnabled && ($9052383c1c4e5569$var$$i.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
    }
    stop() {
        this.ft && this.ft(), this.ft = void 0, $9052383c1c4e5569$var$$i.info("History API monitoring stopped");
    }
    monitorHistoryChanges() {
        var i, e;
        if ($9052383c1c4e5569$var$t && $9052383c1c4e5569$var$t.history) {
            var r = this;
            null != (i = $9052383c1c4e5569$var$t.history.pushState) && i.__posthog_wrapped__ || $9052383c1c4e5569$var$zr($9052383c1c4e5569$var$t.history, "pushState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r._t("pushState");
                }), null != (e = $9052383c1c4e5569$var$t.history.replaceState) && e.__posthog_wrapped__ || $9052383c1c4e5569$var$zr($9052383c1c4e5569$var$t.history, "replaceState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r._t("replaceState");
                }), this.bt();
        }
    }
    _t(i) {
        try {
            var e, r = null == $9052383c1c4e5569$var$t || null == (e = $9052383c1c4e5569$var$t.location) ? void 0 : e.pathname;
            if (!r) return;
            r !== this.ct && this.isEnabled && this._instance.capture("$pageview", {
                navigation_type: i
            }), this.ct = r;
        } catch (t) {
            $9052383c1c4e5569$var$$i.error("Error capturing " + i + " pageview", t);
        }
    }
    bt() {
        if (!this.ft) {
            var i = ()=>{
                this._t("popstate");
            };
            $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$t, "popstate", i), this.ft = ()=>{
                $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$t.removeEventListener("popstate", i);
            };
        }
    }
}
var $9052383c1c4e5569$var$Br = $9052383c1c4e5569$var$Si("[SegmentIntegration]");
function $9052383c1c4e5569$var$qr(t, i) {
    var e = t.config.segment;
    if (!e) return i();
    !function(t, i) {
        var e = t.config.segment;
        if (!e) return i();
        var r = (e)=>{
            var r = ()=>e.anonymousId() || $9052383c1c4e5569$var$yr();
            t.config.get_device_id = r, e.id() && (t.register({
                distinct_id: e.id(),
                $device_id: r()
            }), t.persistence.set_property($9052383c1c4e5569$var$he, "identified")), i();
        }, s = e.user();
        "then" in s && $9052383c1c4e5569$var$C(s.then) ? s.then(r) : r(s);
    }(t, ()=>{
        e.register(((t)=>{
            Promise && Promise.resolve || $9052383c1c4e5569$var$Br.warn("This browser does not have Promise support, and can not use the segment integration");
            var i = (i, e)=>{
                if (!e) return i;
                i.event.userId || i.event.anonymousId === t.get_distinct_id() || ($9052383c1c4e5569$var$Br.info("No userId set, resetting PostHog"), t.reset()), i.event.userId && i.event.userId !== t.get_distinct_id() && ($9052383c1c4e5569$var$Br.info("UserId set, identifying with PostHog"), t.identify(i.event.userId));
                var r = t.calculateEventProperties(e, i.event.properties);
                return i.event.properties = Object.assign({}, r, i.event.properties), i;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (t)=>i(t, t.event.event),
                page: (t)=>i(t, "$pageview"),
                identify: (t)=>i(t, "$identify"),
                screen: (t)=>i(t, "$screen")
            };
        })(t)).then(()=>{
            i();
        });
    });
}
var $9052383c1c4e5569$var$Wr = "posthog-js";
function $9052383c1c4e5569$var$Gr(t, i) {
    var { organization: e, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ], sendExceptionsToPostHog: o = !0 } = void 0 === i ? {} : i;
    return (i)=>{
        var a, l, u, h, d;
        if (!("*" === n || n.includes(i.level)) || !t.__loaded) return i;
        i.tags || (i.tags = {});
        var v = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        i.tags["PostHog Person URL"] = v, t.sessionRecordingStarted() && (i.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var c = (null == (a = i.exception) ? void 0 : a.values) || [], f = c.map((t)=>$9052383c1c4e5569$var$g({}, t, {
                stacktrace: t.stacktrace ? $9052383c1c4e5569$var$g({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$9052383c1c4e5569$var$g({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), p = {
            $exception_message: (null == (l = c[0]) ? void 0 : l.value) || i.message,
            $exception_type: null == (u = c[0]) ? void 0 : u.type,
            $exception_level: i.level,
            $exception_list: f,
            $sentry_event_id: i.event_id,
            $sentry_exception: i.exception,
            $sentry_exception_message: (null == (h = c[0]) ? void 0 : h.value) || i.message,
            $sentry_exception_type: null == (d = c[0]) ? void 0 : d.type,
            $sentry_tags: i.tags
        };
        return e && r && (p.$sentry_url = (s || "https://sentry.io/organizations/") + e + "/issues/?project=" + r + "&query=" + i.event_id), o && t.exceptions.sendExceptionEvent(p), i;
    };
}
class $9052383c1c4e5569$var$Vr {
    constructor(t, i, e, r, s, n){
        this.name = $9052383c1c4e5569$var$Wr, this.setupOnce = function(o) {
            o($9052383c1c4e5569$var$Gr(t, {
                organization: i,
                projectId: e,
                prefix: r,
                severityAllowList: s,
                sendExceptionsToPostHog: null == n || n
            }));
        };
    }
}
var $9052383c1c4e5569$var$Jr = null != $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$t.location ? $9052383c1c4e5569$var$or($9052383c1c4e5569$var$t.location.hash, "__posthog") || $9052383c1c4e5569$var$or(location.hash, "state") : null, $9052383c1c4e5569$var$Kr = "_postHogToolbarParams", $9052383c1c4e5569$var$Yr = $9052383c1c4e5569$var$Si("[Toolbar]"), $9052383c1c4e5569$var$Xr = function(t) {
    return t[t.UNINITIALIZED = 0] = "UNINITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.LOADED = 2] = "LOADED", t;
}($9052383c1c4e5569$var$Xr || {});
class $9052383c1c4e5569$var$Qr {
    constructor(t){
        this.instance = t;
    }
    yt(t) {
        $9052383c1c4e5569$var$v.ph_toolbar_state = t;
    }
    wt() {
        var t;
        return null !== (t = $9052383c1c4e5569$var$v.ph_toolbar_state) && void 0 !== t ? t : $9052383c1c4e5569$var$Xr.UNINITIALIZED;
    }
    maybeLoadToolbar(i, e, r) {
        if (void 0 === i && (i = void 0), void 0 === e && (e = void 0), void 0 === r && (r = void 0), !$9052383c1c4e5569$var$t || !$9052383c1c4e5569$var$o) return !1;
        i = null != i ? i : $9052383c1c4e5569$var$t.location, r = null != r ? r : $9052383c1c4e5569$var$t.history;
        try {
            if (!e) {
                try {
                    $9052383c1c4e5569$var$t.localStorage.setItem("test", "test"), $9052383c1c4e5569$var$t.localStorage.removeItem("test");
                } catch (t) {
                    return !1;
                }
                e = null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.localStorage;
            }
            var s, n = $9052383c1c4e5569$var$Jr || $9052383c1c4e5569$var$or(i.hash, "__posthog") || $9052383c1c4e5569$var$or(i.hash, "state"), a = n ? $9052383c1c4e5569$var$Mi(()=>JSON.parse(atob(decodeURIComponent(n)))) || $9052383c1c4e5569$var$Mi(()=>JSON.parse(decodeURIComponent(n))) : null;
            return a && "ph_authorize" === a.action ? ((s = a).source = "url", s && Object.keys(s).length > 0 && (a.desiredHash ? i.hash = a.desiredHash : r ? r.replaceState(r.state, "", i.pathname + i.search) : i.hash = "")) : ((s = JSON.parse(e.getItem($9052383c1c4e5569$var$Kr) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
        } catch (t) {
            return !1;
        }
    }
    xt(t) {
        var i = $9052383c1c4e5569$var$v.ph_load_toolbar || $9052383c1c4e5569$var$v.ph_load_editor;
        !$9052383c1c4e5569$var$D(i) && $9052383c1c4e5569$var$C(i) ? i(t, this.instance) : $9052383c1c4e5569$var$Yr.warn("No toolbar load function found");
    }
    loadToolbar(i) {
        var e = !(null == $9052383c1c4e5569$var$o || !$9052383c1c4e5569$var$o.getElementById($9052383c1c4e5569$var$_e));
        if (!$9052383c1c4e5569$var$t || e) return !1;
        var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = $9052383c1c4e5569$var$g({
            token: this.instance.config.token
        }, i, {
            apiURL: this.instance.requestRouter.endpointFor("ui")
        }, r ? {
            instrument: !1
        } : {});
        if ($9052383c1c4e5569$var$t.localStorage.setItem($9052383c1c4e5569$var$Kr, JSON.stringify($9052383c1c4e5569$var$g({}, s, {
            source: void 0
        }))), this.wt() === $9052383c1c4e5569$var$Xr.LOADED) this.xt(s);
        else if (this.wt() === $9052383c1c4e5569$var$Xr.UNINITIALIZED) {
            var n;
            this.yt($9052383c1c4e5569$var$Xr.LOADING), null == (n = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == n.loadExternalDependency || n.loadExternalDependency(this.instance, "toolbar", (t)=>{
                if (t) return $9052383c1c4e5569$var$Yr.error("[Toolbar] Failed to load", t), void this.yt($9052383c1c4e5569$var$Xr.UNINITIALIZED);
                this.yt($9052383c1c4e5569$var$Xr.LOADED), this.xt(s);
            }), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$t, "turbolinks:load", ()=>{
                this.yt($9052383c1c4e5569$var$Xr.UNINITIALIZED), this.loadToolbar(s);
            });
        }
        return !0;
    }
    Et(t) {
        return this.loadToolbar(t);
    }
    maybeLoadEditor(t, i, e) {
        return void 0 === t && (t = void 0), void 0 === i && (i = void 0), void 0 === e && (e = void 0), this.maybeLoadToolbar(t, i, e);
    }
}
var $9052383c1c4e5569$var$Zr = $9052383c1c4e5569$var$Si("[TracingHeaders]");
class $9052383c1c4e5569$var$ts {
    constructor(t){
        this.$t = void 0, this.St = void 0, this.rt = ()=>{
            var t, i;
            $9052383c1c4e5569$var$O(this.$t) && (null == (t = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == (t = t.tracingHeadersPatchFns) || t._patchXHR(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
            $9052383c1c4e5569$var$O(this.St) && (null == (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == (i = i.tracingHeadersPatchFns) || i._patchFetch(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
        }, this._instance = t;
    }
    it(t) {
        var i, e;
        null != (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) && i.tracingHeadersPatchFns && t(), null == (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "tracing-headers", (i)=>{
            if (i) return $9052383c1c4e5569$var$Zr.error("failed to load script", i);
            t();
        });
    }
    startIfEnabledOrStop() {
        var t, i;
        this._instance.config.__add_tracing_headers ? this.it(this.rt) : (null == (t = this.$t) || t.call(this), null == (i = this.St) || i.call(this), this.$t = void 0, this.St = void 0);
    }
}
var $9052383c1c4e5569$var$is = "https?://(.*)", $9052383c1c4e5569$var$es = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $9052383c1c4e5569$var$rs = $9052383c1c4e5569$var$Fi([
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid"
], $9052383c1c4e5569$var$es), $9052383c1c4e5569$var$ss = "<masked>", $9052383c1c4e5569$var$ns = [
    "li_fat_id"
];
function $9052383c1c4e5569$var$os(t, i, e) {
    if (!$9052383c1c4e5569$var$o) return {};
    var r, s = i ? $9052383c1c4e5569$var$Fi([], $9052383c1c4e5569$var$es, e || []) : [], n = $9052383c1c4e5569$var$as($9052383c1c4e5569$var$nr($9052383c1c4e5569$var$o.URL, s, $9052383c1c4e5569$var$ss), t), a = (r = {}, $9052383c1c4e5569$var$Ci($9052383c1c4e5569$var$ns, function(t) {
        var i = $9052383c1c4e5569$var$Sr.q(t);
        r[t] = i || null;
    }), r);
    return $9052383c1c4e5569$var$Ri(a, n);
}
function $9052383c1c4e5569$var$as(t, i) {
    var e = $9052383c1c4e5569$var$rs.concat(i || []), r = {};
    return $9052383c1c4e5569$var$Ci(e, function(i) {
        var e = $9052383c1c4e5569$var$sr(t, i);
        r[i] = e || null;
    }), r;
}
function $9052383c1c4e5569$var$ls(t) {
    var i = function(t) {
        return t ? 0 === t.search($9052383c1c4e5569$var$is + "google.([^/?]*)") ? "google" : 0 === t.search($9052383c1c4e5569$var$is + "bing.com") ? "bing" : 0 === t.search($9052383c1c4e5569$var$is + "yahoo.com") ? "yahoo" : 0 === t.search($9052383c1c4e5569$var$is + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", r = {};
    if (!$9052383c1c4e5569$var$j(i)) {
        r.$search_engine = i;
        var s = $9052383c1c4e5569$var$o ? $9052383c1c4e5569$var$sr($9052383c1c4e5569$var$o.referrer, e) : "";
        s.length && (r.ph_keyword = s);
    }
    return r;
}
function $9052383c1c4e5569$var$us() {
    return navigator.language || navigator.userLanguage;
}
function $9052383c1c4e5569$var$hs() {
    return (null == $9052383c1c4e5569$var$o ? void 0 : $9052383c1c4e5569$var$o.referrer) || "$direct";
}
function $9052383c1c4e5569$var$ds(t, i) {
    var e = t ? $9052383c1c4e5569$var$Fi([], $9052383c1c4e5569$var$es, i || []) : [], r = null == $9052383c1c4e5569$var$a ? void 0 : $9052383c1c4e5569$var$a.href.substring(0, 1e3);
    return {
        r: $9052383c1c4e5569$var$hs().substring(0, 1e3),
        u: r ? $9052383c1c4e5569$var$nr(r, e, $9052383c1c4e5569$var$ss) : void 0
    };
}
function $9052383c1c4e5569$var$vs(t) {
    var i, { r: e, u: r } = t, s = {
        $referrer: e,
        $referring_domain: null == e ? void 0 : "$direct" == e ? "$direct" : null == (i = $9052383c1c4e5569$var$er(e)) ? void 0 : i.host
    };
    if (r) {
        s.$current_url = r;
        var n = $9052383c1c4e5569$var$er(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = $9052383c1c4e5569$var$as(r);
        $9052383c1c4e5569$var$Ri(s, o);
    }
    if (e) {
        var a = $9052383c1c4e5569$var$ls(e);
        $9052383c1c4e5569$var$Ri(s, a);
    }
    return s;
}
function $9052383c1c4e5569$var$cs() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $9052383c1c4e5569$var$fs() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
function $9052383c1c4e5569$var$ps(i, e) {
    if (!$9052383c1c4e5569$var$d) return {};
    var r, s, n, o = i ? $9052383c1c4e5569$var$Fi([], $9052383c1c4e5569$var$es, e || []) : [], [l, u] = function(t) {
        for(var i = 0; i < $9052383c1c4e5569$var$Jt.length; i++){
            var [e, r] = $9052383c1c4e5569$var$Jt[i], s = e.exec(t), n = s && ($9052383c1c4e5569$var$C(r) ? r(s, t) : r);
            if (n) return n;
        }
        return [
            "",
            ""
        ];
    }($9052383c1c4e5569$var$d);
    return $9052383c1c4e5569$var$Ri($9052383c1c4e5569$var$ji({
        $os: l,
        $os_version: u,
        $browser: $9052383c1c4e5569$var$Wt($9052383c1c4e5569$var$d, navigator.vendor),
        $device: $9052383c1c4e5569$var$Kt($9052383c1c4e5569$var$d),
        $device_type: (s = $9052383c1c4e5569$var$d, n = $9052383c1c4e5569$var$Kt(s), n === $9052383c1c4e5569$var$et || n === $9052383c1c4e5569$var$it || "Kobo" === n || "Kindle Fire" === n || n === $9052383c1c4e5569$var$Ft ? $9052383c1c4e5569$var$tt : n === $9052383c1c4e5569$var$wt || n === $9052383c1c4e5569$var$Et || n === $9052383c1c4e5569$var$xt || n === $9052383c1c4e5569$var$It ? "Console" : n === $9052383c1c4e5569$var$st ? "Wearable" : n ? $9052383c1c4e5569$var$X : "Desktop"),
        $timezone: $9052383c1c4e5569$var$cs(),
        $timezone_offset: $9052383c1c4e5569$var$fs()
    }), {
        $current_url: $9052383c1c4e5569$var$nr(null == $9052383c1c4e5569$var$a ? void 0 : $9052383c1c4e5569$var$a.href, o, $9052383c1c4e5569$var$ss),
        $host: null == $9052383c1c4e5569$var$a ? void 0 : $9052383c1c4e5569$var$a.host,
        $pathname: null == $9052383c1c4e5569$var$a ? void 0 : $9052383c1c4e5569$var$a.pathname,
        $raw_user_agent: $9052383c1c4e5569$var$d.length > 1e3 ? $9052383c1c4e5569$var$d.substring(0, 997) + "..." : $9052383c1c4e5569$var$d,
        $browser_version: $9052383c1c4e5569$var$Vt($9052383c1c4e5569$var$d, navigator.vendor),
        $browser_language: $9052383c1c4e5569$var$us(),
        $browser_language_prefix: (r = $9052383c1c4e5569$var$us(), "string" == typeof r ? r.split("-")[0] : void 0),
        $screen_height: null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.screen.height,
        $screen_width: null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.screen.width,
        $viewport_height: null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.innerHeight,
        $viewport_width: null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.innerWidth,
        $lib: "web",
        $lib_version: $9052383c1c4e5569$var$c.LIB_VERSION,
        $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        $time: Date.now() / 1e3
    });
}
var $9052383c1c4e5569$var$gs = $9052383c1c4e5569$var$Si("[Web Vitals]"), $9052383c1c4e5569$var$_s = 9e5;
class $9052383c1c4e5569$var$ms {
    constructor(t){
        var i;
        this.kt = !1, this.P = !1, this.N = {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }, this.Pt = ()=>{
            clearTimeout(this.Tt), 0 !== this.N.metrics.length && (this._instance.capture("$web_vitals", this.N.metrics.reduce((t, i)=>$9052383c1c4e5569$var$g({}, t, {
                    ["$web_vitals_" + i.name + "_event"]: $9052383c1c4e5569$var$g({}, i),
                    ["$web_vitals_" + i.name + "_value"]: i.value
                }), {})), this.N = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }, this.It = (t)=>{
            var i, e = null == (i = this._instance.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0);
            if ($9052383c1c4e5569$var$O(e)) $9052383c1c4e5569$var$gs.error("Could not read session ID. Dropping metrics!");
            else {
                this.N = this.N || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var r = this.Ct();
                if (!$9052383c1c4e5569$var$O(r)) {
                    if ($9052383c1c4e5569$var$D(null == t ? void 0 : t.name) || $9052383c1c4e5569$var$D(null == t ? void 0 : t.value)) $9052383c1c4e5569$var$gs.error("Invalid metric received", t);
                    else if (this.Rt && t.value >= this.Rt) $9052383c1c4e5569$var$gs.error("Ignoring metric with value >= " + this.Rt, t);
                    else this.N.url !== r && (this.Pt(), this.Tt = setTimeout(this.Pt, this.flushToCaptureTimeoutMs)), $9052383c1c4e5569$var$O(this.N.url) && (this.N.url = r), this.N.firstMetricTimestamp = $9052383c1c4e5569$var$O(this.N.firstMetricTimestamp) ? Date.now() : this.N.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0), this.N.metrics.push($9052383c1c4e5569$var$g({}, t, {
                        $current_url: r,
                        $session_id: e.sessionId,
                        $window_id: e.windowId,
                        timestamp: Date.now()
                    })), this.N.metrics.length === this.allowedMetrics.length && this.Pt();
                }
            }
        }, this.rt = ()=>{
            if (!this.P) {
                var t, i, e, r, s = $9052383c1c4e5569$var$v.__PosthogExtensions__;
                $9052383c1c4e5569$var$O(s) || $9052383c1c4e5569$var$O(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: i, onFCP: e, onINP: r } = s.postHogWebVitalsCallbacks), t && i && e && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.It.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this.It.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && e(this.It.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.It.bind(this)), this.P = !0) : $9052383c1c4e5569$var$gs.error("web vitals callbacks not loaded - not starting");
            }
        }, this._instance = t, this.kt = !(null == (i = this._instance.persistence) || !i.props[$9052383c1c4e5569$var$Yi]), this.startIfEnabled();
    }
    get allowedMetrics() {
        var t, i, e = $9052383c1c4e5569$var$R(this._instance.config.capture_performance) ? null == (t = this._instance.config.capture_performance) ? void 0 : t.web_vitals_allowed_metrics : void 0;
        return $9052383c1c4e5569$var$D(e) ? (null == (i = this._instance.persistence) ? void 0 : i.props[$9052383c1c4e5569$var$Zi]) || [
            "CLS",
            "FCP",
            "INP",
            "LCP"
        ] : e;
    }
    get flushToCaptureTimeoutMs() {
        return ($9052383c1c4e5569$var$R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
    }
    get useAttribution() {
        var t = $9052383c1c4e5569$var$R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_attribution : void 0;
        return null != t && t;
    }
    get Rt() {
        var t = $9052383c1c4e5569$var$R(this._instance.config.capture_performance) && $9052383c1c4e5569$var$L(this._instance.config.capture_performance.__web_vitals_max_value) ? this._instance.config.capture_performance.__web_vitals_max_value : $9052383c1c4e5569$var$_s;
        return 0 < t && t <= 6e4 ? $9052383c1c4e5569$var$_s : t;
    }
    get isEnabled() {
        var t = null == $9052383c1c4e5569$var$a ? void 0 : $9052383c1c4e5569$var$a.protocol;
        if ("http:" !== t && "https:" !== t) return $9052383c1c4e5569$var$gs.info("Web Vitals are disabled on non-http/https protocols"), !1;
        var i = $9052383c1c4e5569$var$R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals : $9052383c1c4e5569$var$U(this._instance.config.capture_performance) ? this._instance.config.capture_performance : void 0;
        return $9052383c1c4e5569$var$U(i) ? i : this.kt;
    }
    startIfEnabled() {
        this.isEnabled && !this.P && ($9052383c1c4e5569$var$gs.info("enabled, starting..."), this.it(this.rt));
    }
    onRemoteConfig(t) {
        var i = $9052383c1c4e5569$var$R(t.capturePerformance) && !!t.capturePerformance.web_vitals, e = $9052383c1c4e5569$var$R(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
        this._instance.persistence && (this._instance.persistence.register({
            [$9052383c1c4e5569$var$Yi]: i
        }), this._instance.persistence.register({
            [$9052383c1c4e5569$var$Zi]: e
        })), this.kt = i, this.startIfEnabled();
    }
    it(t) {
        var i, e;
        if (null != (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) && i.postHogWebVitalsCallbacks) t();
        else {
            var r = this.useAttribution ? "web-vitals-with-attribution" : "web-vitals";
            null == (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, r, (i)=>{
                i ? $9052383c1c4e5569$var$gs.error("failed to load script", i) : t();
            });
        }
    }
    Ct() {
        var i = $9052383c1c4e5569$var$t ? $9052383c1c4e5569$var$t.location.href : void 0;
        if (i) {
            var e = this._instance.config.mask_personal_data_properties, r = this._instance.config.custom_personal_data_properties, s = e ? $9052383c1c4e5569$var$Fi([], $9052383c1c4e5569$var$es, r || []) : [];
            return $9052383c1c4e5569$var$nr(i, s, $9052383c1c4e5569$var$ss);
        }
        $9052383c1c4e5569$var$gs.error("Could not determine current URL");
    }
}
var $9052383c1c4e5569$var$bs = $9052383c1c4e5569$var$Si("[Heatmaps]");
function $9052383c1c4e5569$var$ys(t) {
    return $9052383c1c4e5569$var$R(t) && "clientX" in t && "clientY" in t && $9052383c1c4e5569$var$L(t.clientX) && $9052383c1c4e5569$var$L(t.clientY);
}
class $9052383c1c4e5569$var$ws {
    constructor(t){
        var i;
        this.kt = !1, this.P = !1, this.Ft = null, this.instance = t, this.kt = !(null == (i = this.instance.persistence) || !i.props[$9052383c1c4e5569$var$Gi]), this.rageclicks = new $9052383c1c4e5569$var$ir(t.config.rageclick);
    }
    get flushIntervalMilliseconds() {
        var t = 5e3;
        return $9052383c1c4e5569$var$R(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
    }
    get isEnabled() {
        return $9052383c1c4e5569$var$D(this.instance.config.capture_heatmaps) ? $9052383c1c4e5569$var$D(this.instance.config.enable_heatmaps) ? this.kt : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
    }
    startIfEnabled() {
        if (this.isEnabled) {
            if (this.P) return;
            $9052383c1c4e5569$var$bs.info("starting..."), this.Ot(), this.Mt();
        } else {
            var t;
            clearInterval(null !== (t = this.Ft) && void 0 !== t ? t : void 0), this.At(), this.getAndClearBuffer();
        }
    }
    onRemoteConfig(t) {
        var i = !!t.heatmaps;
        this.instance.persistence && this.instance.persistence.register({
            [$9052383c1c4e5569$var$Gi]: i
        }), this.kt = i, this.startIfEnabled();
    }
    getAndClearBuffer() {
        var t = this.N;
        return this.N = void 0, t;
    }
    jt(t) {
        this.Dt(t.originalEvent, "deadclick");
    }
    Mt() {
        this.Ft && clearInterval(this.Ft), this.Ft = function(t) {
            return "visible" === (null == t ? void 0 : t.visibilityState);
        }($9052383c1c4e5569$var$o) ? setInterval(this.Lt.bind(this), this.flushIntervalMilliseconds) : null;
    }
    Ot() {
        $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$o && (this.Nt = this.Lt.bind(this), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$t, "beforeunload", this.Nt), this.Ut = (i)=>this.Dt(i || (null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.event)), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$o, "click", this.Ut, {
            capture: !0
        }), this.zt = (i)=>this.Ht(i || (null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.event)), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$o, "mousemove", this.zt, {
            capture: !0
        }), this.Bt = new $9052383c1c4e5569$var$Lr(this.instance, $9052383c1c4e5569$var$jr, this.jt.bind(this)), this.Bt.startIfEnabled(), this.qt = this.Mt.bind(this), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$o, "visibilitychange", this.qt), this.P = !0);
    }
    At() {
        var i;
        $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$o && (this.Nt && $9052383c1c4e5569$var$t.removeEventListener("beforeunload", this.Nt), this.Ut && $9052383c1c4e5569$var$o.removeEventListener("click", this.Ut, {
            capture: !0
        }), this.zt && $9052383c1c4e5569$var$o.removeEventListener("mousemove", this.zt, {
            capture: !0
        }), this.qt && $9052383c1c4e5569$var$o.removeEventListener("visibilitychange", this.qt), clearTimeout(this.Wt), null == (i = this.Bt) || i.stop(), this.P = !1);
    }
    Gt(i, e) {
        var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(i, e, r) {
            for(var s = i; s && $9052383c1c4e5569$var$we(s) && !$9052383c1c4e5569$var$xe(s, "body");){
                if (s === r) return !1;
                if ($9052383c1c4e5569$var$w(e, null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.getComputedStyle(s).position)) return !0;
                s = $9052383c1c4e5569$var$Oe(s);
            }
            return !1;
        }($9052383c1c4e5569$var$Ce(i), [
            "fixed",
            "sticky"
        ], n);
        return {
            x: i.clientX + (o ? 0 : s),
            y: i.clientY + (o ? 0 : r),
            target_fixed: o,
            type: e
        };
    }
    Dt(t, i) {
        var e;
        if (void 0 === i && (i = "click"), !$9052383c1c4e5569$var$ye(t.target) && $9052383c1c4e5569$var$ys(t)) {
            var r = this.Gt(t, i);
            null != (e = this.rageclicks) && e.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.Vt($9052383c1c4e5569$var$g({}, r, {
                type: "rageclick"
            })), this.Vt(r);
        }
    }
    Ht(t) {
        !$9052383c1c4e5569$var$ye(t.target) && $9052383c1c4e5569$var$ys(t) && (clearTimeout(this.Wt), this.Wt = setTimeout(()=>{
            this.Vt(this.Gt(t, "mousemove"));
        }, 500));
    }
    Vt(i) {
        if ($9052383c1c4e5569$var$t) {
            var e = $9052383c1c4e5569$var$t.location.href, r = this.instance.config.mask_personal_data_properties, s = this.instance.config.custom_personal_data_properties, n = r ? $9052383c1c4e5569$var$Fi([], $9052383c1c4e5569$var$es, s || []) : [], o = $9052383c1c4e5569$var$nr(e, n, $9052383c1c4e5569$var$ss);
            this.N = this.N || {}, this.N[o] || (this.N[o] = []), this.N[o].push(i);
        }
    }
    Lt() {
        this.N && !$9052383c1c4e5569$var$F(this.N) && this.instance.capture("$$heatmap", {
            $heatmap_data: this.getAndClearBuffer()
        });
    }
}
class $9052383c1c4e5569$var$xs {
    constructor(t){
        this.Jt = (t, i, e)=>{
            e && (e.noSessionId || e.activityTimeout || e.sessionPastMaximumLength) && ($9052383c1c4e5569$var$$i.info("[PageViewManager] Session rotated, clearing pageview state", {
                sessionId: t,
                changeReason: e
            }), this.Kt = void 0, this._instance.scrollManager.resetContext());
        }, this._instance = t, this.Yt();
    }
    Yt() {
        var t;
        this.Xt = null == (t = this._instance.sessionManager) ? void 0 : t.onSessionId(this.Jt);
    }
    destroy() {
        var t;
        null == (t = this.Xt) || t.call(this), this.Xt = void 0;
    }
    doPageView(i, e) {
        var r, s = this.Qt(i, e);
        return this.Kt = {
            pathname: null !== (r = null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.location.pathname) && void 0 !== r ? r : "",
            pageViewId: e,
            timestamp: i
        }, this._instance.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var i;
        return this.Qt(t, null == (i = this.Kt) ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.Kt) ? void 0 : t.pageViewId
        };
    }
    Qt(t, i) {
        var e = this.Kt;
        if (!e) return {
            $pageview_id: i
        };
        var r = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        }, s = this._instance.scrollManager.getContext();
        if (s && !this._instance.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: u, maxContentY: h } = s;
            if (!($9052383c1c4e5569$var$O(n) || $9052383c1c4e5569$var$O(o) || $9052383c1c4e5569$var$O(a) || $9052383c1c4e5569$var$O(l) || $9052383c1c4e5569$var$O(u) || $9052383c1c4e5569$var$O(h))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), h = Math.ceil(h);
                var d = n <= 1 ? 1 : $9052383c1c4e5569$var$K(o / n, 0, 1, $9052383c1c4e5569$var$$i), v = n <= 1 ? 1 : $9052383c1c4e5569$var$K(a / n, 0, 1, $9052383c1c4e5569$var$$i), c = l <= 1 ? 1 : $9052383c1c4e5569$var$K(u / l, 0, 1, $9052383c1c4e5569$var$$i), f = l <= 1 ? 1 : $9052383c1c4e5569$var$K(h / l, 0, 1, $9052383c1c4e5569$var$$i);
                r = $9052383c1c4e5569$var$Ri(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: h,
                    $prev_pageview_max_content_percentage: f
                });
            }
        }
        return e.pathname && (r.$prev_pageview_pathname = e.pathname), e.timestamp && (r.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), r;
    }
}
var $9052383c1c4e5569$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $9052383c1c4e5569$export$6a00d17b5aff0af = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({}), $9052383c1c4e5569$var$Ss = Uint8Array, $9052383c1c4e5569$var$ks = Uint16Array, $9052383c1c4e5569$var$Ps = Uint32Array, $9052383c1c4e5569$var$Ts = new $9052383c1c4e5569$var$Ss([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $9052383c1c4e5569$var$Is = new $9052383c1c4e5569$var$Ss([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $9052383c1c4e5569$var$Cs = new $9052383c1c4e5569$var$Ss([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $9052383c1c4e5569$var$Rs = function(t, i) {
    for(var e = new $9052383c1c4e5569$var$ks(31), r = 0; r < 31; ++r)e[r] = i += 1 << t[r - 1];
    var s = new $9052383c1c4e5569$var$Ps(e[30]);
    for(r = 1; r < 30; ++r)for(var n = e[r]; n < e[r + 1]; ++n)s[n] = n - e[r] << 5 | r;
    return [
        e,
        s
    ];
}, $9052383c1c4e5569$var$Fs = $9052383c1c4e5569$var$Rs($9052383c1c4e5569$var$Ts, 2), $9052383c1c4e5569$var$Os = $9052383c1c4e5569$var$Fs[0], $9052383c1c4e5569$var$Ms = $9052383c1c4e5569$var$Fs[1];
$9052383c1c4e5569$var$Os[28] = 258, $9052383c1c4e5569$var$Ms[258] = 28;
for(var $9052383c1c4e5569$var$As = $9052383c1c4e5569$var$Rs($9052383c1c4e5569$var$Is, 0)[1], $9052383c1c4e5569$var$js = new $9052383c1c4e5569$var$ks(32768), $9052383c1c4e5569$var$Ds = 0; $9052383c1c4e5569$var$Ds < 32768; ++$9052383c1c4e5569$var$Ds){
    var $9052383c1c4e5569$var$Ls = (43690 & $9052383c1c4e5569$var$Ds) >>> 1 | (21845 & $9052383c1c4e5569$var$Ds) << 1;
    $9052383c1c4e5569$var$Ls = (61680 & ($9052383c1c4e5569$var$Ls = (52428 & $9052383c1c4e5569$var$Ls) >>> 2 | (13107 & $9052383c1c4e5569$var$Ls) << 2)) >>> 4 | (3855 & $9052383c1c4e5569$var$Ls) << 4, $9052383c1c4e5569$var$js[$9052383c1c4e5569$var$Ds] = ((65280 & $9052383c1c4e5569$var$Ls) >>> 8 | (255 & $9052383c1c4e5569$var$Ls) << 8) >>> 1;
}
var $9052383c1c4e5569$var$Ns = function(t, i, e) {
    for(var r = t.length, s = 0, n = new $9052383c1c4e5569$var$ks(i); s < r; ++s)++n[t[s] - 1];
    var o, a = new $9052383c1c4e5569$var$ks(i);
    for(s = 0; s < i; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (e) {
        o = new $9052383c1c4e5569$var$ks(1 << i);
        var l = 15 - i;
        for(s = 0; s < r; ++s)if (t[s]) for(var u = s << 4 | t[s], h = i - t[s], d = a[t[s] - 1]++ << h, v = d | (1 << h) - 1; d <= v; ++d)o[$9052383c1c4e5569$var$js[d] >>> l] = u;
    } else for(o = new $9052383c1c4e5569$var$ks(r), s = 0; s < r; ++s)o[s] = $9052383c1c4e5569$var$js[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $9052383c1c4e5569$var$Us = new $9052383c1c4e5569$var$Ss(288);
for($9052383c1c4e5569$var$Ds = 0; $9052383c1c4e5569$var$Ds < 144; ++$9052383c1c4e5569$var$Ds)$9052383c1c4e5569$var$Us[$9052383c1c4e5569$var$Ds] = 8;
for($9052383c1c4e5569$var$Ds = 144; $9052383c1c4e5569$var$Ds < 256; ++$9052383c1c4e5569$var$Ds)$9052383c1c4e5569$var$Us[$9052383c1c4e5569$var$Ds] = 9;
for($9052383c1c4e5569$var$Ds = 256; $9052383c1c4e5569$var$Ds < 280; ++$9052383c1c4e5569$var$Ds)$9052383c1c4e5569$var$Us[$9052383c1c4e5569$var$Ds] = 7;
for($9052383c1c4e5569$var$Ds = 280; $9052383c1c4e5569$var$Ds < 288; ++$9052383c1c4e5569$var$Ds)$9052383c1c4e5569$var$Us[$9052383c1c4e5569$var$Ds] = 8;
var $9052383c1c4e5569$var$zs = new $9052383c1c4e5569$var$Ss(32);
for($9052383c1c4e5569$var$Ds = 0; $9052383c1c4e5569$var$Ds < 32; ++$9052383c1c4e5569$var$Ds)$9052383c1c4e5569$var$zs[$9052383c1c4e5569$var$Ds] = 5;
var $9052383c1c4e5569$var$Hs = $9052383c1c4e5569$var$Ns($9052383c1c4e5569$var$Us, 9, 0), $9052383c1c4e5569$var$Bs = $9052383c1c4e5569$var$Ns($9052383c1c4e5569$var$zs, 5, 0), $9052383c1c4e5569$var$qs = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $9052383c1c4e5569$var$Ws = function(t, i, e) {
    (null == e || e > t.length) && (e = t.length);
    var r = new (t instanceof $9052383c1c4e5569$var$ks ? $9052383c1c4e5569$var$ks : t instanceof $9052383c1c4e5569$var$Ps ? $9052383c1c4e5569$var$Ps : $9052383c1c4e5569$var$Ss)(e - i);
    return r.set(t.subarray(i, e)), r;
}, $9052383c1c4e5569$var$Gs = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8;
}, $9052383c1c4e5569$var$Vs = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8, t[r + 2] |= e >>> 16;
}, $9052383c1c4e5569$var$Js = function(t, i) {
    for(var e = [], r = 0; r < t.length; ++r)t[r] && e.push({
        s: r,
        f: t[r]
    });
    var s = e.length, n = e.slice();
    if (!s) return [
        new $9052383c1c4e5569$var$Ss(0),
        0
    ];
    if (1 == s) {
        var o = new $9052383c1c4e5569$var$Ss(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var a = e[0], l = e[1], u = 0, h = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; h != s - 1;)a = e[e[u].f < e[d].f ? u++ : d++], l = e[u != h && e[u].f < e[d].f ? u++ : d++], e[h++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; r < s; ++r)n[r].s > v && (v = n[r].s);
    var c = new $9052383c1c4e5569$var$ks(v + 1), f = $9052383c1c4e5569$var$Ks(e[h - 1], c, 0);
    if (f > i) {
        r = 0;
        var p = 0, g = f - i, _ = 1 << g;
        for(n.sort(function(t, i) {
            return c[i.s] - c[t.s] || t.f - i.f;
        }); r < s; ++r){
            var m = n[r].s;
            if (!(c[m] > i)) break;
            p += _ - (1 << f - c[m]), c[m] = i;
        }
        for(p >>>= g; p > 0;){
            var b = n[r].s;
            c[b] < i ? p -= 1 << i - c[b]++ - 1 : ++r;
        }
        for(; r >= 0 && p; --r){
            var y = n[r].s;
            c[y] == i && (--c[y], ++p);
        }
        f = i;
    }
    return [
        new $9052383c1c4e5569$var$Ss(c),
        f
    ];
}, $9052383c1c4e5569$var$Ks = function(t, i, e) {
    return -1 == t.s ? Math.max($9052383c1c4e5569$var$Ks(t.l, i, e + 1), $9052383c1c4e5569$var$Ks(t.r, i, e + 1)) : i[t.s] = e;
}, $9052383c1c4e5569$var$Ys = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new $9052383c1c4e5569$var$ks(++i), r = 0, s = t[0], n = 1, o = function(t) {
        e[r++] = t;
    }, a = 1; a <= i; ++a)if (t[a] == s && a != i) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        e.subarray(0, r),
        i
    ];
}, $9052383c1c4e5569$var$Xs = function(t, i) {
    for(var e = 0, r = 0; r < i.length; ++r)e += t[r] * i[r];
    return e;
}, $9052383c1c4e5569$var$Qs = function(t, i, e) {
    var r = e.length, s = $9052383c1c4e5569$var$qs(i + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; n < r; ++n)t[s + n + 4] = e[n];
    return 8 * (s + 4 + r);
}, $9052383c1c4e5569$var$Zs = function(t, i, e, r, s, n, o, a, l, u, h) {
    $9052383c1c4e5569$var$Gs(i, h++, e), ++s[256];
    for(var d = $9052383c1c4e5569$var$Js(s, 15), v = d[0], c = d[1], f = $9052383c1c4e5569$var$Js(n, 15), p = f[0], g = f[1], _ = $9052383c1c4e5569$var$Ys(v), m = _[0], b = _[1], y = $9052383c1c4e5569$var$Ys(p), w = y[0], x = y[1], E = new $9052383c1c4e5569$var$ks(19), S = 0; S < m.length; ++S)E[31 & m[S]]++;
    for(S = 0; S < w.length; ++S)E[31 & w[S]]++;
    for(var k = $9052383c1c4e5569$var$Js(E, 7), P = k[0], T = k[1], I = 19; I > 4 && !P[$9052383c1c4e5569$var$Cs[I - 1]]; --I);
    var C, R, F, O, M = u + 5 << 3, A = $9052383c1c4e5569$var$Xs(s, $9052383c1c4e5569$var$Us) + $9052383c1c4e5569$var$Xs(n, $9052383c1c4e5569$var$zs) + o, j = $9052383c1c4e5569$var$Xs(s, v) + $9052383c1c4e5569$var$Xs(n, p) + o + 14 + 3 * I + $9052383c1c4e5569$var$Xs(E, P) + (2 * E[16] + 3 * E[17] + 7 * E[18]);
    if (M <= A && M <= j) return $9052383c1c4e5569$var$Qs(i, h, t.subarray(l, l + u));
    if ($9052383c1c4e5569$var$Gs(i, h, 1 + (j < A)), h += 2, j < A) {
        C = $9052383c1c4e5569$var$Ns(v, c, 0), R = v, F = $9052383c1c4e5569$var$Ns(p, g, 0), O = p;
        var D = $9052383c1c4e5569$var$Ns(P, T, 0);
        $9052383c1c4e5569$var$Gs(i, h, b - 257), $9052383c1c4e5569$var$Gs(i, h + 5, x - 1), $9052383c1c4e5569$var$Gs(i, h + 10, I - 4), h += 14;
        for(S = 0; S < I; ++S)$9052383c1c4e5569$var$Gs(i, h + 3 * S, P[$9052383c1c4e5569$var$Cs[S]]);
        h += 3 * I;
        for(var L = [
            m,
            w
        ], N = 0; N < 2; ++N){
            var U = L[N];
            for(S = 0; S < U.length; ++S){
                var z = 31 & U[S];
                $9052383c1c4e5569$var$Gs(i, h, D[z]), h += P[z], z > 15 && ($9052383c1c4e5569$var$Gs(i, h, U[S] >>> 5 & 127), h += U[S] >>> 12);
            }
        }
    } else C = $9052383c1c4e5569$var$Hs, R = $9052383c1c4e5569$var$Us, F = $9052383c1c4e5569$var$Bs, O = $9052383c1c4e5569$var$zs;
    for(S = 0; S < a; ++S)if (r[S] > 255) {
        z = r[S] >>> 18 & 31;
        $9052383c1c4e5569$var$Vs(i, h, C[z + 257]), h += R[z + 257], z > 7 && ($9052383c1c4e5569$var$Gs(i, h, r[S] >>> 23 & 31), h += $9052383c1c4e5569$var$Ts[z]);
        var H = 31 & r[S];
        $9052383c1c4e5569$var$Vs(i, h, F[H]), h += O[H], H > 3 && ($9052383c1c4e5569$var$Vs(i, h, r[S] >>> 5 & 8191), h += $9052383c1c4e5569$var$Is[H]);
    } else $9052383c1c4e5569$var$Vs(i, h, C[r[S]]), h += R[r[S]];
    return $9052383c1c4e5569$var$Vs(i, h, C[256]), h + R[256];
}, $9052383c1c4e5569$var$tn = new $9052383c1c4e5569$var$Ps([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $9052383c1c4e5569$var$en = function() {
    for(var t = new $9052383c1c4e5569$var$Ps(256), i = 0; i < 256; ++i){
        for(var e = i, r = 9; --r;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), $9052383c1c4e5569$var$rn = function(t, i, e, r, s) {
    return function(t, i, e, r, s, n) {
        var o = t.length, a = new $9052383c1c4e5569$var$Ss(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), u = 0;
        if (!i || o < 8) for(var h = 0; h <= o; h += 65535){
            var d = h + 65535;
            d < o ? u = $9052383c1c4e5569$var$Qs(l, u, t.subarray(h, d)) : (l[h] = n, u = $9052383c1c4e5569$var$Qs(l, u, t.subarray(h, o)));
        }
        else {
            for(var v = $9052383c1c4e5569$var$tn[i - 1], c = v >>> 13, f = 8191 & v, p = (1 << e) - 1, g = new $9052383c1c4e5569$var$ks(32768), _ = new $9052383c1c4e5569$var$ks(p + 1), m = Math.ceil(e / 3), b = 2 * m, y = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << b) & p;
            }, w = new $9052383c1c4e5569$var$Ps(25e3), x = new $9052383c1c4e5569$var$ks(288), E = new $9052383c1c4e5569$var$ks(32), S = 0, k = 0, P = (h = 0, 0), T = 0, I = 0; h < o; ++h){
                var C = y(h), R = 32767 & h, F = _[C];
                if (g[R] = F, _[C] = R, T <= h) {
                    var O = o - h;
                    if ((S > 7e3 || P > 24576) && O > 423) {
                        u = $9052383c1c4e5569$var$Zs(t, l, 0, w, x, E, k, P, I, h - I, u), P = S = k = 0, I = h;
                        for(var M = 0; M < 286; ++M)x[M] = 0;
                        for(M = 0; M < 30; ++M)E[M] = 0;
                    }
                    var A = 2, j = 0, D = f, L = R - F & 32767;
                    if (O > 2 && C == y(h - L)) for(var N = Math.min(c, O) - 1, U = Math.min(32767, h), z = Math.min(258, O); L <= U && --D && R != F;){
                        if (t[h + A] == t[h + A - L]) {
                            for(var H = 0; H < z && t[h + H] == t[h + H - L]; ++H);
                            if (H > A) {
                                if (A = H, j = L, H > N) break;
                                var B = Math.min(L, H - 2), q = 0;
                                for(M = 0; M < B; ++M){
                                    var W = h - L + M + 32768 & 32767, G = W - g[W] + 32768 & 32767;
                                    G > q && (q = G, F = W);
                                }
                            }
                        }
                        L += (R = F) - (F = g[R]) + 32768 & 32767;
                    }
                    if (j) {
                        w[P++] = 268435456 | $9052383c1c4e5569$var$Ms[A] << 18 | $9052383c1c4e5569$var$As[j];
                        var V = 31 & $9052383c1c4e5569$var$Ms[A], J = 31 & $9052383c1c4e5569$var$As[j];
                        k += $9052383c1c4e5569$var$Ts[V] + $9052383c1c4e5569$var$Is[J], ++x[257 + V], ++E[J], T = h + A, ++S;
                    } else w[P++] = t[h], ++x[t[h]];
                }
            }
            u = $9052383c1c4e5569$var$Zs(t, l, n, w, x, E, k, P, I, h - I, u);
        }
        return $9052383c1c4e5569$var$Ws(a, 0, r + $9052383c1c4e5569$var$qs(u) + s);
    }(t, null == i.level ? 6 : i.level, null == i.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + i.mem, e, r, !0);
}, $9052383c1c4e5569$var$sn = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
};
function $9052383c1c4e5569$var$nn(t, i) {
    void 0 === i && (i = {});
    var e = function() {
        var t = 4294967295;
        return {
            p: function(i) {
                for(var e = t, r = 0; r < i.length; ++r)e = $9052383c1c4e5569$var$en[255 & e ^ i[r]] ^ e >>> 8;
                t = e;
            },
            d: function() {
                return 4294967295 ^ t;
            }
        };
    }(), r = t.length;
    e.p(t);
    var s, n = $9052383c1c4e5569$var$rn(t, i, 10 + ((s = i).filename && s.filename.length + 1 || 0), 8), o = n.length;
    return function(t, i) {
        var e = i.filename;
        if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = i.level < 2 ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && $9052383c1c4e5569$var$sn(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
            t[3] = 8;
            for(var r = 0; r <= e.length; ++r)t[r + 10] = e.charCodeAt(r);
        }
    }(n, i), $9052383c1c4e5569$var$sn(n, o - 8, e.d()), $9052383c1c4e5569$var$sn(n, o - 4, r), n;
}
var $9052383c1c4e5569$var$on = function(t) {
    var i, e, r, s, n = "";
    for(i = e = 0, r = (t = (t + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, s = 0; s < r; s++){
        var o = t.charCodeAt(s), a = null;
        o < 128 ? e++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $9052383c1c4e5569$var$j(a) || (e > i && (n += t.substring(i, e)), n += a, i = e = s + 1);
    }
    return e > i && (n += t.substring(i, t.length)), n;
}, $9052383c1c4e5569$var$an = !!$9052383c1c4e5569$var$u || !!$9052383c1c4e5569$var$l, $9052383c1c4e5569$var$ln = "text/plain", $9052383c1c4e5569$var$un = function(t, i, e) {
    var r;
    void 0 === e && (e = !0);
    var [s, n] = t.split("?"), o = $9052383c1c4e5569$var$g({}, i), a = null !== (r = null == n ? void 0 : n.split("&").map((t)=>{
        var i, [r, s] = t.split("="), n = e && null !== (i = o[r]) && void 0 !== i ? i : s;
        return delete o[r], r + "=" + n;
    })) && void 0 !== r ? r : [], l = $9052383c1c4e5569$var$rr(o);
    return l && a.push(l), s + "?" + a.join("&");
}, $9052383c1c4e5569$var$hn = (t, i)=>JSON.stringify(t, (t, i)=>"bigint" == typeof i ? i.toString() : i, i), $9052383c1c4e5569$var$dn = (t)=>{
    var { data: i, compression: e } = t;
    if (i) {
        if (e === $9052383c1c4e5569$export$6a00d17b5aff0af.GZipJS) {
            var r = $9052383c1c4e5569$var$nn(function(t, i) {
                var e = t.length;
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
                for(var r = new $9052383c1c4e5569$var$Ss(t.length + (t.length >>> 1)), s = 0, n = function(t) {
                    r[s++] = t;
                }, o = 0; o < e; ++o){
                    if (s + 5 > r.length) {
                        var a = new $9052383c1c4e5569$var$Ss(s + 8 + (e - o << 1));
                        a.set(r), r = a;
                    }
                    var l = t.charCodeAt(o);
                    l < 128 || i ? n(l) : l < 2048 ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && l < 57344 ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
                }
                return $9052383c1c4e5569$var$Ws(r, 0, s);
            }($9052383c1c4e5569$var$hn(i)), {
                mtime: 0
            }), s = new Blob([
                r
            ], {
                type: $9052383c1c4e5569$var$ln
            });
            return {
                contentType: $9052383c1c4e5569$var$ln,
                body: s,
                estimatedSize: s.size
            };
        }
        if (e === $9052383c1c4e5569$export$6a00d17b5aff0af.Base64) {
            var n = function(t) {
                var i, e, r, s, n, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, l = 0, u = "", h = [];
                if (!t) return t;
                t = $9052383c1c4e5569$var$on(t);
                do i = (n = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, e = n >> 12 & 63, r = n >> 6 & 63, s = 63 & n, h[l++] = o.charAt(i) + o.charAt(e) + o.charAt(r) + o.charAt(s);
                while (a < t.length);
                switch(u = h.join(""), t.length % 3){
                    case 1:
                        u = u.slice(0, -2) + "==";
                        break;
                    case 2:
                        u = u.slice(0, -1) + "=";
                }
                return u;
            }($9052383c1c4e5569$var$hn(i)), o = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $9052383c1c4e5569$var$hn(t)))(n);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: o,
                estimatedSize: new Blob([
                    o
                ]).size
            };
        }
        var a = $9052383c1c4e5569$var$hn(i);
        return {
            contentType: "application/json",
            body: a,
            estimatedSize: new Blob([
                a
            ]).size
        };
    }
}, $9052383c1c4e5569$var$vn = [];
$9052383c1c4e5569$var$l && $9052383c1c4e5569$var$vn.push({
    transport: "fetch",
    method: (t)=>{
        var i, e, { contentType: r, body: s, estimatedSize: n } = null !== (i = $9052383c1c4e5569$var$dn(t)) && void 0 !== i ? i : {}, o = new Headers;
        $9052383c1c4e5569$var$Ci(t.headers, function(t, i) {
            o.append(i, t);
        }), r && o.append("Content-Type", r);
        var a = t.url, u = null;
        if ($9052383c1c4e5569$var$h) {
            var d = new $9052383c1c4e5569$var$h;
            u = {
                signal: d.signal,
                timeout: setTimeout(()=>d.abort(), t.timeout)
            };
        }
        $9052383c1c4e5569$var$l(a, $9052383c1c4e5569$var$g({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: o,
            keepalive: "POST" === t.method && (n || 0) < 52428.8,
            body: s,
            signal: null == (e = u) ? void 0 : e.signal
        }, t.fetchOptions)).then((i)=>i.text().then((e)=>{
                var r = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    r.json = JSON.parse(e);
                } catch (t) {
                    $9052383c1c4e5569$var$$i.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((i)=>{
            $9052383c1c4e5569$var$$i.error(i), null == t.callback || t.callback({
                statusCode: 0,
                text: i
            });
        }).finally(()=>u ? clearTimeout(u.timeout) : null);
    }
}), $9052383c1c4e5569$var$u && $9052383c1c4e5569$var$vn.push({
    transport: "XHR",
    method: (t)=>{
        var i, e = new $9052383c1c4e5569$var$u;
        e.open(t.method || "GET", t.url, !0);
        var { contentType: r, body: s } = null !== (i = $9052383c1c4e5569$var$dn(t)) && void 0 !== i ? i : {};
        $9052383c1c4e5569$var$Ci(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), t.disableXHRCredentials || (e.withCredentials = !0), e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(s);
    }
}), null != $9052383c1c4e5569$var$n && $9052383c1c4e5569$var$n.sendBeacon && $9052383c1c4e5569$var$vn.push({
    transport: "sendBeacon",
    method: (t)=>{
        var i = $9052383c1c4e5569$var$un(t.url, {
            beacon: "1"
        });
        try {
            var e, { contentType: r, body: s } = null !== (e = $9052383c1c4e5569$var$dn(t)) && void 0 !== e ? e : {}, o = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            $9052383c1c4e5569$var$n.sendBeacon(i, o);
        } catch (t) {}
    }
});
var $9052383c1c4e5569$var$cn = function(t, i) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
};
function $9052383c1c4e5569$var$fn(t, i, e) {
    return $9052383c1c4e5569$var$hn({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
var $9052383c1c4e5569$var$pn = {
    exact: (t, i)=>i.some((i)=>t.some((t)=>i === t)),
    is_not: (t, i)=>i.every((i)=>t.every((t)=>i !== t)),
    regex: (t, i)=>i.some((i)=>t.some((t)=>$9052383c1c4e5569$var$cn(i, t))),
    not_regex: (t, i)=>i.every((i)=>t.every((t)=>!$9052383c1c4e5569$var$cn(i, t))),
    icontains: (t, i)=>i.map($9052383c1c4e5569$var$gn).some((i)=>t.map($9052383c1c4e5569$var$gn).some((t)=>i.includes(t))),
    not_icontains: (t, i)=>i.map($9052383c1c4e5569$var$gn).every((i)=>t.map($9052383c1c4e5569$var$gn).every((t)=>!i.includes(t))),
    gt: (t, i)=>i.some((i)=>{
            var e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e > parseFloat(t));
        }),
    lt: (t, i)=>i.some((i)=>{
            var e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e < parseFloat(t));
        })
}, $9052383c1c4e5569$var$gn = (t)=>t.toLowerCase();
function $9052383c1c4e5569$var$_n(t, i) {
    return !t || Object.entries(t).every((t)=>{
        var [e, r] = t, s = null == i ? void 0 : i[e];
        if ($9052383c1c4e5569$var$O(s) || $9052383c1c4e5569$var$j(s)) return !1;
        var n = [
            String(s)
        ], o = $9052383c1c4e5569$var$pn[r.operator];
        return !!o && o(r.values, n);
    });
}
var $9052383c1c4e5569$var$mn = $9052383c1c4e5569$var$Si("[Error tracking]");
class $9052383c1c4e5569$var$bn {
    constructor(t){
        var i, e;
        this.Zt = [], this.ti = new $9052383c1c4e5569$var$Qt([
            new $9052383c1c4e5569$var$vi,
            new $9052383c1c4e5569$var$xi,
            new $9052383c1c4e5569$var$fi,
            new $9052383c1c4e5569$var$ci,
            new $9052383c1c4e5569$var$yi,
            new $9052383c1c4e5569$var$bi,
            new $9052383c1c4e5569$var$gi,
            new $9052383c1c4e5569$var$wi
        ], $9052383c1c4e5569$var$di()), this._instance = t, this.Zt = null !== (i = null == (e = this._instance.persistence) ? void 0 : e.get_property($9052383c1c4e5569$var$Ji)) && void 0 !== i ? i : [];
    }
    onRemoteConfig(t) {
        var i, e, r, s = null !== (i = null == (e = t.errorTracking) ? void 0 : e.suppressionRules) && void 0 !== i ? i : [], n = null == (r = t.errorTracking) ? void 0 : r.captureExtensionExceptions;
        this.Zt = s, this._instance.persistence && this._instance.persistence.register({
            [$9052383c1c4e5569$var$Ji]: this.Zt,
            [$9052383c1c4e5569$var$Ki]: n
        });
    }
    get ii() {
        var t, i = !!this._instance.get_property($9052383c1c4e5569$var$Ki), e = this._instance.config.error_tracking.captureExtensionExceptions;
        return null !== (t = null != e ? e : i) && void 0 !== t && t;
    }
    buildProperties(t, i) {
        return this.ti.buildFromUnknown(t, {
            syntheticException: null == i ? void 0 : i.syntheticException,
            mechanism: {
                handled: null == i ? void 0 : i.handled
            }
        });
    }
    sendExceptionEvent(t) {
        var i = t.$exception_list;
        if (this.ei(i)) {
            if (this.ri(i)) return void $9052383c1c4e5569$var$mn.info("Skipping exception capture because a suppression rule matched");
            if (!this.ii && this.si(i)) return void $9052383c1c4e5569$var$mn.info("Skipping exception capture because it was thrown by an extension");
            if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.ni(i)) return void $9052383c1c4e5569$var$mn.info("Skipping exception capture because it was thrown by the PostHog SDK");
        }
        return this._instance.capture("$exception", t, {
            _noTruncate: !0,
            _batchKey: "exceptionEvent"
        });
    }
    ri(t) {
        if (0 === t.length) return !1;
        var i = t.reduce((t, i)=>{
            var { type: e, value: r } = i;
            return $9052383c1c4e5569$var$M(e) && e.length > 0 && t.$exception_types.push(e), $9052383c1c4e5569$var$M(r) && r.length > 0 && t.$exception_values.push(r), t;
        }, {
            $exception_types: [],
            $exception_values: []
        });
        return this.Zt.some((t)=>{
            var e = t.values.map((t)=>{
                var e, r = $9052383c1c4e5569$var$pn[t.operator], s = $9052383c1c4e5569$var$I(t.value) ? t.value : [
                    t.value
                ], n = null !== (e = i[t.key]) && void 0 !== e ? e : [];
                return s.length > 0 && r(s, n);
            });
            return "OR" === t.type ? e.some(Boolean) : e.every(Boolean);
        });
    }
    si(t) {
        return t.flatMap((t)=>{
            var i, e;
            return null !== (i = null == (e = t.stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [];
        }).some((t)=>t.filename && t.filename.startsWith("chrome-extension://"));
    }
    ni(t) {
        if (t.length > 0) {
            var i, e, r, s, n = null !== (i = null == (e = t[0].stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [], o = n[n.length - 1];
            return null !== (r = null == o || null == (s = o.filename) ? void 0 : s.includes("posthog.com/static")) && void 0 !== r && r;
        }
        return !1;
    }
    ei(t) {
        return !$9052383c1c4e5569$var$D(t) && $9052383c1c4e5569$var$I(t);
    }
}
var $9052383c1c4e5569$var$yn = $9052383c1c4e5569$var$Si("[FeatureFlags]"), $9052383c1c4e5569$var$wn = $9052383c1c4e5569$var$Si("[FeatureFlags]", {
    debugEnabled: !0
}), $9052383c1c4e5569$var$xn = "$active_feature_flags", $9052383c1c4e5569$var$En = "$override_feature_flags", $9052383c1c4e5569$var$$n = "$feature_flag_payloads", $9052383c1c4e5569$var$Sn = "$override_feature_flag_payloads", $9052383c1c4e5569$var$kn = "$feature_flag_request_id", $9052383c1c4e5569$var$Pn = "$feature_flag_evaluated_at", $9052383c1c4e5569$var$Tn = (t)=>{
    var i = {};
    for (var [e, r] of $9052383c1c4e5569$var$Oi(t || {}))r && (i[e] = r);
    return i;
}, $9052383c1c4e5569$var$In = (t)=>{
    var i = t.flags;
    return i ? (t.featureFlags = Object.fromEntries(Object.keys(i).map((t)=>{
        var e;
        return [
            t,
            null !== (e = i[t].variant) && void 0 !== e ? e : i[t].enabled
        ];
    })), t.featureFlagPayloads = Object.fromEntries(Object.keys(i).filter((t)=>i[t].enabled).filter((t)=>{
        var e;
        return null == (e = i[t].metadata) ? void 0 : e.payload;
    }).map((t)=>{
        var e;
        return [
            t,
            null == (e = i[t].metadata) ? void 0 : e.payload
        ];
    }))) : $9052383c1c4e5569$var$yn.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
}, $9052383c1c4e5569$var$Cn = function(t) {
    return t.FeatureFlags = "feature_flags", t.Recordings = "recordings", t;
}({});
class $9052383c1c4e5569$var$Rn {
    constructor(t){
        this.oi = !1, this.ai = !1, this.li = !1, this.ui = !1, this.hi = !1, this.di = !1, this.vi = !1, this.ci = !1, this._instance = t, this.featureFlagEventHandlers = [];
    }
    fi() {
        var t, i = null !== (t = this._instance.config.evaluation_contexts) && void 0 !== t ? t : this._instance.config.evaluation_environments;
        return !this._instance.config.evaluation_environments || this._instance.config.evaluation_contexts || this.ci || ($9052383c1c4e5569$var$yn.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.ci = !0), null != i && i.length ? i.filter((t)=>{
            var i = t && "string" == typeof t && t.trim().length > 0;
            return i || $9052383c1c4e5569$var$yn.error("Invalid evaluation context found:", t, "Expected non-empty string"), i;
        }) : [];
    }
    pi() {
        return this.fi().length > 0;
    }
    flags() {
        if (this._instance.config.__preview_remote_config) this.di = !0;
        else {
            var t = !this.gi && (this._instance.config.advanced_disable_feature_flags || this._instance.config.advanced_disable_feature_flags_on_first_load);
            this.mi({
                disableFlags: t
            });
        }
    }
    get hasLoadedFlags() {
        return this.ai;
    }
    getFlags() {
        return Object.keys(this.getFlagVariants());
    }
    getFlagsWithDetails() {
        var t = this._instance.get_property($9052383c1c4e5569$var$ne), i = this._instance.get_property($9052383c1c4e5569$var$En), e = this._instance.get_property($9052383c1c4e5569$var$Sn);
        if (!e && !i) return t || {};
        var r = $9052383c1c4e5569$var$Ri({}, t || {}), s = [
            ...new Set([
                ...Object.keys(e || {}),
                ...Object.keys(i || {})
            ])
        ];
        for (var n of s){
            var o, a, l = r[n], u = null == i ? void 0 : i[n], h = $9052383c1c4e5569$var$O(u) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!u, d = $9052383c1c4e5569$var$O(u) ? l.variant : "string" == typeof u ? u : void 0, v = null == e ? void 0 : e[n], c = $9052383c1c4e5569$var$g({}, l, {
                enabled: h,
                variant: h ? null != d ? d : null == l ? void 0 : l.variant : void 0
            });
            if (h !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v) c.metadata = $9052383c1c4e5569$var$g({}, null == l ? void 0 : l.metadata, {
                payload: v,
                original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
            });
            r[n] = c;
        }
        return this.oi || ($9052383c1c4e5569$var$yn.warn(" Overriding feature flag details!", {
            flagDetails: t,
            overriddenPayloads: e,
            finalDetails: r
        }), this.oi = !0), r;
    }
    getFlagVariants() {
        var t = this._instance.get_property($9052383c1c4e5569$var$re), i = this._instance.get_property($9052383c1c4e5569$var$En);
        if (!i) return t || {};
        for(var e = $9052383c1c4e5569$var$Ri({}, t), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.oi || ($9052383c1c4e5569$var$yn.warn(" Overriding feature flags!", {
            enabledFlags: t,
            overriddenFlags: i,
            finalFlags: e
        }), this.oi = !0), e;
    }
    getFlagPayloads() {
        var t = this._instance.get_property($9052383c1c4e5569$var$$n), i = this._instance.get_property($9052383c1c4e5569$var$Sn);
        if (!i) return t || {};
        for(var e = $9052383c1c4e5569$var$Ri({}, t || {}), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.oi || ($9052383c1c4e5569$var$yn.warn(" Overriding feature flag payloads!", {
            flagPayloads: t,
            overriddenPayloads: i,
            finalPayloads: e
        }), this.oi = !0), e;
    }
    reloadFeatureFlags() {
        this.ui || this._instance.config.advanced_disable_feature_flags || this.gi || (this.gi = setTimeout(()=>{
            this.mi();
        }, 5));
    }
    bi() {
        clearTimeout(this.gi), this.gi = void 0;
    }
    ensureFlagsLoaded() {
        this.ai || this.li || this.gi || this.reloadFeatureFlags();
    }
    setAnonymousDistinctId(t) {
        this.$anon_distinct_id = t;
    }
    setReloadingPaused(t) {
        this.ui = t;
    }
    mi(t) {
        var i;
        if (this.bi(), !this._instance.M()) {
            if (this.li) this.hi = !0;
            else {
                var e = this._instance.config.token, r = this._instance.get_property("$device_id"), s = {
                    token: e,
                    distinct_id: this._instance.get_distinct_id(),
                    groups: this._instance.getGroups(),
                    $anon_distinct_id: this.$anon_distinct_id,
                    person_properties: $9052383c1c4e5569$var$g({}, (null == (i = this._instance.persistence) ? void 0 : i.get_initial_props()) || {}, this._instance.get_property($9052383c1c4e5569$var$oe) || {}),
                    group_properties: this._instance.get_property($9052383c1c4e5569$var$ae)
                };
                $9052383c1c4e5569$var$j(r) || $9052383c1c4e5569$var$O(r) || (s.$device_id = r), (null != t && t.disableFlags || this._instance.config.advanced_disable_feature_flags) && (s.disable_flags = !0), this.pi() && (s.evaluation_contexts = this.fi());
                var n = this._instance.config.__preview_remote_config, o = n ? "/flags/?v=2" : "/flags/?v=2&config=true", a = this._instance.config.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : "", l = this._instance.requestRouter.endpointFor("flags", o + a);
                n && (s.timezone = $9052383c1c4e5569$var$cs()), this.li = !0, this._instance._send_request({
                    method: "POST",
                    url: l,
                    data: s,
                    compression: this._instance.config.disable_compression ? void 0 : $9052383c1c4e5569$export$6a00d17b5aff0af.Base64,
                    timeout: this._instance.config.feature_flag_request_timeout_ms,
                    callback: (t)=>{
                        var i, e, r = !0;
                        (200 === t.statusCode && (this.hi || (this.$anon_distinct_id = void 0), r = !1), this.li = !1, this.di) || (this.di = !0, this._instance.yi(null !== (e = t.json) && void 0 !== e ? e : {}));
                        if (!s.disable_flags || this.hi) {
                            if (this.vi = !r, t.json && null != (i = t.json.quotaLimited) && i.includes($9052383c1c4e5569$var$Cn.FeatureFlags)) $9052383c1c4e5569$var$yn.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
                            else {
                                var n;
                                if (!s.disable_flags) this.receivedFeatureFlags(null !== (n = t.json) && void 0 !== n ? n : {}, r);
                                this.hi && (this.hi = !1, this.mi());
                            }
                        }
                    }
                });
            }
        }
    }
    getFeatureFlag(t, i) {
        var e;
        if (void 0 === i && (i = {}), this.ai || this.getFlags() && this.getFlags().length > 0) {
            var r = this.getFeatureFlagResult(t, i);
            return null !== (e = null == r ? void 0 : r.variant) && void 0 !== e ? e : null == r ? void 0 : r.enabled;
        }
        $9052383c1c4e5569$var$yn.warn('getFeatureFlag for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getFeatureFlagDetails(t) {
        return this.getFlagsWithDetails()[t];
    }
    getFeatureFlagPayload(t) {
        var i = this.getFeatureFlagResult(t, {
            send_event: !1
        });
        return null == i ? void 0 : i.payload;
    }
    getFeatureFlagResult(t, i) {
        if (void 0 === i && (i = {}), this.ai || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFlagVariants(), r = t in e, s = e[t], n = this.getFlagPayloads()[t], o = String(s), a = this._instance.get_property($9052383c1c4e5569$var$kn) || void 0, l = this._instance.get_property($9052383c1c4e5569$var$Pn) || void 0, u = this._instance.get_property($9052383c1c4e5569$var$ue) || {};
            if ((i.send_event || !("send_event" in i)) && (!(t in u) || !u[t].includes(o))) {
                var h, d, v, c, f, p, g, _, m;
                $9052383c1c4e5569$var$I(u[t]) ? u[t].push(o) : u[t] = [
                    o
                ], null == (h = this._instance.persistence) || h.register({
                    [$9052383c1c4e5569$var$ue]: u
                });
                var b = this.getFeatureFlagDetails(t), y = {
                    $feature_flag: t,
                    $feature_flag_response: s,
                    $feature_flag_payload: n || null,
                    $feature_flag_request_id: a,
                    $feature_flag_evaluated_at: l,
                    $feature_flag_bootstrapped_response: (null == (d = this._instance.config.bootstrap) || null == (d = d.featureFlags) ? void 0 : d[t]) || null,
                    $feature_flag_bootstrapped_payload: (null == (v = this._instance.config.bootstrap) || null == (v = v.featureFlagPayloads) ? void 0 : v[t]) || null,
                    $used_bootstrap_value: !this.vi
                };
                $9052383c1c4e5569$var$O(null == b || null == (c = b.metadata) ? void 0 : c.version) || (y.$feature_flag_version = b.metadata.version);
                var w, x = null !== (f = null == b || null == (p = b.reason) ? void 0 : p.description) && void 0 !== f ? f : null == b || null == (g = b.reason) ? void 0 : g.code;
                if (x && (y.$feature_flag_reason = x), null != b && null != (_ = b.metadata) && _.id && (y.$feature_flag_id = b.metadata.id), $9052383c1c4e5569$var$O(null == b ? void 0 : b.original_variant) && $9052383c1c4e5569$var$O(null == b ? void 0 : b.original_enabled) || (y.$feature_flag_original_response = $9052383c1c4e5569$var$O(b.original_variant) ? b.original_enabled : b.original_variant), null != b && null != (m = b.metadata) && m.original_payload) y.$feature_flag_original_payload = null == b || null == (w = b.metadata) ? void 0 : w.original_payload;
                this._instance.capture("$feature_flag_called", y);
            }
            if (r) {
                var E = n;
                if (!$9052383c1c4e5569$var$O(n)) try {
                    E = JSON.parse(n);
                } catch (t) {}
                return {
                    key: t,
                    enabled: !!s,
                    variant: "string" == typeof s ? s : void 0,
                    payload: E
                };
            }
        } else $9052383c1c4e5569$var$yn.warn('getFeatureFlagResult for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getRemoteConfigPayload(t, i) {
        var e = this._instance.config.token, r = {
            distinct_id: this._instance.get_distinct_id(),
            token: e
        };
        this.pi() && (r.evaluation_contexts = this.fi()), this._instance._send_request({
            method: "POST",
            url: this._instance.requestRouter.endpointFor("flags", "/flags/?v=2&config=true"),
            data: r,
            compression: this._instance.config.disable_compression ? void 0 : $9052383c1c4e5569$export$6a00d17b5aff0af.Base64,
            timeout: this._instance.config.feature_flag_request_timeout_ms,
            callback: (e)=>{
                var r, s = null == (r = e.json) ? void 0 : r.featureFlagPayloads;
                i((null == s ? void 0 : s[t]) || void 0);
            }
        });
    }
    isFeatureEnabled(t, i) {
        if (void 0 === i && (i = {}), this.ai || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFeatureFlag(t, i);
            return $9052383c1c4e5569$var$O(e) ? void 0 : !!e;
        }
        $9052383c1c4e5569$var$yn.warn('isFeatureEnabled for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    addFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers.push(t);
    }
    removeFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
    }
    receivedFeatureFlags(t, i) {
        if (this._instance.persistence) {
            this.ai = !0;
            var e = this.getFlagVariants(), r = this.getFlagPayloads(), s = this.getFlagsWithDetails();
            !function(t, i, e, r, s) {
                void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                var n = $9052383c1c4e5569$var$In(t), o = n.flags, a = n.featureFlags, l = n.featureFlagPayloads;
                if (a) {
                    var u = t.requestId, h = t.evaluatedAt;
                    if ($9052383c1c4e5569$var$I(a)) {
                        $9052383c1c4e5569$var$yn.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                        var d = {};
                        if (a) for(var v = 0; v < a.length; v++)d[a[v]] = !0;
                        i && i.register({
                            [$9052383c1c4e5569$var$xn]: a,
                            [$9052383c1c4e5569$var$re]: d
                        });
                    } else {
                        var c = a, f = l, p = o;
                        if (t.errorsWhileComputingFlags) {
                            if (o) {
                                var _ = new Set(Object.keys(o).filter((t)=>{
                                    var i;
                                    return !(null != (i = o[t]) && i.failed);
                                }));
                                c = $9052383c1c4e5569$var$g({}, e, Object.fromEntries(Object.entries(c).filter((t)=>{
                                    var [i] = t;
                                    return _.has(i);
                                }))), f = $9052383c1c4e5569$var$g({}, r, Object.fromEntries(Object.entries(f || {}).filter((t)=>{
                                    var [i] = t;
                                    return _.has(i);
                                }))), p = $9052383c1c4e5569$var$g({}, s, Object.fromEntries(Object.entries(p || {}).filter((t)=>{
                                    var [i] = t;
                                    return _.has(i);
                                })));
                            } else c = $9052383c1c4e5569$var$g({}, e, c), f = $9052383c1c4e5569$var$g({}, r, f), p = $9052383c1c4e5569$var$g({}, s, p);
                        }
                        i && i.register($9052383c1c4e5569$var$g({
                            [$9052383c1c4e5569$var$xn]: Object.keys($9052383c1c4e5569$var$Tn(c)),
                            [$9052383c1c4e5569$var$re]: c || {},
                            [$9052383c1c4e5569$var$$n]: f || {},
                            [$9052383c1c4e5569$var$ne]: p || {}
                        }, u ? {
                            [$9052383c1c4e5569$var$kn]: u
                        } : {}, h ? {
                            [$9052383c1c4e5569$var$Pn]: h
                        } : {}));
                    }
                }
            }(t, this._instance.persistence, e, r, s), this.wi(i);
        }
    }
    override(t, i) {
        void 0 === i && (i = !1), $9052383c1c4e5569$var$yn.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
            flags: t,
            suppressWarning: i
        });
    }
    overrideFeatureFlags(t) {
        if (!this._instance.__loaded || !this._instance.persistence) return $9052383c1c4e5569$var$yn.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
        if (!1 === t) return this._instance.persistence.unregister($9052383c1c4e5569$var$En), this._instance.persistence.unregister($9052383c1c4e5569$var$Sn), this.wi(), $9052383c1c4e5569$var$wn.info("All overrides cleared");
        if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
            var i, e = t;
            if (this.oi = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i), "flags" in e) {
                if (!1 === e.flags) this._instance.persistence.unregister($9052383c1c4e5569$var$En), $9052383c1c4e5569$var$wn.info("Flag overrides cleared");
                else if (e.flags) {
                    if ($9052383c1c4e5569$var$I(e.flags)) {
                        for(var r = {}, s = 0; s < e.flags.length; s++)r[e.flags[s]] = !0;
                        this._instance.persistence.register({
                            [$9052383c1c4e5569$var$En]: r
                        });
                    } else this._instance.persistence.register({
                        [$9052383c1c4e5569$var$En]: e.flags
                    });
                    $9052383c1c4e5569$var$wn.info("Flag overrides set", {
                        flags: e.flags
                    });
                }
            }
            return "payloads" in e && (!1 === e.payloads ? (this._instance.persistence.unregister($9052383c1c4e5569$var$Sn), $9052383c1c4e5569$var$wn.info("Payload overrides cleared")) : e.payloads && (this._instance.persistence.register({
                [$9052383c1c4e5569$var$Sn]: e.payloads
            }), $9052383c1c4e5569$var$wn.info("Payload overrides set", {
                payloads: e.payloads
            }))), void this.wi();
        }
        this.wi();
    }
    onFeatureFlags(t) {
        if (this.addFeatureFlagsHandler(t), this.ai) {
            var { flags: i, flagVariants: e } = this.xi();
            t(i, e);
        }
        return ()=>this.removeFeatureFlagsHandler(t);
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        var r, s = (this._instance.get_property($9052383c1c4e5569$var$se) || []).find((i)=>i.flagKey === t), n = {
            ["$feature_enrollment/" + t]: i
        }, o = {
            $feature_flag: t,
            $feature_enrollment: i,
            $set: n
        };
        s && (o.$early_access_feature_name = s.name), e && (o.$feature_enrollment_stage = e), this._instance.capture("$feature_enrollment_update", o), this.setPersonPropertiesForFlags(n, !1);
        var a = $9052383c1c4e5569$var$g({}, this.getFlagVariants(), {
            [t]: i
        });
        null == (r = this._instance.persistence) || r.register({
            [$9052383c1c4e5569$var$xn]: Object.keys($9052383c1c4e5569$var$Tn(a)),
            [$9052383c1c4e5569$var$re]: a
        }), this.wi();
    }
    getEarlyAccessFeatures(t, i, e) {
        void 0 === i && (i = !1);
        var r = this._instance.get_property($9052383c1c4e5569$var$se), s = e ? "&" + e.map((t)=>"stage=" + t).join("&") : "";
        if (r && !i) return t(r);
        this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this._instance.config.token + s),
            method: "GET",
            callback: (i)=>{
                var e, r;
                if (i.json) {
                    var s = i.json.earlyAccessFeatures;
                    return null == (e = this._instance.persistence) || e.unregister($9052383c1c4e5569$var$se), null == (r = this._instance.persistence) || r.register({
                        [$9052383c1c4e5569$var$se]: s
                    }), t(s);
                }
            }
        });
    }
    xi() {
        var t = this.getFlags(), i = this.getFlagVariants();
        return {
            flags: t.filter((t)=>i[t]),
            flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
        };
    }
    wi(t) {
        var { flags: i, flagVariants: e } = this.xi();
        this.featureFlagEventHandlers.forEach((r)=>r(i, e, {
                errorsLoading: t
            }));
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property($9052383c1c4e5569$var$oe) || {};
        this._instance.register({
            [$9052383c1c4e5569$var$oe]: $9052383c1c4e5569$var$g({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetPersonPropertiesForFlags() {
        this._instance.unregister($9052383c1c4e5569$var$oe);
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property($9052383c1c4e5569$var$ae) || {};
        0 !== Object.keys(e).length && Object.keys(e).forEach((i)=>{
            e[i] = $9052383c1c4e5569$var$g({}, e[i], t[i]), delete t[i];
        }), this._instance.register({
            [$9052383c1c4e5569$var$ae]: $9052383c1c4e5569$var$g({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetGroupPropertiesForFlags(t) {
        if (t) {
            var i = this._instance.get_property($9052383c1c4e5569$var$ae) || {};
            this._instance.register({
                [$9052383c1c4e5569$var$ae]: $9052383c1c4e5569$var$g({}, i, {
                    [t]: {}
                })
            });
        } else this._instance.unregister($9052383c1c4e5569$var$ae);
    }
    reset() {
        this.ai = !1, this.li = !1, this.ui = !1, this.hi = !1, this.di = !1, this.vi = !1, this.$anon_distinct_id = void 0, this.bi(), this.oi = !1;
    }
}
var $9052383c1c4e5569$var$Fn = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class $9052383c1c4e5569$var$On {
    constructor(t, i){
        this.R = t, this.props = {}, this.Ei = !1, this.$i = ((t)=>{
            var i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(t), this.Y = this.Si(t), this.load(), t.debug && $9052383c1c4e5569$var$$i.info("Persistence loaded", t.persistence, $9052383c1c4e5569$var$g({}, this.props)), this.update_config(t, t, i), this.save();
    }
    isDisabled() {
        return !!this.ki;
    }
    Si(i) {
        -1 === $9052383c1c4e5569$var$Fn.indexOf(i.persistence.toLowerCase()) && ($9052383c1c4e5569$var$$i.critical("Unknown persistence type " + i.persistence + "; falling back to localStorage+cookie"), i.persistence = "localStorage+cookie");
        var e = function(i) {
            void 0 === i && (i = []);
            var e = [
                ...$9052383c1c4e5569$var$Tr,
                ...i
            ];
            return $9052383c1c4e5569$var$g({}, $9052383c1c4e5569$var$Pr, {
                W: function(t) {
                    try {
                        var i = {};
                        try {
                            i = $9052383c1c4e5569$var$Sr.W(t) || {};
                        } catch (t) {}
                        var e = $9052383c1c4e5569$var$Ri(i, JSON.parse($9052383c1c4e5569$var$Pr.q(t) || "{}"));
                        return $9052383c1c4e5569$var$Pr.G(t, e), e;
                    } catch (t) {}
                    return null;
                },
                G: function(t, i, r, s, n, o) {
                    try {
                        $9052383c1c4e5569$var$Pr.G(t, i, void 0, void 0, o);
                        var a = {};
                        e.forEach((t)=>{
                            i[t] && (a[t] = i[t]);
                        }), Object.keys(a).length && $9052383c1c4e5569$var$Sr.G(t, a, r, s, n, o);
                    } catch (t) {
                        $9052383c1c4e5569$var$Pr.B(t);
                    }
                },
                V: function(i, e) {
                    try {
                        null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.localStorage.removeItem(i), $9052383c1c4e5569$var$Sr.V(i, e);
                    } catch (t) {
                        $9052383c1c4e5569$var$Pr.B(t);
                    }
                }
            });
        }(i.cookie_persisted_properties || []), r = i.persistence.toLowerCase();
        return "localstorage" === r && $9052383c1c4e5569$var$Pr.H() ? $9052383c1c4e5569$var$Pr : "localstorage+cookie" === r && e.H() ? e : "sessionstorage" === r && $9052383c1c4e5569$var$Fr.H() ? $9052383c1c4e5569$var$Fr : "memory" === r ? $9052383c1c4e5569$var$Cr : "cookie" === r ? $9052383c1c4e5569$var$Sr : e.H() ? e : $9052383c1c4e5569$var$Sr;
    }
    properties() {
        var t = {};
        return $9052383c1c4e5569$var$Ci(this.props, function(i, e) {
            if (e === $9052383c1c4e5569$var$re && $9052383c1c4e5569$var$R(i)) for(var r = Object.keys(i), n = 0; n < r.length; n++)t["$feature/" + r[n]] = i[r[n]];
            else a = e, l = !1, ($9052383c1c4e5569$var$j(o = $9052383c1c4e5569$var$be) ? l : $9052383c1c4e5569$var$s && o.indexOf === $9052383c1c4e5569$var$s ? -1 != o.indexOf(a) : ($9052383c1c4e5569$var$Ci(o, function(t) {
                if (l || (l = t === a)) return $9052383c1c4e5569$var$Ti;
            }), l)) || (t[e] = i);
            var o, a, l;
        }), t;
    }
    load() {
        if (!this.ki) {
            var t = this.Y.W(this.$i);
            t && (this.props = $9052383c1c4e5569$var$Ri({}, t));
        }
    }
    save() {
        this.ki || this.Y.G(this.$i, this.props, this.Pi, this.Ti, this.Ii, this.R.debug);
    }
    remove() {
        this.Y.V(this.$i, !1), this.Y.V(this.$i, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if ($9052383c1c4e5569$var$R(t)) {
            $9052383c1c4e5569$var$O(i) && (i = "None"), this.Pi = $9052383c1c4e5569$var$O(e) ? this.Ci : e;
            var r = !1;
            if ($9052383c1c4e5569$var$Ci(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.props[e] = t, r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if ($9052383c1c4e5569$var$R(t)) {
            this.Pi = $9052383c1c4e5569$var$O(i) ? this.Ci : i;
            var e = !1;
            if ($9052383c1c4e5569$var$Ci(t, (i, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== i && (this.props[r] = i, e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (delete this.props[t], this.save());
    }
    update_campaign_params() {
        if (!this.Ei) {
            var t = $9052383c1c4e5569$var$os(this.R.custom_campaign_params, this.R.mask_personal_data_properties, this.R.custom_personal_data_properties);
            $9052383c1c4e5569$var$F($9052383c1c4e5569$var$ji(t)) || this.register(t), this.Ei = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $9052383c1c4e5569$var$o ? void 0 : $9052383c1c4e5569$var$o.referrer) ? $9052383c1c4e5569$var$ls(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $9052383c1c4e5569$var$hs(),
            $referring_domain: null != $9052383c1c4e5569$var$o && $9052383c1c4e5569$var$o.referrer && (null == (t = $9052383c1c4e5569$var$er($9052383c1c4e5569$var$o.referrer)) ? void 0 : t.host) || "$direct"
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$9052383c1c4e5569$var$ce] || this.props[$9052383c1c4e5569$var$fe] || this.register_once({
            [$9052383c1c4e5569$var$pe]: $9052383c1c4e5569$var$ds(this.R.mask_personal_data_properties, this.R.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $9052383c1c4e5569$var$Ci([
            $9052383c1c4e5569$var$fe,
            $9052383c1c4e5569$var$ce
        ], (i)=>{
            var e = this.props[i];
            e && $9052383c1c4e5569$var$Ci(e, function(i, e) {
                t["$initial_" + $9052383c1c4e5569$var$E(e)] = i;
            });
        });
        var i, e, r = this.props[$9052383c1c4e5569$var$pe];
        if (r) {
            var s = (i = $9052383c1c4e5569$var$vs(r), e = {}, $9052383c1c4e5569$var$Ci(i, function(t, i) {
                e["$initial_" + $9052383c1c4e5569$var$E(i)] = t;
            }), e);
            $9052383c1c4e5569$var$Ri(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return $9052383c1c4e5569$var$Ci(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i, e) {
        if (this.Ci = this.Pi = t.cookie_expiration, this.set_disabled(t.disable_persistence || !!e), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== i.persistence || !((t, i)=>{
            if (t.length !== i.length) return !1;
            var e = [
                ...t
            ].sort(), r = [
                ...i
            ].sort();
            return e.every((t, i)=>t === r[i]);
        })(t.cookie_persisted_properties || [], i.cookie_persisted_properties || [])) {
            var r = this.Si(t), s = this.props;
            this.clear(), this.Y = r, this.props = s, this.save();
        }
    }
    set_disabled(t) {
        this.ki = t, this.ki ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Ti && (this.Ti = t, this.remove(), this.save());
    }
    set_secure(t) {
        t !== this.Ii && (this.Ii = t, this.remove(), this.save());
    }
    set_event_timer(t, i) {
        var e = this.props[$9052383c1c4e5569$var$qi] || {};
        e[t] = i, this.props[$9052383c1c4e5569$var$qi] = e, this.save();
    }
    remove_event_timer(t) {
        var i = (this.props[$9052383c1c4e5569$var$qi] || {})[t];
        return $9052383c1c4e5569$var$O(i) || (delete this.props[$9052383c1c4e5569$var$qi][t], this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.props[t] = i, this.save();
    }
}
var $9052383c1c4e5569$var$Mn = $9052383c1c4e5569$var$Si("[Product Tours]"), $9052383c1c4e5569$var$An = "ph_product_tours";
class $9052383c1c4e5569$var$jn {
    constructor(t){
        this.Ri = null, this.Fi = null, this._instance = t;
    }
    onRemoteConfig(t) {
        this._instance.persistence && this._instance.persistence.register({
            [$9052383c1c4e5569$var$Qi]: !(null == t || !t.productTours)
        }), this.loadIfEnabled();
    }
    loadIfEnabled() {
        var t, i;
        this.Ri || (t = this._instance).config.disable_product_tours || null == (i = t.persistence) || !i.get_property($9052383c1c4e5569$var$Qi) || this.it(()=>this.Oi());
    }
    it(t) {
        var i, e;
        null != (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) && i.generateProductTours ? t() : null == (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "product-tours", (i)=>{
            i ? $9052383c1c4e5569$var$Mn.error("Could not load product tours script", i) : t();
        });
    }
    Oi() {
        var t;
        !this.Ri && null != (t = $9052383c1c4e5569$var$v.__PosthogExtensions__) && t.generateProductTours && (this.Ri = $9052383c1c4e5569$var$v.__PosthogExtensions__.generateProductTours(this._instance, !0));
    }
    getProductTours(t, i) {
        if (void 0 === i && (i = !1), !$9052383c1c4e5569$var$I(this.Fi) || i) {
            var e = this._instance.persistence;
            if (e) {
                var r = e.props[$9052383c1c4e5569$var$An];
                if ($9052383c1c4e5569$var$I(r) && !i) return this.Fi = r, void t(r, {
                    isLoaded: !0
                });
            }
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/product_tours/?token=" + this._instance.config.token),
                method: "GET",
                callback: (i)=>{
                    var r = i.statusCode;
                    if (200 !== r || !i.json) {
                        var s = "Product Tours API could not be loaded, status: " + r;
                        return $9052383c1c4e5569$var$Mn.error(s), void t([], {
                            isLoaded: !1,
                            error: s
                        });
                    }
                    var n = $9052383c1c4e5569$var$I(i.json.product_tours) ? i.json.product_tours : [];
                    this.Fi = n, e && e.register({
                        [$9052383c1c4e5569$var$An]: n
                    }), t(n, {
                        isLoaded: !0
                    });
                }
            });
        } else t(this.Fi, {
            isLoaded: !0
        });
    }
    getActiveProductTours(t) {
        $9052383c1c4e5569$var$D(this.Ri) ? t([], {
            isLoaded: !1,
            error: "Product tours not loaded"
        }) : this.Ri.getActiveProductTours(t);
    }
    showProductTour(t) {
        var i;
        null == (i = this.Ri) || i.showTourById(t);
    }
    previewTour(t) {
        this.Ri ? this.Ri.previewTour(t) : this.it(()=>{
            var i;
            this.Oi(), null == (i = this.Ri) || i.previewTour(t);
        });
    }
    dismissProductTour() {
        var t;
        null == (t = this.Ri) || t.dismissTour("user_clicked_skip");
    }
    nextStep() {
        var t;
        null == (t = this.Ri) || t.nextStep();
    }
    previousStep() {
        var t;
        null == (t = this.Ri) || t.previousStep();
    }
    clearCache() {
        var t;
        this.Fi = null, null == (t = this._instance.persistence) || t.unregister($9052383c1c4e5569$var$An);
    }
    resetTour(t) {
        var i;
        null == (i = this.Ri) || i.resetTour(t);
    }
    resetAllTours() {
        var t;
        null == (t = this.Ri) || t.resetAllTours();
    }
    cancelPendingTour(t) {
        var i;
        null == (i = this.Ri) || i.cancelPendingTour(t);
    }
}
var $9052383c1c4e5569$export$352273f853caad57 = function(t) {
    return t.Activation = "events", t.Cancellation = "cancelEvents", t;
}({}), $9052383c1c4e5569$export$87f1e68f1b904cbb = function(t) {
    return t.Button = "button", t.Tab = "tab", t.Selector = "selector", t;
}({}), $9052383c1c4e5569$export$8c0ce98316e43193 = function(t) {
    return t.TopLeft = "top_left", t.TopRight = "top_right", t.TopCenter = "top_center", t.MiddleLeft = "middle_left", t.MiddleRight = "middle_right", t.MiddleCenter = "middle_center", t.Left = "left", t.Center = "center", t.Right = "right", t.NextToTrigger = "next_to_trigger", t;
}({}), $9052383c1c4e5569$export$3693bed37a847924 = function(t) {
    return t.Top = "top", t.Left = "left", t.Right = "right", t.Bottom = "bottom", t;
}({}), $9052383c1c4e5569$export$22779822dd24228f = function(t) {
    return t.Popover = "popover", t.API = "api", t.Widget = "widget", t.ExternalSurvey = "external_survey", t;
}({}), $9052383c1c4e5569$export$9c2ac61661d417f8 = function(t) {
    return t.Open = "open", t.MultipleChoice = "multiple_choice", t.SingleChoice = "single_choice", t.Rating = "rating", t.Link = "link", t;
}({}), $9052383c1c4e5569$export$bbed2da3bd3bb001 = function(t) {
    return t.NextQuestion = "next_question", t.End = "end", t.ResponseBased = "response_based", t.SpecificQuestion = "specific_question", t;
}({}), $9052383c1c4e5569$export$407ee791fe918359 = function(t) {
    return t.Once = "once", t.Recurring = "recurring", t.Always = "always", t;
}({}), $9052383c1c4e5569$export$9d7ec1793ca1658e = function(t) {
    return t.SHOWN = "survey shown", t.DISMISSED = "survey dismissed", t.SENT = "survey sent", t.ABANDONED = "survey abandoned", t;
}({}), $9052383c1c4e5569$export$fe4c9af525341543 = function(t) {
    return t.SURVEY_ID = "$survey_id", t.SURVEY_NAME = "$survey_name", t.SURVEY_RESPONSE = "$survey_response", t.SURVEY_ITERATION = "$survey_iteration", t.SURVEY_ITERATION_START_DATE = "$survey_iteration_start_date", t.SURVEY_PARTIALLY_COMPLETED = "$survey_partially_completed", t.SURVEY_SUBMISSION_ID = "$survey_submission_id", t.SURVEY_QUESTIONS = "$survey_questions", t.SURVEY_COMPLETED = "$survey_completed", t.PRODUCT_TOUR_ID = "$product_tour_id", t.SURVEY_LAST_SEEN_DATE = "$survey_last_seen_date", t;
}({}), $9052383c1c4e5569$export$a8a66d9d1b857494 = function(t) {
    return t.Popover = "popover", t.Inline = "inline", t;
}({}), $9052383c1c4e5569$var$Jn = $9052383c1c4e5569$var$Si("[Surveys]");
var $9052383c1c4e5569$var$Kn = "seenSurvey_", $9052383c1c4e5569$var$Yn = (t, i)=>{
    var e = "$survey_" + i + "/" + t.id;
    return t.current_iteration && t.current_iteration > 0 && (e = "$survey_" + i + "/" + t.id + "/" + t.current_iteration), e;
}, $9052383c1c4e5569$var$Xn = (t)=>((t, i)=>{
        var e = "" + t + i.id;
        return i.current_iteration && i.current_iteration > 0 && (e = "" + t + i.id + "_" + i.current_iteration), e;
    })($9052383c1c4e5569$var$Kn, t), $9052383c1c4e5569$var$Qn = [
    $9052383c1c4e5569$export$22779822dd24228f.Popover,
    $9052383c1c4e5569$export$22779822dd24228f.Widget,
    $9052383c1c4e5569$export$22779822dd24228f.API
], $9052383c1c4e5569$var$Zn = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: $9052383c1c4e5569$export$a8a66d9d1b857494.Popover
};
class $9052383c1c4e5569$var$to {
    constructor(){
        this.Mi = {}, this.Mi = {};
    }
    on(t, i) {
        return this.Mi[t] || (this.Mi[t] = []), this.Mi[t].push(i), ()=>{
            this.Mi[t] = this.Mi[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (var e of this.Mi[t] || [])e(i);
        for (var r of this.Mi["*"] || [])r(t, i);
    }
}
function $9052383c1c4e5569$var$io(t, i, e) {
    if ($9052383c1c4e5569$var$D(t)) return !1;
    switch(e){
        case "exact":
            return t === i;
        case "contains":
            var r = i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
            return new RegExp(r, "i").test(t);
        case "regex":
            try {
                return new RegExp(i).test(t);
            } catch (t) {
                return !1;
            }
        default:
            return !1;
    }
}
class $9052383c1c4e5569$var$eo {
    constructor(t){
        this.Ai = new $9052383c1c4e5569$var$to, this.ji = (t, i)=>this.Di(t, i) && this.Li(t, i) && this.Ni(t, i) && this.Ui(t, i), this.Di = (t, i)=>null == i || !i.event || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event), this._instance = t, this.zi = new Set, this.Hi = new Set;
    }
    init() {
        var t;
        if (!$9052383c1c4e5569$var$O(null == (t = this._instance) ? void 0 : t._addCaptureHook)) {
            var i;
            null == (i = this._instance) || i._addCaptureHook((t, i)=>{
                this.on(t, i);
            });
        }
    }
    register(t) {
        var i, e;
        if (!$9052383c1c4e5569$var$O(null == (i = this._instance) ? void 0 : i._addCaptureHook) && (t.forEach((t)=>{
            var i, e;
            null == (i = this.Hi) || i.add(t), null == (e = t.steps) || e.forEach((t)=>{
                var i;
                null == (i = this.zi) || i.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (e = this._instance) && e.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var i;
                null == (i = t.steps) || i.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this._instance) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, i) {
        var e;
        null != i && 0 != t.length && (this.zi.has(t) || this.zi.has(null == i ? void 0 : i.event)) && this.Hi && (null == (e = this.Hi) ? void 0 : e.size) > 0 && this.Hi.forEach((t)=>{
            this.Bi(i, t) && this.Ai.emit("actionCaptured", t.name);
        });
    }
    qi(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    Bi(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (var e of i.steps)if (this.ji(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.Ai.on(t, i);
    }
    Li(t, i) {
        if (null != i && i.url) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$9052383c1c4e5569$var$io(r, i.url, i.url_matching || "contains")) return !1;
        }
        return !0;
    }
    Ni(t, i) {
        return !!this.Wi(t, i) && !!this.Gi(t, i) && !!this.Vi(t, i);
    }
    Wi(t, i) {
        var e;
        if (null == i || !i.href) return !0;
        var r = this.Ji(t);
        if (r.length > 0) return r.some((t)=>$9052383c1c4e5569$var$io(t.href, i.href, i.href_matching || "exact"));
        var s, n = (null == t || null == (e = t.properties) ? void 0 : e.$elements_chain) || "";
        return !!n && $9052383c1c4e5569$var$io((s = n.match(/(?::|")href="(.*?)"/)) ? s[1] : "", i.href, i.href_matching || "exact");
    }
    Gi(t, i) {
        var e;
        if (null == i || !i.text) return !0;
        var r = this.Ji(t);
        if (r.length > 0) return r.some((t)=>$9052383c1c4e5569$var$io(t.text, i.text, i.text_matching || "exact") || $9052383c1c4e5569$var$io(t.$el_text, i.text, i.text_matching || "exact"));
        var s, n, o, a = (null == t || null == (e = t.properties) ? void 0 : e.$elements_chain) || "";
        return !!a && (s = function(t) {
            for(var i, e = [], r = /(?::|")text="(.*?)"/g; !$9052383c1c4e5569$var$D(i = r.exec(t));)e.includes(i[1]) || e.push(i[1]);
            return e;
        }(a), n = i.text, o = i.text_matching || "exact", s.some((t)=>$9052383c1c4e5569$var$io(t, n, o)));
    }
    Vi(t, i) {
        var e, r;
        if (null == i || !i.selector) return !0;
        var s = null == t || null == (e = t.properties) ? void 0 : e.$element_selectors;
        if (null != s && s.includes(i.selector)) return !0;
        var n = (null == t || null == (r = t.properties) ? void 0 : r.$elements_chain) || "";
        if (i.selector_regex && n) try {
            return new RegExp(i.selector_regex).test(n);
        } catch (t) {
            return !1;
        }
        return !1;
    }
    Ji(t) {
        var i;
        return null == (null == t || null == (i = t.properties) ? void 0 : i.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
    Ui(t, i) {
        return null == i || !i.properties || 0 === i.properties.length || $9052383c1c4e5569$var$_n(i.properties.reduce((t, i)=>{
            var e = $9052383c1c4e5569$var$I(i.value) ? i.value.map(String) : null != i.value ? [
                String(i.value)
            ] : [];
            return t[i.key] = {
                values: e,
                operator: i.operator || "exact"
            }, t;
        }, {}), null == t ? void 0 : t.properties);
    }
}
class $9052383c1c4e5569$var$ro {
    constructor(t){
        this._instance = t, this.Ki = new Map, this.Yi = new Map, this.Xi = new Map;
    }
    Qi(t, i) {
        return !!t && $9052383c1c4e5569$var$_n(t.propertyFilters, null == i ? void 0 : i.properties);
    }
    Zi(t, i) {
        var e = new Map;
        return t.forEach((t)=>{
            var r;
            null == (r = t.conditions) || null == (r = r[i]) || null == (r = r.values) || r.forEach((i)=>{
                if (null != i && i.name) {
                    var r = e.get(i.name) || [];
                    r.push(t.id), e.set(i.name, r);
                }
            });
        }), e;
    }
    te(t, i, e) {
        var r = (e === $9052383c1c4e5569$export$352273f853caad57.Activation ? this.Ki : this.Yi).get(t), s = [];
        return this.ie((t)=>{
            s = t.filter((t)=>null == r ? void 0 : r.includes(t.id));
        }), s.filter((r)=>{
            var s, n = null == (s = r.conditions) || null == (s = s[e]) || null == (s = s.values) ? void 0 : s.find((i)=>i.name === t);
            return this.Qi(n, i);
        });
    }
    register(t) {
        var i;
        $9052383c1c4e5569$var$O(null == (i = this._instance) ? void 0 : i._addCaptureHook) || (this.ee(t), this.re(t));
    }
    re(t) {
        var i = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.actions) && (null == (e = t.conditions) || null == (e = e.actions) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== i.length) {
            if (null == this.se) {
                this.se = new $9052383c1c4e5569$var$eo(this._instance), this.se.init();
                this.se.qi((t)=>{
                    this.onAction(t);
                });
            }
            i.forEach((t)=>{
                var i, e, r, s, n;
                t.conditions && null != (i = t.conditions) && i.actions && null != (e = t.conditions) && null != (e = e.actions) && e.values && (null == (r = t.conditions) || null == (r = r.actions) || null == (r = r.values) ? void 0 : r.length) > 0 && (null == (s = this.se) || s.register(t.conditions.actions.values), null == (n = t.conditions) || null == (n = n.actions) || null == (n = n.values) || n.forEach((i)=>{
                    if (i && i.name) {
                        var e = this.Xi.get(i.name);
                        e && e.push(t.id), this.Xi.set(i.name, e || [
                            t.id
                        ]);
                    }
                }));
            });
        }
    }
    ee(t) {
        var i, e = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.events) && (null == (e = t.conditions) || null == (e = e.events) || null == (e = e.values) ? void 0 : e.length) > 0;
        }), r = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.cancelEvents) && (null == (e = t.conditions) || null == (e = e.cancelEvents) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== e.length || 0 !== r.length) null == (i = this._instance) || i._addCaptureHook((t, i)=>{
            this.onEvent(t, i);
        }), this.Ki = this.Zi(t, $9052383c1c4e5569$export$352273f853caad57.Activation), this.Yi = this.Zi(t, $9052383c1c4e5569$export$352273f853caad57.Cancellation);
    }
    onEvent(t, i) {
        var e, r = this.ne(), s = this.oe(), n = this.ae(), o = (null == (e = this._instance) || null == (e = e.persistence) ? void 0 : e.props[s]) || [];
        if (n === t && i && o.length > 0) {
            var a, l;
            r.info("event matched, removing item from activated items", {
                event: t,
                eventPayload: i,
                existingActivatedItems: o
            });
            var u = (null == i || null == (a = i.properties) ? void 0 : a.$survey_id) || (null == i || null == (l = i.properties) ? void 0 : l.$product_tour_id);
            if (u) {
                var h = o.indexOf(u);
                h >= 0 && (o.splice(h, 1), this.le(o));
            }
        } else {
            if (this.Yi.has(t)) {
                var d = this.te(t, i, $9052383c1c4e5569$export$352273f853caad57.Cancellation);
                d.length > 0 && (r.info("cancel event matched, cancelling items", {
                    event: t,
                    itemsToCancel: d.map((t)=>t.id)
                }), d.forEach((t)=>{
                    var i = o.indexOf(t.id);
                    i >= 0 && o.splice(i, 1), this.ue(t.id);
                }), this.le(o));
            }
            if (this.Ki.has(t)) {
                r.info("event name matched", {
                    event: t,
                    eventPayload: i,
                    items: this.Ki.get(t)
                });
                var v = this.te(t, i, $9052383c1c4e5569$export$352273f853caad57.Activation);
                this.le(o.concat(v.map((t)=>t.id) || []));
            }
        }
    }
    onAction(t) {
        var i, e = this.oe(), r = (null == (i = this._instance) || null == (i = i.persistence) ? void 0 : i.props[e]) || [];
        this.Xi.has(t) && this.le(r.concat(this.Xi.get(t) || []));
    }
    le(t) {
        var i, e = this.ne(), r = this.oe(), s = [
            ...new Set(t)
        ].filter((t)=>!this.he(t));
        e.info("updating activated items", {
            activatedItems: s
        }), null == (i = this._instance) || null == (i = i.persistence) || i.register({
            [r]: s
        });
    }
    getActivatedIds() {
        var t, i = this.oe(), e = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[i];
        return e || [];
    }
    getEventToItemsMap() {
        return this.Ki;
    }
    de() {
        return this.se;
    }
}
class $9052383c1c4e5569$var$so extends $9052383c1c4e5569$var$ro {
    constructor(t){
        super(t);
    }
    oe() {
        return "$surveys_activated";
    }
    ae() {
        return $9052383c1c4e5569$export$9d7ec1793ca1658e.SHOWN;
    }
    ie(t) {
        var i;
        null == (i = this._instance) || i.getSurveys(t);
    }
    ue(t) {
        var i;
        null == (i = this._instance) || i.cancelPendingSurvey(t);
    }
    ne() {
        return $9052383c1c4e5569$var$Jn;
    }
    he() {
        return !1;
    }
    getSurveys() {
        return this.getActivatedIds();
    }
    getEventToSurveys() {
        return this.getEventToItemsMap();
    }
}
class $9052383c1c4e5569$var$no {
    constructor(t){
        this.ve = void 0, this._surveyManager = null, this.ce = !1, this.fe = [], this.pe = null, this._instance = t, this._surveyEventReceiver = null;
    }
    onRemoteConfig(t) {
        if (!this._instance.config.disable_surveys) {
            var i = t.surveys;
            if ($9052383c1c4e5569$var$D(i)) return $9052383c1c4e5569$var$Jn.warn("Flags not loaded yet. Not loading surveys.");
            var e = $9052383c1c4e5569$var$I(i);
            this.ve = e ? i.length > 0 : i, $9052383c1c4e5569$var$Jn.info("flags response received, isSurveysEnabled: " + this.ve), this.loadIfEnabled();
        }
    }
    reset() {
        localStorage.removeItem("lastSeenSurveyDate");
        for(var t = [], i = 0; i < localStorage.length; i++){
            var e = localStorage.key(i);
            (null != e && e.startsWith($9052383c1c4e5569$var$Kn) || null != e && e.startsWith("inProgressSurvey_")) && t.push(e);
        }
        t.forEach((t)=>localStorage.removeItem(t));
    }
    loadIfEnabled() {
        if (!this._surveyManager) {
            if (this.ce) $9052383c1c4e5569$var$Jn.info("Already initializing surveys, skipping...");
            else if (this._instance.config.disable_surveys) $9052383c1c4e5569$var$Jn.info("Disabled. Not loading surveys.");
            else if (this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) $9052383c1c4e5569$var$Jn.info("Not loading surveys in cookieless mode without consent.");
            else {
                var t = null == $9052383c1c4e5569$var$v ? void 0 : $9052383c1c4e5569$var$v.__PosthogExtensions__;
                if (t) {
                    if (!$9052383c1c4e5569$var$O(this.ve) || this._instance.config.advanced_enable_surveys) {
                        var i = this.ve || this._instance.config.advanced_enable_surveys;
                        this.ce = !0;
                        try {
                            var e = t.generateSurveys;
                            if (e) return void this.ge(e, i);
                            var r = t.loadExternalDependency;
                            if (!r) return void this._e("PostHog loadExternalDependency extension not found.");
                            r(this._instance, "surveys", (e)=>{
                                e || !t.generateSurveys ? this._e("Could not load surveys script", e) : this.ge(t.generateSurveys, i);
                            });
                        } catch (t) {
                            throw this._e("Error initializing surveys", t), t;
                        } finally{
                            this.ce = !1;
                        }
                    }
                } else $9052383c1c4e5569$var$Jn.error("PostHog Extensions not found.");
            }
        }
    }
    ge(t, i) {
        this._surveyManager = t(this._instance, i), this._surveyEventReceiver = new $9052383c1c4e5569$var$so(this._instance), $9052383c1c4e5569$var$Jn.info("Surveys loaded successfully"), this.me({
            isLoaded: !0
        });
    }
    _e(t, i) {
        $9052383c1c4e5569$var$Jn.error(t, i), this.me({
            isLoaded: !1,
            error: t
        });
    }
    onSurveysLoaded(t) {
        return this.fe.push(t), this._surveyManager && this.me({
            isLoaded: !0
        }), ()=>{
            this.fe = this.fe.filter((i)=>i !== t);
        };
    }
    getSurveys(t, i) {
        if (void 0 === i && (i = !1), this._instance.config.disable_surveys) return $9052383c1c4e5569$var$Jn.info("Disabled. Not loading surveys."), t([]);
        var e, r = this._instance.get_property($9052383c1c4e5569$var$le);
        if (r && !i) return t(r, {
            isLoaded: !0
        });
        "undefined" != typeof Promise && this.pe ? this.pe.then((i)=>{
            var { surveys: e, context: r } = i;
            return t(e, r);
        }) : ("undefined" != typeof Promise && (this.pe = new Promise((t)=>{
            e = t;
        })), this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this._instance.config.token),
            method: "GET",
            timeout: this._instance.config.surveys_request_timeout_ms,
            callback: (i)=>{
                var r;
                this.pe = null;
                var s = i.statusCode;
                if (200 !== s || !i.json) {
                    var n = "Surveys API could not be loaded, status: " + s;
                    $9052383c1c4e5569$var$Jn.error(n);
                    var o = {
                        isLoaded: !1,
                        error: n
                    };
                    return t([], o), void (null == e || e({
                        surveys: [],
                        context: o
                    }));
                }
                var a, l = i.json.surveys || [], u = l.filter((t)=>(function(t) {
                        return !(!t.start_date || t.end_date);
                    })(t) && (function(t) {
                        var i;
                        return !(null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) || !i.length);
                    }(t) || function(t) {
                        var i;
                        return !(null == (i = t.conditions) || null == (i = i.actions) || null == (i = i.values) || !i.length);
                    }(t)));
                u.length > 0 && (null == (a = this._surveyEventReceiver) || a.register(u));
                null == (r = this._instance.persistence) || r.register({
                    [$9052383c1c4e5569$var$le]: l
                });
                var h = {
                    isLoaded: !0
                };
                t(l, h), null == e || e({
                    surveys: l,
                    context: h
                });
            }
        }));
    }
    me(t) {
        for (var i of this.fe)try {
            if (!t.isLoaded) return i([], t);
            this.getSurveys(i);
        } catch (t) {
            $9052383c1c4e5569$var$Jn.error("Error in survey callback", t);
        }
    }
    getActiveMatchingSurveys(t, i) {
        if (void 0 === i && (i = !1), !$9052383c1c4e5569$var$D(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, i);
        $9052383c1c4e5569$var$Jn.warn("init was not called");
    }
    be(t) {
        var i = null;
        return this.getSurveys((e)=>{
            var r;
            i = null !== (r = e.find((i)=>i.id === t)) && void 0 !== r ? r : null;
        }), i;
    }
    ye(t) {
        if ($9052383c1c4e5569$var$D(this._surveyManager)) return {
            eligible: !1,
            reason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = "string" == typeof t ? this.be(t) : t;
        return i ? this._surveyManager.checkSurveyEligibility(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    canRenderSurvey(t) {
        if ($9052383c1c4e5569$var$D(this._surveyManager)) return $9052383c1c4e5569$var$Jn.warn("init was not called"), {
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = this.ye(t);
        return {
            visible: i.eligible,
            disabledReason: i.reason
        };
    }
    canRenderSurveyAsync(t, i) {
        return $9052383c1c4e5569$var$D(this._surveyManager) ? ($9052383c1c4e5569$var$Jn.warn("init was not called"), Promise.resolve({
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        })) : new Promise((e)=>{
            this.getSurveys((i)=>{
                var r, s = null !== (r = i.find((i)=>i.id === t)) && void 0 !== r ? r : null;
                if (s) {
                    var n = this.ye(s);
                    e({
                        visible: n.eligible,
                        disabledReason: n.reason
                    });
                } else e({
                    visible: !1,
                    disabledReason: "Survey not found"
                });
            }, i);
        });
    }
    renderSurvey(t, i, e) {
        var r;
        if ($9052383c1c4e5569$var$D(this._surveyManager)) $9052383c1c4e5569$var$Jn.warn("init was not called");
        else {
            var s = "string" == typeof t ? this.be(t) : t;
            if (null != s && s.id) {
                if ($9052383c1c4e5569$var$Qn.includes(s.type)) {
                    var n = null == $9052383c1c4e5569$var$o ? void 0 : $9052383c1c4e5569$var$o.querySelector(i);
                    if (n) return null != (r = s.appearance) && r.surveyPopupDelaySeconds ? ($9052383c1c4e5569$var$Jn.info("Rendering survey " + s.id + " with delay of " + s.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(()=>{
                        var t, i;
                        $9052383c1c4e5569$var$Jn.info("Rendering survey " + s.id + " with delay of " + (null == (t = s.appearance) ? void 0 : t.surveyPopupDelaySeconds) + " seconds"), null == (i = this._surveyManager) || i.renderSurvey(s, n, e), $9052383c1c4e5569$var$Jn.info("Survey " + s.id + " rendered");
                    }, 1e3 * s.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(s, n, e);
                    $9052383c1c4e5569$var$Jn.warn("Survey element not found");
                } else $9052383c1c4e5569$var$Jn.warn("Surveys of type " + s.type + " cannot be rendered in the app");
            } else $9052383c1c4e5569$var$Jn.warn("Survey not found");
        }
    }
    displaySurvey(t, i) {
        var e;
        if ($9052383c1c4e5569$var$D(this._surveyManager)) $9052383c1c4e5569$var$Jn.warn("init was not called");
        else {
            var r = this.be(t);
            if (r) {
                var s = r;
                if (null != (e = r.appearance) && e.surveyPopupDelaySeconds && i.ignoreDelay && (s = $9052383c1c4e5569$var$g({}, r, {
                    appearance: $9052383c1c4e5569$var$g({}, r.appearance, {
                        surveyPopupDelaySeconds: 0
                    })
                })), i.displayType !== $9052383c1c4e5569$export$a8a66d9d1b857494.Popover && i.initialResponses && $9052383c1c4e5569$var$Jn.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), !1 === i.ignoreConditions) {
                    var n = this.canRenderSurvey(r);
                    if (!n.visible) return void $9052383c1c4e5569$var$Jn.warn("Survey is not eligible to be displayed: ", n.disabledReason);
                }
                i.displayType !== $9052383c1c4e5569$export$a8a66d9d1b857494.Inline ? this._surveyManager.handlePopoverSurvey(s, i) : this.renderSurvey(s, i.selector, i.properties);
            } else $9052383c1c4e5569$var$Jn.warn("Survey not found");
        }
    }
    cancelPendingSurvey(t) {
        $9052383c1c4e5569$var$D(this._surveyManager) ? $9052383c1c4e5569$var$Jn.warn("init was not called") : this._surveyManager.cancelSurvey(t);
    }
    handlePageUnload() {
        var t;
        null == (t = this._surveyManager) || t.handlePageUnload();
    }
}
var $9052383c1c4e5569$var$oo = $9052383c1c4e5569$var$Si("[Conversations]");
class $9052383c1c4e5569$var$ao {
    constructor(t){
        this.we = void 0, this._conversationsManager = null, this.xe = !1, this.Ee = null, this._instance = t;
    }
    onRemoteConfig(t) {
        if (!this._instance.config.disable_conversations) {
            var i = t.conversations;
            $9052383c1c4e5569$var$D(i) || ($9052383c1c4e5569$var$U(i) ? this.we = i : (this.we = i.enabled, this.Ee = i), this.loadIfEnabled());
        }
    }
    reset() {
        var t;
        null == (t = this._conversationsManager) || t.reset(), this._conversationsManager = null, this.we = void 0, this.Ee = null;
    }
    loadIfEnabled() {
        if (!this._conversationsManager && !this.xe && !(this._instance.config.disable_conversations || this._instance.config.cookieless_mode && this._instance.consent.isOptedOut())) {
            var t = null == $9052383c1c4e5569$var$v ? void 0 : $9052383c1c4e5569$var$v.__PosthogExtensions__;
            if (t && !$9052383c1c4e5569$var$O(this.we) && this.we) {
                if (this.Ee && this.Ee.token) {
                    this.xe = !0;
                    try {
                        var i = t.initConversations;
                        if (i) return this.$e(i), void (this.xe = !1);
                        var e = t.loadExternalDependency;
                        if (!e) return void this.Se("PostHog loadExternalDependency extension not found.");
                        e(this._instance, "conversations", (i)=>{
                            i || !t.initConversations ? this.Se("Could not load conversations script", i) : this.$e(t.initConversations), this.xe = !1;
                        });
                    } catch (t) {
                        this.Se("Error initializing conversations", t), this.xe = !1;
                    }
                } else $9052383c1c4e5569$var$oo.error("Conversations enabled but missing token in remote config.");
            }
        }
    }
    $e(t) {
        if (this.Ee) try {
            this._conversationsManager = t(this.Ee, this._instance), $9052383c1c4e5569$var$oo.info("Conversations loaded successfully");
        } catch (t) {
            this.Se("Error completing conversations initialization", t);
        }
        else $9052383c1c4e5569$var$oo.error("Cannot complete initialization: remote config is null");
    }
    Se(t, i) {
        $9052383c1c4e5569$var$oo.error(t, i), this._conversationsManager = null, this.xe = !1;
    }
    show() {
        this._conversationsManager ? this._conversationsManager.show() : $9052383c1c4e5569$var$oo.warn("Conversations not loaded yet.");
    }
    hide() {
        this._conversationsManager && this._conversationsManager.hide();
    }
    isAvailable() {
        return !0 === this.we && !$9052383c1c4e5569$var$j(this._conversationsManager);
    }
    isVisible() {
        var t, i;
        return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.isVisible()) && void 0 !== t && t;
    }
    sendMessage(t, i, e) {
        var r = this;
        return $9052383c1c4e5569$var$p(function*() {
            return r._conversationsManager ? r._conversationsManager.sendMessage(t, i, e) : ($9052383c1c4e5569$var$oo.warn("Conversations not available yet."), null);
        })();
    }
    getMessages(t, i) {
        var e = this;
        return $9052383c1c4e5569$var$p(function*() {
            return e._conversationsManager ? e._conversationsManager.getMessages(t, i) : ($9052383c1c4e5569$var$oo.warn("Conversations not available yet."), null);
        })();
    }
    markAsRead(t) {
        var i = this;
        return $9052383c1c4e5569$var$p(function*() {
            return i._conversationsManager ? i._conversationsManager.markAsRead(t) : ($9052383c1c4e5569$var$oo.warn("Conversations not available yet."), null);
        })();
    }
    getTickets(t) {
        var i = this;
        return $9052383c1c4e5569$var$p(function*() {
            return i._conversationsManager ? i._conversationsManager.getTickets(t) : ($9052383c1c4e5569$var$oo.warn("Conversations not available yet."), null);
        })();
    }
    getCurrentTicketId() {
        var t, i;
        return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.getCurrentTicketId()) && void 0 !== t ? t : null;
    }
    getWidgetSessionId() {
        var t, i;
        return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.getWidgetSessionId()) && void 0 !== t ? t : null;
    }
}
class $9052383c1c4e5569$var$lo {
    constructor(t){
        var i;
        this.ke = !1, this.Pe = !1, this._instance = t, this._instance && null != (i = this._instance.config.logs) && i.captureConsoleLogs && (this.ke = !0);
    }
    onRemoteConfig(t) {
        var i, e = null == (i = t.logs) ? void 0 : i.captureConsoleLogs;
        !$9052383c1c4e5569$var$D(e) && e && (this.ke = !0, this.loadIfEnabled());
    }
    reset() {}
    loadIfEnabled() {
        if (this.ke && !this.Pe) {
            var t = $9052383c1c4e5569$var$Si("[logs]"), i = null == $9052383c1c4e5569$var$v ? void 0 : $9052383c1c4e5569$var$v.__PosthogExtensions__;
            if (i) {
                var e = i.loadExternalDependency;
                e ? e(this._instance, "logs", (e)=>{
                    var r;
                    e || null == (r = i.logs) || !r.initializeLogs ? t.error("Could not load logs script", e) : (i.logs.initializeLogs(this._instance), this.Pe = !0);
                }) : t.error("PostHog loadExternalDependency extension not found.");
            } else t.error("PostHog Extensions not found.");
        }
    }
}
var $9052383c1c4e5569$var$uo = $9052383c1c4e5569$var$Si("[RateLimiter]");
class $9052383c1c4e5569$var$ho {
    constructor(t){
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    $9052383c1c4e5569$var$uo.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $9052383c1c4e5569$var$uo.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: i
                });
            }
        }, this.instance = t, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    get captureEventsPerSecond() {
        var t;
        return (null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_per_second) || 10;
    }
    get captureEventsBurstLimit() {
        var t;
        return Math.max((null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
    }
    clientRateLimitContext(t) {
        var i, e, r;
        void 0 === t && (t = !1);
        var { captureEventsBurstLimit: s, captureEventsPerSecond: n } = this, o = (new Date).getTime(), a = null !== (i = null == (e = this.instance.persistence) ? void 0 : e.get_property($9052383c1c4e5569$var$ve)) && void 0 !== i ? i : {
            tokens: s,
            last: o
        };
        a.tokens += (o - a.last) / 1e3 * n, a.last = o, a.tokens > s && (a.tokens = s);
        var l = a.tokens < 1;
        return l || t || (a.tokens = Math.max(0, a.tokens - 1)), !l || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + n + " events per second and " + s + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = l, null == (r = this.instance.persistence) || r.set_property($9052383c1c4e5569$var$ve, a), {
            isRateLimited: l,
            remainingTokens: a.tokens
        };
    }
    isServerRateLimited(t) {
        var i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
}
var $9052383c1c4e5569$var$vo = $9052383c1c4e5569$var$Si("[RemoteConfig]");
class $9052383c1c4e5569$var$co {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null == (t = $9052383c1c4e5569$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.config;
    }
    Te(t) {
        var i, e;
        null != (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) && i.loadExternalDependency ? null == (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "remote-config", ()=>t(this.remoteConfig)) : ($9052383c1c4e5569$var$vo.error("PostHog Extensions not found. Cannot load remote config."), t());
    }
    Ie(t) {
        this._instance._send_request({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"),
            callback: (i)=>{
                t(i.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $9052383c1c4e5569$var$vo.info("Using preloaded remote config", this.remoteConfig), void this.yi(this.remoteConfig);
            if (this._instance.M()) return void $9052383c1c4e5569$var$vo.warn("Remote config is disabled. Falling back to local config.");
            this.Te((t)=>{
                if (!t) return $9052383c1c4e5569$var$vo.info("No config found after loading remote JS config. Falling back to JSON."), void this.Ie((t)=>{
                    this.yi(t);
                });
                this.yi(t);
            });
        } catch (t) {
            $9052383c1c4e5569$var$vo.error("Error loading remote config", t);
        }
    }
    yi(t) {
        t ? this._instance.config.__preview_remote_config ? (this._instance.yi(t), !1 !== t.hasFeatureFlags && this._instance.featureFlags.ensureFlagsLoaded()) : $9052383c1c4e5569$var$vo.info("__preview_remote_config is disabled. Logging config instead", t) : $9052383c1c4e5569$var$vo.error("Failed to fetch remote config from PostHog.");
    }
}
var $9052383c1c4e5569$var$fo = 3e3;
class $9052383c1c4e5569$var$po {
    constructor(t, i){
        this.Ce = !0, this.Re = [], this.Fe = $9052383c1c4e5569$var$K((null == i ? void 0 : i.flush_interval_ms) || $9052383c1c4e5569$var$fo, 250, 5e3, $9052383c1c4e5569$var$$i.createLogger("flush interval"), $9052383c1c4e5569$var$fo), this.Oe = t;
    }
    enqueue(t) {
        this.Re.push(t), this.Me || this.Ae();
    }
    unload() {
        this.je();
        var t = this.Re.length > 0 ? this.De() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.Oe($9052383c1c4e5569$var$g({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.Ce = !1, this.Ae();
    }
    Ae() {
        var t = this;
        this.Ce || (this.Me = setTimeout(()=>{
            if (this.je(), this.Re.length > 0) {
                var i = this.De(), e = function() {
                    var e = i[r], s = (new Date).getTime();
                    e.data && $9052383c1c4e5569$var$I(e.data) && $9052383c1c4e5569$var$Ci(e.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.Oe(e);
                };
                for(var r in i)e();
            }
        }, this.Fe));
    }
    je() {
        clearTimeout(this.Me), this.Me = void 0;
    }
    De() {
        var t = {};
        return $9052383c1c4e5569$var$Ci(this.Re, (i)=>{
            var e, r = i, s = (r ? r.batchKey : null) || r.url;
            $9052383c1c4e5569$var$O(t[s]) && (t[s] = $9052383c1c4e5569$var$g({}, r, {
                data: []
            })), null == (e = t[s].data) || e.push(r.data);
        }), this.Re = [], t;
    }
}
var $9052383c1c4e5569$var$go = [
    "retriesPerformedSoFar"
];
class $9052383c1c4e5569$var$_o {
    constructor(i){
        this.Le = !1, this.Ne = 3e3, this.Re = [], this._instance = i, this.Re = [], this.Ue = !0, !$9052383c1c4e5569$var$O($9052383c1c4e5569$var$t) && "onLine" in $9052383c1c4e5569$var$t.navigator && (this.Ue = $9052383c1c4e5569$var$t.navigator.onLine, this.ze = ()=>{
            this.Ue = !0, this.Lt();
        }, this.He = ()=>{
            this.Ue = !1;
        }, $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$t, "online", this.ze), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$t, "offline", this.He));
    }
    get length() {
        return this.Re.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: i } = t, e = $9052383c1c4e5569$var$_(t, $9052383c1c4e5569$var$go);
        $9052383c1c4e5569$var$N(i) && (e.url = $9052383c1c4e5569$var$un(e.url, {
            retry_count: i
        })), this._instance._send_request($9052383c1c4e5569$var$g({}, e, {
            callback: (t)=>{
                200 !== t.statusCode && (t.statusCode < 400 || t.statusCode >= 500) && (null != i ? i : 0) < 10 ? this.Be($9052383c1c4e5569$var$g({
                    retriesPerformedSoFar: i
                }, e)) : null == e.callback || e.callback(t);
            }
        }));
    }
    Be(t) {
        var i = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = i + 1;
        var e = function(t) {
            var i = 3e3 * Math.pow(2, t), e = i / 2, r = Math.min(18e5, i), s = (Math.random() - .5) * (r - e);
            return Math.ceil(r + s);
        }(i), r = Date.now() + e;
        this.Re.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + e;
        navigator.onLine || (s += " (Browser is offline)"), $9052383c1c4e5569$var$$i.warn(s), this.Le || (this.Le = !0, this.qe());
    }
    qe() {
        if (this.We && clearTimeout(this.We), 0 === this.Re.length) return this.Le = !1, void (this.We = void 0);
        this.We = setTimeout(()=>{
            this.Ue && this.Re.length > 0 && this.Lt(), this.qe();
        }, this.Ne);
    }
    Lt() {
        var t = Date.now(), i = [], e = this.Re.filter((e)=>e.retryAt < t || (i.push(e), !1));
        if (this.Re = i, e.length > 0) for (var { requestOptions: r } of e)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: i } of (this.We && (clearTimeout(this.We), this.We = void 0), this.Le = !1, $9052383c1c4e5569$var$O($9052383c1c4e5569$var$t) || (this.ze && ($9052383c1c4e5569$var$t.removeEventListener("online", this.ze), this.ze = void 0), this.He && ($9052383c1c4e5569$var$t.removeEventListener("offline", this.He), this.He = void 0)), this.Re))try {
            this._instance._send_request($9052383c1c4e5569$var$g({}, i, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $9052383c1c4e5569$var$$i.error(t);
        }
        this.Re = [];
    }
}
class $9052383c1c4e5569$var$mo {
    constructor(t){
        this.Ge = ()=>{
            var t, i, e, r;
            this.Ve || (this.Ve = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.Ve.lastScrollY = Math.ceil(n), this.Ve.maxScrollY = Math.max(n, null !== (t = this.Ve.maxScrollY) && void 0 !== t ? t : 0), this.Ve.maxScrollHeight = Math.max(o, null !== (i = this.Ve.maxScrollHeight) && void 0 !== i ? i : 0), this.Ve.lastContentY = a, this.Ve.maxContentY = Math.max(a, null !== (e = this.Ve.maxContentY) && void 0 !== e ? e : 0), this.Ve.maxContentHeight = Math.max(l, null !== (r = this.Ve.maxContentHeight) && void 0 !== r ? r : 0);
        }, this._instance = t;
    }
    getContext() {
        return this.Ve;
    }
    resetContext() {
        var t = this.Ve;
        return setTimeout(this.Ge, 0), t;
    }
    startMeasuringScrollPosition() {
        $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$t, "scroll", this.Ge, {
            capture: !0
        }), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$t, "scrollend", this.Ge, {
            capture: !0
        }), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$t, "resize", this.Ge);
    }
    scrollElement() {
        if (!this._instance.config.scroll_root_selector) return null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.document.documentElement;
        var i = $9052383c1c4e5569$var$I(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [
            this._instance.config.scroll_root_selector
        ];
        for (var e of i){
            var r = null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.document.querySelector(e);
            if (r) return r;
        }
    }
    scrollY() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollTop || 0;
        }
        return $9052383c1c4e5569$var$t && ($9052383c1c4e5569$var$t.scrollY || $9052383c1c4e5569$var$t.pageYOffset || $9052383c1c4e5569$var$t.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollLeft || 0;
        }
        return $9052383c1c4e5569$var$t && ($9052383c1c4e5569$var$t.scrollX || $9052383c1c4e5569$var$t.pageXOffset || $9052383c1c4e5569$var$t.document.documentElement.scrollLeft) || 0;
    }
}
var $9052383c1c4e5569$var$bo = (t)=>$9052383c1c4e5569$var$ds(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class $9052383c1c4e5569$var$yo {
    constructor(t, i, e, r){
        this.Je = (t)=>{
            var i = this.Ke();
            if (!i || i.sessionId !== t) {
                var e = {
                    sessionId: t,
                    props: this.Ye(this._instance)
                };
                this.Xe.register({
                    [$9052383c1c4e5569$var$de]: e
                });
            }
        }, this._instance = t, this.Qe = i, this.Xe = e, this.Ye = r || $9052383c1c4e5569$var$bo, this.Qe.onSessionId(this.Je);
    }
    Ke() {
        return this.Xe.props[$9052383c1c4e5569$var$de];
    }
    getSetOnceProps() {
        var t, i = null == (t = this.Ke()) ? void 0 : t.props;
        return i ? "r" in i ? $9052383c1c4e5569$var$vs(i) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $9052383c1c4e5569$var$Ci($9052383c1c4e5569$var$ji(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t["$session_entry_" + $9052383c1c4e5569$var$E(e)] = i;
        }), t;
    }
}
var $9052383c1c4e5569$var$wo = $9052383c1c4e5569$var$Si("[SessionId]");
class $9052383c1c4e5569$var$xo {
    on(t, i) {
        return this.Ze.on(t, i);
    }
    constructor(t, i, e){
        var r;
        if (this.tr = [], this.ir = void 0, this.Ze = new $9052383c1c4e5569$var$to, this.er = (t, i)=>!(!$9052383c1c4e5569$var$N(t) || !$9052383c1c4e5569$var$N(i)) && Math.abs(t - i) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if ("always" === t.config.cookieless_mode) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.R = t.config, this.Xe = t.persistence, this.rr = void 0, this.sr = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.nr = i || $9052383c1c4e5569$var$yr, this.ar = e || $9052383c1c4e5569$var$yr;
        var s = this.R.persistence_name || this.R.token, n = this.R.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * $9052383c1c4e5569$var$K(n, 60, 36e3, $9052383c1c4e5569$var$wo.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.lr(), this.ur = "ph_" + s + "_window_id", this.hr = "ph_" + s + "_primary_window_exists", this.dr()) {
            var o = $9052383c1c4e5569$var$Fr.W(this.ur), a = $9052383c1c4e5569$var$Fr.W(this.hr);
            o && !a ? this.rr = o : $9052383c1c4e5569$var$Fr.V(this.ur), $9052383c1c4e5569$var$Fr.G(this.hr, !0);
        }
        if (null != (r = this.R.bootstrap) && r.sessionID) try {
            var l = ((t)=>{
                var i = t.replace(/-/g, "");
                if (32 !== i.length) throw new Error("Not a valid UUID");
                if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                return parseInt(i.substring(0, 12), 16);
            })(this.R.bootstrap.sessionID);
            this.vr(this.R.bootstrap.sessionID, (new Date).getTime(), l);
        } catch (t) {
            $9052383c1c4e5569$var$wo.error("Invalid sessionID in bootstrap", t);
        }
        this.cr();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $9052383c1c4e5569$var$O(this.tr) && (this.tr = []), this.tr.push(t), this.sr && t(this.sr, this.rr), ()=>{
            this.tr = this.tr.filter((i)=>i !== t);
        };
    }
    dr() {
        return "memory" !== this.R.persistence && !this.Xe.ki && $9052383c1c4e5569$var$Fr.H();
    }
    pr(t) {
        t !== this.rr && (this.rr = t, this.dr() && $9052383c1c4e5569$var$Fr.G(this.ur, t));
    }
    gr() {
        return this.rr ? this.rr : this.dr() ? $9052383c1c4e5569$var$Fr.W(this.ur) : null;
    }
    vr(t, i, e) {
        t === this.sr && i === this._sessionActivityTimestamp && e === this._sessionStartTimestamp || (this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.sr = t, this.Xe.register({
            [$9052383c1c4e5569$var$ie]: [
                i,
                t,
                e
            ]
        }));
    }
    _r() {
        var t = this.Xe.props[$9052383c1c4e5569$var$ie];
        return $9052383c1c4e5569$var$I(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.vr(null, null, null);
    }
    destroy() {
        clearTimeout(this.mr), this.mr = void 0, this.ir && $9052383c1c4e5569$var$t && ($9052383c1c4e5569$var$t.removeEventListener("beforeunload", this.ir, {
            capture: !1
        }), this.ir = void 0), this.tr = [];
    }
    cr() {
        this.ir = ()=>{
            this.dr() && $9052383c1c4e5569$var$Fr.V(this.hr);
        }, $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$t, "beforeunload", this.ir, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, i) {
        if (void 0 === t && (t = !1), void 0 === i && (i = null), "always" === this.R.cookieless_mode) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        var e = i || (new Date).getTime(), [r, s, n] = this._r(), o = this.gr(), a = $9052383c1c4e5569$var$N(n) && Math.abs(e - n) > 864e5, l = !1, u = !s, h = !u && !t && this.er(e, r);
        u || h || a ? (s = this.nr(), o = this.ar(), $9052383c1c4e5569$var$wo.info("new session ID generated", {
            sessionId: s,
            windowId: o,
            changeReason: {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            }
        }), n = e, l = !0) : o || (o = this.ar(), l = !0);
        var d = !!$9052383c1c4e5569$var$N(r) && t && !a ? r : e, v = !$9052383c1c4e5569$var$N(n) ? (new Date).getTime() : n;
        return this.pr(o), this.vr(s, d, v), t || this.lr(), l && this.tr.forEach((t)=>t(s, o, l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0)), {
            sessionId: s,
            windowId: o,
            sessionStartTimestamp: v,
            changeReason: l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0,
            lastActivityTimestamp: r
        };
    }
    lr() {
        clearTimeout(this.mr), this.mr = setTimeout(()=>{
            var [t] = this._r();
            if (this.er((new Date).getTime(), t)) {
                var i = this.sr;
                this.resetSessionId(), this.Ze.emit("forcedIdleReset", {
                    idleSessionId: i
                });
            }
        }, 1.1 * this.sessionTimeoutMs);
    }
}
var $9052383c1c4e5569$var$Eo = [
    "$set_once",
    "$set"
], $9052383c1c4e5569$var$$o = $9052383c1c4e5569$var$Si("[SiteApps]");
class $9052383c1c4e5569$var$So {
    constructor(t){
        this._instance = t, this.br = [], this.apps = {};
    }
    get isEnabled() {
        return !!this._instance.config.opt_in_site_apps;
    }
    yr(t, i) {
        if (i) {
            var e = this.globalsForEvent(i);
            this.br.push(e), this.br.length > 1e3 && (this.br = this.br.slice(10));
        }
    }
    get siteAppLoaders() {
        var t;
        return null == (t = $9052383c1c4e5569$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.siteApps;
    }
    init() {
        if (this.isEnabled) {
            var t = this._instance._addCaptureHook(this.yr.bind(this));
            this.wr = ()=>{
                t(), this.br = [], this.wr = void 0;
            };
        }
    }
    globalsForEvent(t) {
        var i, e, r, s, n, o, a;
        if (!t) throw new Error("Event payload is required");
        var l = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
        for (var [d, v] of Object.entries(h))l[d] = {
            id: u[d],
            type: d,
            properties: v
        };
        var { $set_once: c, $set: f } = t;
        return {
            event: $9052383c1c4e5569$var$g({}, $9052383c1c4e5569$var$_(t, $9052383c1c4e5569$var$Eo), {
                properties: $9052383c1c4e5569$var$g({}, t.properties, f ? {
                    $set: $9052383c1c4e5569$var$g({}, null !== (i = null == (e = t.properties) ? void 0 : e.$set) && void 0 !== i ? i : {}, f)
                } : {}, c ? {
                    $set_once: $9052383c1c4e5569$var$g({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                } : {}),
                elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
            }),
            person: {
                properties: this._instance.get_property("$stored_person_properties")
            },
            groups: l
        };
    }
    setupSiteApp(t) {
        var i = this.apps[t.id], e = ()=>{
            var e;
            (!i.errored && this.br.length && ($9052383c1c4e5569$var$$o.info("Processing " + this.br.length + " events for site app with id " + t.id), this.br.forEach((t)=>null == i.processEvent ? void 0 : i.processEvent(t)), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored)) && (null == (e = this.wr) || e.call(this));
        }, r = !1, s = (s)=>{
            i.errored = !s, i.loaded = !0, $9052383c1c4e5569$var$$o.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && e();
        };
        try {
            var { processEvent: n } = t.init({
                posthog: this._instance,
                callback: (t)=>{
                    s(t);
                }
            });
            n && (i.processEvent = n), r = !0;
        } catch (i) {
            $9052383c1c4e5569$var$$o.error("Error while initializing PostHog app with config id " + t.id, i), s(!1);
        }
        if (r && i.loaded) try {
            e();
        } catch (e) {
            $9052383c1c4e5569$var$$o.error("Error while processing buffered events PostHog app with config id " + t.id, e), i.errored = !0;
        }
    }
    Er() {
        var t = this.siteAppLoaders || [];
        for (var i of t)this.apps[i.id] = {
            id: i.id,
            loaded: !1,
            errored: !1,
            processedBuffer: !1
        };
        for (var e of t)this.setupSiteApp(e);
    }
    $r(t) {
        if (0 !== Object.keys(this.apps).length) {
            var i = this.globalsForEvent(t);
            for (var e of Object.values(this.apps))try {
                null == e.processEvent || e.processEvent(i);
            } catch (i) {
                $9052383c1c4e5569$var$$o.error("Error while processing event " + t.event + " for site app " + e.id, i);
            }
        }
    }
    onRemoteConfig(t) {
        var i, e, r, s = this;
        if (null != (i = this.siteAppLoaders) && i.length) return this.isEnabled ? (this.Er(), void this._instance.on("eventCaptured", (t)=>this.$r(t))) : void $9052383c1c4e5569$var$$o.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        if (null == (e = this.wr) || e.call(this), null != (r = t.siteApps) && r.length) {
            if (this.isEnabled) {
                var n = function(t) {
                    var i;
                    $9052383c1c4e5569$var$v["__$$ph_site_app_" + t] = s._instance, null == (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == i.loadSiteApp || i.loadSiteApp(s._instance, a, (i)=>{
                        if (i) return $9052383c1c4e5569$var$$o.error("Error while initializing PostHog app with config id " + t, i);
                    });
                };
                for (var { id: o, url: a } of t.siteApps)n(o);
            } else $9052383c1c4e5569$var$$o.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        }
    }
}
var $9052383c1c4e5569$var$ko = function(t, i) {
    if (!t) return !1;
    var e = t.userAgent;
    if (e && $9052383c1c4e5569$var$b(e, i)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$9052383c1c4e5569$var$b(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
}, $9052383c1c4e5569$var$Po = function(t) {
    return t.US = "us", t.EU = "eu", t.CUSTOM = "custom", t;
}({}), $9052383c1c4e5569$var$To = "i.posthog.com";
class $9052383c1c4e5569$var$Io {
    constructor(t){
        this.Sr = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get flagsApiHost() {
        var t = this.instance.config.flags_api_host;
        return t ? t.trim().replace(/\/$/, "") : this.apiHost;
    }
    get uiHost() {
        var t, i = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace("." + $9052383c1c4e5569$var$To, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.Sr[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Sr[this.apiHost] = $9052383c1c4e5569$var$Po.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Sr[this.apiHost] = $9052383c1c4e5569$var$Po.EU : this.Sr[this.apiHost] = $9052383c1c4e5569$var$Po.CUSTOM), this.Sr[this.apiHost];
    }
    endpointFor(t, i) {
        if (void 0 === i && (i = ""), i && (i = "/" === i[0] ? i : "/" + i), "ui" === t) return this.uiHost + i;
        if ("flags" === t) return this.flagsApiHost + i;
        if (this.region === $9052383c1c4e5569$var$Po.CUSTOM) return this.apiHost + i;
        var e = $9052383c1c4e5569$var$To + i;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + e;
            case "api":
                return "https://" + this.region + "." + e;
        }
    }
}
var $9052383c1c4e5569$var$Co = {
    icontains: (i, e)=>!!$9052383c1c4e5569$var$t && e.href.toLowerCase().indexOf(i.toLowerCase()) > -1,
    not_icontains: (i, e)=>!!$9052383c1c4e5569$var$t && -1 === e.href.toLowerCase().indexOf(i.toLowerCase()),
    regex: (i, e)=>!!$9052383c1c4e5569$var$t && $9052383c1c4e5569$var$cn(e.href, i),
    not_regex: (i, e)=>!!$9052383c1c4e5569$var$t && !$9052383c1c4e5569$var$cn(e.href, i),
    exact: (t, i)=>i.href === t,
    is_not: (t, i)=>i.href !== t
};
class $9052383c1c4e5569$var$Ro {
    constructor(t){
        var i = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), i.getWebExperiments((t)=>{
                $9052383c1c4e5569$var$Ro.kr("retrieved web experiments from the server"), i.Pr = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var e;
                        if (i.Pr) $9052383c1c4e5569$var$Ro.kr("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (e = i.Pr) || e.set(t.feature_flag_key, t);
                        var r = i._instance.getFeatureFlag(t.feature_flag_key);
                        $9052383c1c4e5569$var$M(r) && t.variants[r] && i.Tr(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $9052383c1c4e5569$var$Ro.Ir(n) && i.Tr(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this._instance = t, this._instance.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    onFeatureFlags(t) {
        if (this._is_bot()) $9052383c1c4e5569$var$Ro.kr("Refusing to render web experiment since the viewer is a likely bot");
        else if (!this._instance.config.disable_web_experiments) {
            if ($9052383c1c4e5569$var$D(this.Pr)) return this.Pr = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $9052383c1c4e5569$var$Ro.kr("applying feature flags", t), t.forEach((t)=>{
                var i;
                if (this.Pr && null != (i = this.Pr) && i.has(t)) {
                    var e, r = this._instance.getFeatureFlag(t), s = null == (e = this.Pr) ? void 0 : e.get(t);
                    r && null != s && s.variants[r] && this.Tr(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $9052383c1c4e5569$var$Ro.getWindowLocation();
        if (null != t && t.search) {
            var i = $9052383c1c4e5569$var$sr(null == t ? void 0 : t.search, "__experiment_id"), e = $9052383c1c4e5569$var$sr(null == t ? void 0 : t.search, "__experiment_variant");
            i && e && ($9052383c1c4e5569$var$Ro.kr("previewing web experiments " + i + " && " + e), this.getWebExperiments((t)=>{
                this.Cr(parseInt(i), e, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this._instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, i, e) {
        if (this._instance.config.disable_web_experiments && !e) return t([]);
        var r = this._instance.get_property("$web_experiments");
        if (r && !i) return t(r);
        this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this._instance.config.token),
            method: "GET",
            callback: (i)=>{
                if (200 !== i.statusCode || !i.json) return t([]);
                var e = i.json.experiments || [];
                return t(e);
            }
        });
    }
    Cr(t, i, e) {
        var r = e.filter((i)=>i.id === t);
        r && r.length > 0 && ($9052383c1c4e5569$var$Ro.kr("Previewing web experiment [" + r[0].name + "] with variant [" + i + "]"), this.Tr(r[0].name, i, r[0].variants[i].transforms));
    }
    static Ir(t) {
        return !$9052383c1c4e5569$var$D(t.conditions) && $9052383c1c4e5569$var$Ro.Rr(t) && $9052383c1c4e5569$var$Ro.Fr(t);
    }
    static Rr(t) {
        var i;
        if ($9052383c1c4e5569$var$D(t.conditions) || $9052383c1c4e5569$var$D(null == (i = t.conditions) ? void 0 : i.url)) return !0;
        var e, r, s, n = $9052383c1c4e5569$var$Ro.getWindowLocation();
        return !!n && (null == (e = t.conditions) || !e.url || $9052383c1c4e5569$var$Co[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.location;
    }
    static Fr(t) {
        var i;
        if ($9052383c1c4e5569$var$D(t.conditions) || $9052383c1c4e5569$var$D(null == (i = t.conditions) ? void 0 : i.utm)) return !0;
        var e = $9052383c1c4e5569$var$os();
        if (e.utm_source) {
            var r, s, n, o, a, l, u, h, d = null == (r = t.conditions) || null == (r = r.utm) || !r.utm_campaign || (null == (s = t.conditions) || null == (s = s.utm) ? void 0 : s.utm_campaign) == e.utm_campaign, v = null == (n = t.conditions) || null == (n = n.utm) || !n.utm_source || (null == (o = t.conditions) || null == (o = o.utm) ? void 0 : o.utm_source) == e.utm_source, c = null == (a = t.conditions) || null == (a = a.utm) || !a.utm_medium || (null == (l = t.conditions) || null == (l = l.utm) ? void 0 : l.utm_medium) == e.utm_medium, f = null == (u = t.conditions) || null == (u = u.utm) || !u.utm_term || (null == (h = t.conditions) || null == (h = h.utm) ? void 0 : h.utm_term) == e.utm_term;
            return d && c && f && v;
        }
        return !1;
    }
    static kr(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        $9052383c1c4e5569$var$$i.info("[WebExperiments] " + t, e);
    }
    Tr(t, i, e) {
        this._is_bot() ? $9052383c1c4e5569$var$Ro.kr("Refusing to render web experiment since the viewer is a likely bot") : "control" !== i ? e.forEach((e)=>{
            if (e.selector) {
                var r;
                $9052383c1c4e5569$var$Ro.kr("applying transform of variant " + i + " for experiment " + t + " ", e);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(e.selector);
                null == s || s.forEach((t)=>{
                    var i = t;
                    e.html && (i.innerHTML = e.html), e.css && i.setAttribute("style", e.css);
                });
            }
        }) : $9052383c1c4e5569$var$Ro.kr("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $9052383c1c4e5569$var$n && this._instance ? $9052383c1c4e5569$var$ko($9052383c1c4e5569$var$n, this._instance.config.custom_blocked_useragents) : void 0;
    }
}
var $9052383c1c4e5569$var$Fo = $9052383c1c4e5569$var$Si("[PostHog ExternalIntegrations]"), $9052383c1c4e5569$var$Oo = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
class $9052383c1c4e5569$var$Mo {
    constructor(t){
        this._instance = t;
    }
    it(t, i) {
        var e;
        null == (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, t, (t)=>{
            if (t) return $9052383c1c4e5569$var$Fo.error("failed to load script", t);
            i();
        });
    }
    startIfEnabledOrStop() {
        var t = this, i = function(i) {
            var e, s, n;
            (!r || null != (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) && null != (e = e.integrations) && e[i] || t.it($9052383c1c4e5569$var$Oo[i], ()=>{
                var e;
                null == (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == (e = e.integrations) || null == (e = e[i]) || e.start(t._instance);
            }), !r && null != (s = $9052383c1c4e5569$var$v.__PosthogExtensions__) && null != (s = s.integrations) && s[i]) && (null == (n = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == (n = n.integrations) || null == (n = n[i]) || n.stop());
        };
        for (var [e, r] of Object.entries(null !== (s = this._instance.config.integrations) && void 0 !== s ? s : {})){
            var s;
            i(e);
        }
    }
}
var $9052383c1c4e5569$var$Ao = "[SessionRecording]", $9052383c1c4e5569$var$jo = $9052383c1c4e5569$var$Si($9052383c1c4e5569$var$Ao);
class $9052383c1c4e5569$var$Do {
    get started() {
        var t;
        return !(null == (t = this.Or) || !t.isStarted);
    }
    get status() {
        return this.Or ? this.Or.status : this.Mr && !this.Ar ? "disabled" : "lazy_loading";
    }
    constructor(t){
        if (this._forceAllowLocalhostNetworkCapture = !1, this.Mr = !1, this.jr = void 0, this._instance = t, !this._instance.sessionManager) throw $9052383c1c4e5569$var$jo.error("started without valid sessionManager"), new Error($9052383c1c4e5569$var$Ao + " started without valid sessionManager. This is a bug.");
        if ("always" === this._instance.config.cookieless_mode) throw new Error($9052383c1c4e5569$var$Ao + ' cannot be used with cookieless_mode="always"');
    }
    get Ar() {
        var i, e = !(null == (i = this._instance.get_property($9052383c1c4e5569$var$te)) || !i.enabled), r = !this._instance.config.disable_session_recording, s = this._instance.config.disable_session_recording || this._instance.consent.isOptedOut();
        return $9052383c1c4e5569$var$t && e && r && !s;
    }
    startIfEnabledOrStop(t) {
        var i;
        if (!this.Ar || null == (i = this.Or) || !i.isStarted) {
            var e = !$9052383c1c4e5569$var$O(Object.assign) && !$9052383c1c4e5569$var$O(Array.from);
            this.Ar && e ? (this.Dr(t), $9052383c1c4e5569$var$jo.info("starting")) : this.stopRecording();
        }
    }
    Dr(t) {
        var i, e, r;
        this.Ar && (null != $9052383c1c4e5569$var$v && null != (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) && null != (i = i.rrweb) && i.record && null != (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) && e.initSessionRecording ? this.Lr(t) : null == (r = $9052383c1c4e5569$var$v.__PosthogExtensions__) || null == r.loadExternalDependency || r.loadExternalDependency(this._instance, this.Nr, (i)=>{
            if (i) return $9052383c1c4e5569$var$jo.error("could not load recorder", i);
            this.Lr(t);
        }));
    }
    stopRecording() {
        var t, i;
        null == (t = this.jr) || t.call(this), this.jr = void 0, null == (i = this.Or) || i.stop();
    }
    Ur() {
        var t;
        null == (t = this._instance.persistence) || t.unregister($9052383c1c4e5569$var$ee);
    }
    zr(t) {
        if (this._instance.persistence) {
            var i, e, r = this._instance.persistence, s = ()=>{
                var i = !1 === t.sessionRecording ? void 0 : t.sessionRecording, e = null == i ? void 0 : i.sampleRate, s = $9052383c1c4e5569$var$D(e) ? null : parseFloat(e);
                $9052383c1c4e5569$var$D(s) && this.Ur();
                var n = null == i ? void 0 : i.minimumDurationMilliseconds;
                r.register({
                    [$9052383c1c4e5569$var$te]: $9052383c1c4e5569$var$g({
                        enabled: !!i
                    }, i, {
                        networkPayloadCapture: $9052383c1c4e5569$var$g({
                            capturePerformance: t.capturePerformance
                        }, null == i ? void 0 : i.networkPayloadCapture),
                        canvasRecording: {
                            enabled: null == i ? void 0 : i.recordCanvas,
                            fps: null == i ? void 0 : i.canvasFps,
                            quality: null == i ? void 0 : i.canvasQuality
                        },
                        sampleRate: s,
                        minimumDurationMilliseconds: $9052383c1c4e5569$var$O(n) ? null : n,
                        endpoint: null == i ? void 0 : i.endpoint,
                        triggerMatchType: null == i ? void 0 : i.triggerMatchType,
                        masking: null == i ? void 0 : i.masking,
                        urlTriggers: null == i ? void 0 : i.urlTriggers
                    })
                });
            };
            s(), null == (i = this.jr) || i.call(this), this.jr = null == (e = this._instance.sessionManager) ? void 0 : e.onSessionId(s);
        }
    }
    onRemoteConfig(t) {
        "sessionRecording" in t ? !1 !== t.sessionRecording ? (this.zr(t), this.Mr = !0, this.startIfEnabledOrStop()) : this.Mr = !0 : $9052383c1c4e5569$var$jo.info("skipping remote config with no sessionRecording", t);
    }
    log(t, i) {
        var e;
        void 0 === i && (i = "log"), null != (e = this.Or) && e.log ? this.Or.log(t, i) : $9052383c1c4e5569$var$jo.warn("log called before recorder was ready");
    }
    get Nr() {
        var t, i, e = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.get_property($9052383c1c4e5569$var$te);
        return (null == e || null == (i = e.scriptConfig) ? void 0 : i.script) || "lazy-recorder";
    }
    Lr(t) {
        var i, e;
        if (null == (i = $9052383c1c4e5569$var$v.__PosthogExtensions__) || !i.initSessionRecording) throw Error("Called on script loaded before session recording is available");
        this.Or || (this.Or = null == (e = $9052383c1c4e5569$var$v.__PosthogExtensions__) ? void 0 : e.initSessionRecording(this._instance), this.Or._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture);
        this.Or.start(t);
    }
    onRRwebEmit(t) {
        var i;
        null == (i = this.Or) || null == i.onRRwebEmit || i.onRRwebEmit(t);
    }
    overrideLinkedFlag() {
        var t, i;
        this.Or || null == (i = this._instance.persistence) || i.register({
            $replay_override_linked_flag: !0
        });
        null == (t = this.Or) || t.overrideLinkedFlag();
    }
    overrideSampling() {
        var t, i;
        this.Or || null == (i = this._instance.persistence) || i.register({
            $replay_override_sampling: !0
        });
        null == (t = this.Or) || t.overrideSampling();
    }
    overrideTrigger(t) {
        var i, e;
        this.Or || null == (e = this._instance.persistence) || e.register({
            ["url" === t ? "$replay_override_url_trigger" : "$replay_override_event_trigger"]: !0
        });
        null == (i = this.Or) || i.overrideTrigger(t);
    }
    get sdkDebugProperties() {
        var t;
        return (null == (t = this.Or) ? void 0 : t.sdkDebugProperties) || {
            $recording_status: this.status
        };
    }
    tryAddCustomEvent(t, i) {
        var e;
        return !(null == (e = this.Or) || !e.tryAddCustomEvent(t, i));
    }
}
var $9052383c1c4e5569$var$Lo = {}, $9052383c1c4e5569$var$No = ()=>{}, $9052383c1c4e5569$var$Uo = "posthog", $9052383c1c4e5569$var$zo = !$9052383c1c4e5569$var$an && -1 === (null == $9052383c1c4e5569$var$d ? void 0 : $9052383c1c4e5569$var$d.indexOf("MSIE")) && -1 === (null == $9052383c1c4e5569$var$d ? void 0 : $9052383c1c4e5569$var$d.indexOf("Mozilla")), $9052383c1c4e5569$var$Ho = (i)=>{
    var e;
    return $9052383c1c4e5569$var$g({
        api_host: "https://us.i.posthog.com",
        flags_api_host: null,
        ui_host: null,
        token: "",
        autocapture: !0,
        cross_subdomain_cookie: $9052383c1c4e5569$var$Ni(null == $9052383c1c4e5569$var$o ? void 0 : $9052383c1c4e5569$var$o.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_persisted_properties: [],
        loaded: $9052383c1c4e5569$var$No,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageleave: "if_capture_pageview",
        defaults: null != i ? i : "unset",
        __preview_deferred_init_extensions: !1,
        debug: $9052383c1c4e5569$var$a && $9052383c1c4e5569$var$M(null == $9052383c1c4e5569$var$a ? void 0 : $9052383c1c4e5569$var$a.search) && -1 !== $9052383c1c4e5569$var$a.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_conversations: !1,
        disable_product_tours: !0,
        disable_external_dependency_loading: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $9052383c1c4e5569$var$t || null == (e = $9052383c1c4e5569$var$t.location) ? void 0 : e.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error: (t)=>{
            var i = "Bad HTTP status: " + t.statusCode + " " + t.text;
            $9052383c1c4e5569$var$$i.error(i);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: $9052383c1c4e5569$var$fo
        },
        error_tracking: {},
        _onCapture: $9052383c1c4e5569$var$No,
        __preview_eager_load_replay: !1
    }, ((t)=>({
            rageclick: !(t && t >= "2025-11-30") || {
                content_ignorelist: !0
            },
            capture_pageview: !(t && t >= "2025-05-24") || "history_change",
            session_recording: t && t >= "2025-11-30" ? {
                strictMinimumDuration: !0
            } : {},
            external_scripts_inject_target: t && t >= "2026-01-30" ? "head" : "body",
            internal_or_test_user_hostname: t && t >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0
        }))(i));
}, $9052383c1c4e5569$var$Bo = (t)=>{
    var i = {};
    $9052383c1c4e5569$var$O(t.process_person) || (i.person_profiles = t.process_person), $9052383c1c4e5569$var$O(t.xhr_headers) || (i.request_headers = t.xhr_headers), $9052383c1c4e5569$var$O(t.cookie_name) || (i.persistence_name = t.cookie_name), $9052383c1c4e5569$var$O(t.disable_cookie) || (i.disable_persistence = t.disable_cookie), $9052383c1c4e5569$var$O(t.store_google) || (i.save_campaign_params = t.store_google), $9052383c1c4e5569$var$O(t.verbose) || (i.debug = t.verbose);
    var e = $9052383c1c4e5569$var$Ri({}, i, t);
    return $9052383c1c4e5569$var$I(t.property_blacklist) && ($9052383c1c4e5569$var$O(t.property_denylist) ? e.property_denylist = t.property_blacklist : $9052383c1c4e5569$var$I(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $9052383c1c4e5569$var$$i.error("Invalid value for property_denylist config: " + t.property_denylist)), e;
};
class $9052383c1c4e5569$var$qo {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get Hr() {
        return this.__forceAllowLocalhost;
    }
    set Hr(t) {
        $9052383c1c4e5569$var$$i.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $9052383c1c4e5569$export$a9d6b9cbf49b8241 {
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        this.webPerformance = new $9052383c1c4e5569$var$qo, this.Br = !1, this.version = $9052383c1c4e5569$var$c.LIB_VERSION, this.qr = new $9052383c1c4e5569$var$to, this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $9052383c1c4e5569$var$Ho(), this.SentryIntegration = $9052383c1c4e5569$var$Vr, this.sentryIntegration = (t)=>(function(t, i) {
                var e = $9052383c1c4e5569$var$Gr(t, i);
                return {
                    name: $9052383c1c4e5569$var$Wr,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.Wr = !1, this.Gr = null, this.Vr = null, this.Jr = null, this.featureFlags = new $9052383c1c4e5569$var$Rn(this), this.toolbar = new $9052383c1c4e5569$var$Qr(this), this.scrollManager = new $9052383c1c4e5569$var$mo(this), this.pageViewManager = new $9052383c1c4e5569$var$xs(this), this.surveys = new $9052383c1c4e5569$var$no(this), this.conversations = new $9052383c1c4e5569$var$ao(this), this.logs = new $9052383c1c4e5569$var$lo(this), this.experiments = new $9052383c1c4e5569$var$Ro(this), this.exceptions = new $9052383c1c4e5569$var$bn(this), this.rateLimiter = new $9052383c1c4e5569$var$ho(this), this.requestRouter = new $9052383c1c4e5569$var$Io(this), this.consent = new $9052383c1c4e5569$var$Mr(this), this.externalIntegrations = new $9052383c1c4e5569$var$Mo(this), this.people = {
            set: (t, i, e)=>{
                var r = $9052383c1c4e5569$var$M(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(r), null == e || e({});
            },
            set_once: (t, i, e)=>{
                var r = $9052383c1c4e5569$var$M(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, r), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$9052383c1c4e5569$var$$i.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, i, e) {
        if (e && e !== $9052383c1c4e5569$var$Uo) {
            var r, s = null !== (r = $9052383c1c4e5569$var$Lo[e]) && void 0 !== r ? r : new $9052383c1c4e5569$export$a9d6b9cbf49b8241;
            return s._init(t, i, e), $9052383c1c4e5569$var$Lo[e] = s, $9052383c1c4e5569$var$Lo[$9052383c1c4e5569$var$Uo][e] = s, s;
        }
        return this._init(t, i, e);
    }
    _init(i, e, r) {
        var s;
        if (void 0 === e && (e = {}), $9052383c1c4e5569$var$O(i) || $9052383c1c4e5569$var$A(i)) return $9052383c1c4e5569$var$$i.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, e.debug = this.Kr(e.debug), this.Yr = e, this.Xr = [], e.person_profiles && (this.Vr = e.person_profiles), this.set_config($9052383c1c4e5569$var$Ri({}, $9052383c1c4e5569$var$Ho(e.defaults), $9052383c1c4e5569$var$Bo(e), {
            name: r,
            token: i
        })), this.config.on_xhr_error && $9052383c1c4e5569$var$$i.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = e.disable_compression ? void 0 : $9052383c1c4e5569$export$6a00d17b5aff0af.GZipJS;
        var n = this.Qr();
        this.persistence = new $9052383c1c4e5569$var$On(this.config, n), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $9052383c1c4e5569$var$On($9052383c1c4e5569$var$g({}, this.config, {
            persistence: "sessionStorage"
        }), n);
        var o = $9052383c1c4e5569$var$g({}, this.persistence.props), a = $9052383c1c4e5569$var$g({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.Zr = new $9052383c1c4e5569$var$po((t)=>this.ts(t), this.config.request_queue_config), this.es = new $9052383c1c4e5569$var$_o(this), this.__request_queue = [];
        var l = "always" === this.config.cookieless_mode || "on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut();
        if (l || (this.sessionManager = new $9052383c1c4e5569$var$xo(this), this.sessionPropsManager = new $9052383c1c4e5569$var$yo(this, this.sessionManager, this.persistence)), this.config.__preview_deferred_init_extensions ? ($9052383c1c4e5569$var$$i.info("Deferring extension initialization to improve startup performance"), setTimeout(()=>{
            this.rs(l);
        }, 0)) : ($9052383c1c4e5569$var$$i.info("Initializing extensions synchronously"), this.rs(l)), $9052383c1c4e5569$var$c.DEBUG = $9052383c1c4e5569$var$c.DEBUG || this.config.debug, $9052383c1c4e5569$var$c.DEBUG && $9052383c1c4e5569$var$$i.info("Starting in debug mode", {
            this: this,
            config: e,
            thisC: $9052383c1c4e5569$var$g({}, this.config),
            p: o,
            s: a
        }), void 0 !== (null == (s = e.bootstrap) ? void 0 : s.distinctID)) {
            var u, h, d = this.config.get_device_id($9052383c1c4e5569$var$yr()), v = null != (u = e.bootstrap) && u.isIdentifiedID ? d : e.bootstrap.distinctID;
            this.persistence.set_property($9052383c1c4e5569$var$he, null != (h = e.bootstrap) && h.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: e.bootstrap.distinctID,
                $device_id: v
            });
        }
        if (this.ss()) {
            var f, p, _ = Object.keys((null == (f = e.bootstrap) ? void 0 : f.featureFlags) || {}).filter((t)=>{
                var i;
                return !(null == (i = e.bootstrap) || null == (i = i.featureFlags) || !i[t]);
            }).reduce((t, i)=>{
                var r;
                return t[i] = (null == (r = e.bootstrap) || null == (r = r.featureFlags) ? void 0 : r[i]) || !1, t;
            }, {}), m = Object.keys((null == (p = e.bootstrap) ? void 0 : p.featureFlagPayloads) || {}).filter((t)=>_[t]).reduce((t, i)=>{
                var r, s;
                null != (r = e.bootstrap) && null != (r = r.featureFlagPayloads) && r[i] && (t[i] = null == (s = e.bootstrap) || null == (s = s.featureFlagPayloads) ? void 0 : s[i]);
                return t;
            }, {});
            this.featureFlags.receivedFeatureFlags({
                featureFlags: _,
                featureFlagPayloads: m
            });
        }
        if (l) this.register_once({
            distinct_id: $9052383c1c4e5569$var$me,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var b = this.config.get_device_id($9052383c1c4e5569$var$yr());
            this.register_once({
                distinct_id: b,
                $device_id: b
            }, ""), this.persistence.set_property($9052383c1c4e5569$var$he, "anonymous");
        }
        return $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), this.toolbar.maybeLoadToolbar(), e.segment ? $9052383c1c4e5569$var$qr(this, ()=>this.ns()) : this.ns(), $9052383c1c4e5569$var$C(this.config._onCapture) && this.config._onCapture !== $9052383c1c4e5569$var$No && ($9052383c1c4e5569$var$$i.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $9052383c1c4e5569$var$$i.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this;
    }
    rs(t) {
        var i = performance.now();
        this.historyAutocapture = new $9052383c1c4e5569$var$Hr(this), this.historyAutocapture.startIfEnabled();
        var e = [];
        e.push(()=>{
            new $9052383c1c4e5569$var$ts(this).startIfEnabledOrStop();
        }), e.push(()=>{
            var t;
            this.siteApps = new $9052383c1c4e5569$var$So(this), null == (t = this.siteApps) || t.init();
        }), t || e.push(()=>{
            this.sessionRecording = new $9052383c1c4e5569$var$Do(this), this.sessionRecording.startIfEnabledOrStop();
        }), this.config.disable_scroll_properties || e.push(()=>{
            this.scrollManager.startMeasuringScrollPosition();
        }), e.push(()=>{
            this.autocapture = new $9052383c1c4e5569$var$cr(this), this.autocapture.startIfEnabled();
        }), e.push(()=>{
            this.surveys.loadIfEnabled();
        }), e.push(()=>{
            this.logs.loadIfEnabled();
        }), e.push(()=>{
            this.conversations.loadIfEnabled();
        }), e.push(()=>{
            this.productTours = new $9052383c1c4e5569$var$jn(this), this.productTours.loadIfEnabled();
        }), e.push(()=>{
            this.heatmaps = new $9052383c1c4e5569$var$ws(this), this.heatmaps.startIfEnabled();
        }), e.push(()=>{
            this.webVitalsAutocapture = new $9052383c1c4e5569$var$ms(this);
        }), e.push(()=>{
            this.exceptionObserver = new $9052383c1c4e5569$var$Ur(this), this.exceptionObserver.startIfEnabledOrStop();
        }), e.push(()=>{
            this.deadClicksAutocapture = new $9052383c1c4e5569$var$Lr(this, $9052383c1c4e5569$var$Dr), this.deadClicksAutocapture.startIfEnabled();
        }), e.push(()=>{
            if (this.os) {
                var t = this.os;
                this.os = void 0, this.yi(t);
            }
        }), this.ls(e, i);
    }
    ls(t, i) {
        for(; t.length > 0;){
            if (this.config.__preview_deferred_init_extensions) {
                if (performance.now() - i >= 30 && t.length > 0) return void setTimeout(()=>{
                    this.ls(t, i);
                }, 0);
            }
            var e = t.shift();
            if (e) try {
                e();
            } catch (t) {
                $9052383c1c4e5569$var$$i.error("Error initializing extension:", t);
            }
        }
        var r = Math.round(performance.now() - i);
        this.register_for_session({
            $sdk_debug_extensions_init_method: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous",
            $sdk_debug_extensions_init_time_ms: r
        }), this.config.__preview_deferred_init_extensions && $9052383c1c4e5569$var$$i.info("PostHog extensions initialized (" + r + "ms)");
    }
    yi(t) {
        var i, e, r, s, n, a, l, u, h;
        if (!$9052383c1c4e5569$var$o || !$9052383c1c4e5569$var$o.body) return $9052383c1c4e5569$var$$i.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.yi(t);
        }, 500);
        this.config.__preview_deferred_init_extensions && (this.os = t), this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = $9052383c1c4e5569$var$w(t.supportedCompression, $9052383c1c4e5569$export$6a00d17b5aff0af.GZipJS) ? $9052383c1c4e5569$export$6a00d17b5aff0af.GZipJS : $9052383c1c4e5569$var$w(t.supportedCompression, $9052383c1c4e5569$export$6a00d17b5aff0af.Base64) ? $9052383c1c4e5569$export$6a00d17b5aff0af.Base64 : void 0), null != (i = t.analytics) && i.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({
            person_profiles: this.Vr ? this.Vr : "identified_only"
        }), null == (e = this.siteApps) || e.onRemoteConfig(t), null == (r = this.sessionRecording) || r.onRemoteConfig(t), null == (s = this.autocapture) || s.onRemoteConfig(t), null == (n = this.heatmaps) || n.onRemoteConfig(t), this.surveys.onRemoteConfig(t), this.logs.onRemoteConfig(t), this.conversations.onRemoteConfig(t), null == (a = this.productTours) || a.onRemoteConfig(t), null == (l = this.webVitalsAutocapture) || l.onRemoteConfig(t), null == (u = this.exceptionObserver) || u.onRemoteConfig(t), this.exceptions.onRemoteConfig(t), null == (h = this.deadClicksAutocapture) || h.onRemoteConfig(t);
    }
    ns() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $9052383c1c4e5569$var$$i.critical("`loaded` function failed", t);
        }
        if (this.us(), this.config.internal_or_test_user_hostname && null != $9052383c1c4e5569$var$a && $9052383c1c4e5569$var$a.hostname) {
            var t = $9052383c1c4e5569$var$a.hostname, i = this.config.internal_or_test_user_hostname;
            ("string" == typeof i ? t === i : i.test(t)) && this.setInternalOrTestUser();
        }
        this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || "always" === this.config.cookieless_mode) && this.hs();
        }, 1), new $9052383c1c4e5569$var$co(this).load(), this.featureFlags.flags();
    }
    us() {
        var t;
        this.is_capturing() && this.config.request_batching && (null == (t = this.Zr) || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && $9052383c1c4e5569$var$Ii(this.__request_queue, (t)=>this.ts(t)), this.__request_queue = [], this.us();
    }
    _handle_unload() {
        var t, i;
        this.surveys.handlePageUnload(), this.config.request_batching ? (this.ds() && this.capture("$pageleave"), null == (t = this.Zr) || t.unload(), null == (i = this.es) || i.unload()) : this.ds() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    _send_request(t) {
        this.__loaded && ($9052383c1c4e5569$var$zo ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = $9052383c1c4e5569$var$un(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = $9052383c1c4e5569$var$g({}, this.config.request_headers, t.headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, t.disableXHRCredentials = this.config.__preview_disable_xhr_credentials, this.config.__preview_disable_beacon && (t.disableTransport = [
            "sendBeacon"
        ]), t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var i, e, r, s = $9052383c1c4e5569$var$g({}, t);
            s.timeout = s.timeout || 6e4, s.url = $9052383c1c4e5569$var$un(s.url, {
                _: (new Date).getTime().toString(),
                ver: $9052383c1c4e5569$var$c.LIB_VERSION,
                compression: s.compression
            });
            var n = null !== (i = s.transport) && void 0 !== i ? i : "fetch", o = $9052383c1c4e5569$var$vn.filter((t)=>!s.disableTransport || !t.transport || !s.disableTransport.includes(t.transport)), a = null !== (e = null == (r = $9052383c1c4e5569$var$Ui(o, (t)=>t.transport === n)) ? void 0 : r.method) && void 0 !== e ? e : o[0].method;
            if (!a) throw new Error("No available transport method");
            a(s);
        })($9052383c1c4e5569$var$g({}, t, {
            callback: (i)=>{
                var e, r;
                (this.rateLimiter.checkForLimiting(i), i.statusCode >= 400) && (null == (e = (r = this.config).on_request_error) || e.call(r, i));
                null == t.callback || t.callback(i);
            }
        }))));
    }
    ts(t) {
        this.es ? this.es.retriableRequest(t) : this._send_request(t);
    }
    _execute_array(t) {
        var i, e = [], r = [], s = [];
        $9052383c1c4e5569$var$Ii(t, (t)=>{
            t && (i = t[0], $9052383c1c4e5569$var$I(i) ? s.push(t) : $9052383c1c4e5569$var$C(t) ? t.call(this) : $9052383c1c4e5569$var$I(t) && "alias" === i ? e.push(t) : $9052383c1c4e5569$var$I(t) && -1 !== i.indexOf("capture") && $9052383c1c4e5569$var$C(this[i]) ? s.push(t) : r.push(t));
        });
        var n = function(t, i) {
            $9052383c1c4e5569$var$Ii(t, function(t) {
                if ($9052383c1c4e5569$var$I(t[0])) {
                    var e = i;
                    $9052383c1c4e5569$var$Ci(t, function(t) {
                        e = e[t[0]].apply(e, t.slice(1));
                    });
                } else this[t[0]].apply(this, t.slice(1));
            }, i);
        };
        n(e, this), n(r, this), n(s, this);
    }
    ss() {
        var t, i;
        return (null == (t = this.config.bootstrap) ? void 0 : t.featureFlags) && Object.keys(null == (i = this.config.bootstrap) ? void 0 : i.featureFlags).length > 0 || !1;
    }
    push(t) {
        this._execute_array([
            t
        ]);
    }
    capture(t, i, e) {
        var r;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.Zr) {
            if (this.is_capturing()) {
                if (!$9052383c1c4e5569$var$O(t) && $9052383c1c4e5569$var$M(t)) {
                    var s = !this.config.opt_out_useragent_filter && this._is_bot();
                    if (!(s && !this.config.__preview_capture_bot_pageviews)) {
                        var n = null != e && e.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == n || !n.isRateLimited) {
                            null != i && i.$current_url && !$9052383c1c4e5569$var$M(null == i ? void 0 : i.$current_url) && ($9052383c1c4e5569$var$$i.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var o = new Date, a = (null == e ? void 0 : e.timestamp) || o, l = $9052383c1c4e5569$var$yr(), u = {
                                uuid: l,
                                event: t,
                                properties: this.calculateEventProperties(t, i || {}, a, l)
                            };
                            "$pageview" === t && this.config.__preview_capture_bot_pageviews && s && (u.event = "$bot_pageview", u.properties.$browser_type = "bot"), n && (u.properties.$lib_rate_limit_remaining_tokens = n.remainingTokens), (null == e ? void 0 : e.$set) && (u.$set = null == e ? void 0 : e.$set);
                            var h, d = "$groupidentify" !== t, v = this.vs(null == e ? void 0 : e.$set_once, d);
                            if (v && (u.$set_once = v), (u = $9052383c1c4e5569$var$Di(u, null != e && e._noTruncate ? null : this.config.properties_string_max_length)).timestamp = a, $9052383c1c4e5569$var$O(null == e ? void 0 : e.timestamp) || (u.properties.$event_time_override_provided = !0, u.properties.$event_time_override_system_time = o), t === $9052383c1c4e5569$export$9d7ec1793ca1658e.DISMISSED || t === $9052383c1c4e5569$export$9d7ec1793ca1658e.SENT) {
                                var c = null == i ? void 0 : i[$9052383c1c4e5569$export$fe4c9af525341543.SURVEY_ID], f = null == i ? void 0 : i[$9052383c1c4e5569$export$fe4c9af525341543.SURVEY_ITERATION];
                                h = {
                                    id: c,
                                    current_iteration: f
                                }, localStorage.getItem($9052383c1c4e5569$var$Xn(h)) || localStorage.setItem($9052383c1c4e5569$var$Xn(h), "true"), u.$set = $9052383c1c4e5569$var$g({}, u.$set, {
                                    [$9052383c1c4e5569$var$Yn({
                                        id: c,
                                        current_iteration: f
                                    }, t === $9052383c1c4e5569$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed")]: !0
                                });
                            } else t === $9052383c1c4e5569$export$9d7ec1793ca1658e.SHOWN && (u.$set = $9052383c1c4e5569$var$g({}, u.$set, {
                                [$9052383c1c4e5569$export$fe4c9af525341543.SURVEY_LAST_SEEN_DATE]: (new Date).toISOString()
                            }));
                            var p = $9052383c1c4e5569$var$g({}, u.properties.$set, u.$set);
                            if ($9052383c1c4e5569$var$F(p) || this.setPersonPropertiesForFlags(p), !$9052383c1c4e5569$var$D(this.config.before_send)) {
                                var _ = this.cs(u);
                                if (!_) return;
                                u = _;
                            }
                            this.qr.emit("eventCaptured", u);
                            var m = {
                                method: "POST",
                                url: null !== (r = null == e ? void 0 : e._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: u,
                                compression: "best-available",
                                batchKey: null == e ? void 0 : e._batchKey
                            };
                            return !this.config.request_batching || e && (null == e || !e._batchKey) || null != e && e.send_instantly ? this.ts(m) : this.Zr.enqueue(m), u;
                        }
                        $9052383c1c4e5569$var$$i.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $9052383c1c4e5569$var$$i.error("No event name provided to posthog.capture");
            }
        } else $9052383c1c4e5569$var$$i.uninitializedWarning("posthog.capture");
    }
    _addCaptureHook(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    calculateEventProperties(t, i, e, r, s) {
        if (e = e || new Date, !this.persistence || !this.sessionPersistence) return i;
        var n = s ? void 0 : this.persistence.remove_event_timer(t), a = $9052383c1c4e5569$var$g({}, i);
        if (a.token = this.config.token, a.$config_defaults = this.config.defaults, ("always" == this.config.cookieless_mode || "on_reject" == this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) && (a.$cookieless_mode = !0), "$snapshot" === t) {
            var l = $9052383c1c4e5569$var$g({}, this.persistence.properties(), this.sessionPersistence.properties());
            return a.distinct_id = l.distinct_id, (!$9052383c1c4e5569$var$M(a.distinct_id) && !$9052383c1c4e5569$var$L(a.distinct_id) || $9052383c1c4e5569$var$A(a.distinct_id)) && $9052383c1c4e5569$var$$i.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), a;
        }
        var u, h = $9052383c1c4e5569$var$ps(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
        if (this.sessionManager) {
            var { sessionId: v, windowId: c } = this.sessionManager.checkAndGetSessionAndWindowId(s, e.getTime());
            a.$session_id = v, a.$window_id = c;
        }
        this.sessionPropsManager && $9052383c1c4e5569$var$Ri(a, this.sessionPropsManager.getSessionProps());
        try {
            var f;
            this.sessionRecording && $9052383c1c4e5569$var$Ri(a, this.sessionRecording.sdkDebugProperties), a.$sdk_debug_retry_queue_size = null == (f = this.es) ? void 0 : f.length;
        } catch (t) {
            a.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $9052383c1c4e5569$var$Po.CUSTOM && (a.$lib_custom_api_host = this.config.api_host), u = "$pageview" !== t || s ? "$pageleave" !== t || s ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(e) : this.pageViewManager.doPageView(e, r), a = $9052383c1c4e5569$var$Ri(a, u), "$pageview" === t && $9052383c1c4e5569$var$o && (a.title = $9052383c1c4e5569$var$o.title), !$9052383c1c4e5569$var$O(n)) {
            var p = e.getTime() - n;
            a.$duration = parseFloat((p / 1e3).toFixed(3));
        }
        $9052383c1c4e5569$var$d && this.config.opt_out_useragent_filter && (a.$browser_type = this._is_bot() ? "bot" : "browser"), (a = $9052383c1c4e5569$var$Ri({}, h, this.persistence.properties(), this.sessionPersistence.properties(), a)).$is_identified = this._isIdentified(), $9052383c1c4e5569$var$I(this.config.property_denylist) ? $9052383c1c4e5569$var$Ci(this.config.property_denylist, function(t) {
            delete a[t];
        }) : $9052383c1c4e5569$var$$i.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var _ = this.config.sanitize_properties;
        _ && ($9052383c1c4e5569$var$$i.error("sanitize_properties is deprecated. Use before_send instead"), a = _(a, t));
        var m = this.fs();
        return a.$process_person_profile = m, m && !s && this.ps("_calculate_event_properties"), a;
    }
    vs(t, i) {
        var e;
        if (void 0 === i && (i = !0), !this.persistence || !this.fs()) return t;
        if (this.Br) return t;
        var r = this.persistence.get_initial_props(), s = null == (e = this.sessionPropsManager) ? void 0 : e.getSetOnceProps(), n = $9052383c1c4e5569$var$Ri({}, r, s || {}, t || {}), o = this.config.sanitize_properties;
        return o && ($9052383c1c4e5569$var$$i.error("sanitize_properties is deprecated. Use before_send instead"), n = o(n, "$set_once")), i && (this.Br = !0), $9052383c1c4e5569$var$F(n) ? void 0 : n;
    }
    register(t, i) {
        var e;
        null == (e = this.persistence) || e.register(t, i);
    }
    register_once(t, i, e) {
        var r;
        null == (r = this.persistence) || r.register_once(t, i, e);
    }
    register_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.register(t);
    }
    unregister(t) {
        var i;
        null == (i = this.persistence) || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.unregister(t);
    }
    gs(t, i) {
        this.register({
            [t]: i
        });
    }
    getFeatureFlag(t, i) {
        return this.featureFlags.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        return this.featureFlags.getFeatureFlagPayload(t);
    }
    getFeatureFlagResult(t, i) {
        return this.featureFlags.getFeatureFlagResult(t, i);
    }
    isFeatureEnabled(t, i) {
        return this.featureFlags.isFeatureEnabled(t, i);
    }
    reloadFeatureFlags() {
        this.featureFlags.reloadFeatureFlags();
    }
    updateFlags(t, i, e) {
        var r = null != e && e.merge ? this.featureFlags.getFlagVariants() : {}, s = null != e && e.merge ? this.featureFlags.getFlagPayloads() : {}, n = $9052383c1c4e5569$var$g({}, r, t), o = $9052383c1c4e5569$var$g({}, s, i), a = {};
        for (var [l, u] of Object.entries(n)){
            var h = "string" == typeof u;
            a[l] = {
                key: l,
                enabled: !!h || Boolean(u),
                variant: h ? u : void 0,
                reason: void 0,
                metadata: $9052383c1c4e5569$var$O(null == o ? void 0 : o[l]) ? void 0 : {
                    id: 0,
                    version: void 0,
                    description: void 0,
                    payload: o[l]
                }
            };
        }
        this.featureFlags.receivedFeatureFlags({
            flags: a
        });
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        this.featureFlags.updateEarlyAccessFeatureEnrollment(t, i, e);
    }
    getEarlyAccessFeatures(t, i, e) {
        return void 0 === i && (i = !1), this.featureFlags.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this.qr.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags.onFeatureFlags(t);
    }
    onSurveysLoaded(t) {
        return this.surveys.onSurveysLoaded(t);
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null == (e = this.sessionManager) ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getSurveys(t, i);
    }
    getActiveMatchingSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getActiveMatchingSurveys(t, i);
    }
    renderSurvey(t, i) {
        this.surveys.renderSurvey(t, i);
    }
    displaySurvey(t, i) {
        void 0 === i && (i = $9052383c1c4e5569$var$Zn), this.surveys.displaySurvey(t, i);
    }
    cancelPendingSurvey(t) {
        this.surveys.cancelPendingSurvey(t);
    }
    canRenderSurvey(t) {
        return this.surveys.canRenderSurvey(t);
    }
    canRenderSurveyAsync(t, i) {
        return void 0 === i && (i = !1), this.surveys.canRenderSurveyAsync(t, i);
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $9052383c1c4e5569$var$$i.uninitializedWarning("posthog.identify");
        if ($9052383c1c4e5569$var$L(t) && (t = t.toString(), $9052383c1c4e5569$var$$i.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
            if ([
                "distinct_id",
                "distinctid"
            ].includes(t.toLowerCase())) $9052383c1c4e5569$var$$i.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
            else if (t !== $9052383c1c4e5569$var$me) {
                if (this.ps("posthog.identify")) {
                    var r = this.get_distinct_id();
                    if (this.register({
                        $user_id: t
                    }), !this.get_property("$device_id")) {
                        var s = r;
                        this.register_once({
                            $had_persisted_distinct_id: !0,
                            $device_id: s
                        }, "");
                    }
                    t !== r && t !== this.get_property($9052383c1c4e5569$var$Bi) && (this.unregister($9052383c1c4e5569$var$Bi), this.register({
                        distinct_id: t
                    }));
                    var n = "anonymous" === (this.persistence.get_property($9052383c1c4e5569$var$he) || "anonymous");
                    t !== r && n ? (this.persistence.set_property($9052383c1c4e5569$var$he, "identified"), this.setPersonPropertiesForFlags($9052383c1c4e5569$var$g({}, e || {}, i || {}), !1), this.capture("$identify", {
                        distinct_id: t,
                        $anon_distinct_id: r
                    }, {
                        $set: i || {},
                        $set_once: e || {}
                    }), this.Jr = $9052383c1c4e5569$var$fn(t, i, e), this.featureFlags.setAnonymousDistinctId(r)) : (i || e) && this.setPersonProperties(i, e), t !== r && (this.reloadFeatureFlags(), this.unregister($9052383c1c4e5569$var$ue));
                }
            } else $9052383c1c4e5569$var$$i.critical('The string "' + $9052383c1c4e5569$var$me + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.');
        } else $9052383c1c4e5569$var$$i.error("Unique user id has not been set in posthog.identify");
    }
    setPersonProperties(t, i) {
        if ((t || i) && this.ps("posthog.setPersonProperties")) {
            var e = $9052383c1c4e5569$var$fn(this.get_distinct_id(), t, i);
            this.Jr !== e ? (this.setPersonPropertiesForFlags($9052383c1c4e5569$var$g({}, i || {}, t || {})), this.capture("$set", {
                $set: t || {},
                $set_once: i || {}
            }), this.Jr = e) : $9052383c1c4e5569$var$$i.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, i, e) {
        if (t && i) {
            var r = this.getGroups();
            r[t] !== i && this.resetGroupPropertiesForFlags(t), this.register({
                $groups: $9052383c1c4e5569$var$g({}, r, {
                    [t]: i
                })
            }), e && (this.capture("$groupidentify", {
                $group_type: t,
                $group_key: i,
                $group_set: e
            }), this.setGroupPropertiesForFlags({
                [t]: e
            })), r[t] === i || e || this.reloadFeatureFlags();
        } else $9052383c1c4e5569$var$$i.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.featureFlags.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags() {
        this.featureFlags.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.ps("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(t, i);
    }
    resetGroupPropertiesForFlags(t) {
        this.featureFlags.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var i, e, r, s;
        if ($9052383c1c4e5569$var$$i.info("reset"), !this.__loaded) return $9052383c1c4e5569$var$$i.uninitializedWarning("posthog.reset");
        var n = this.get_property("$device_id");
        if (this.consent.reset(), null == (i = this.persistence) || i.clear(), null == (e = this.sessionPersistence) || e.clear(), this.surveys.reset(), this.featureFlags.reset(), null == (r = this.persistence) || r.set_property($9052383c1c4e5569$var$he, "anonymous"), null == (s = this.sessionManager) || s.resetSessionId(), this.Jr = null, "always" === this.config.cookieless_mode) this.register_once({
            distinct_id: $9052383c1c4e5569$var$me,
            $device_id: null
        }, "");
        else {
            var o = this.config.get_device_id($9052383c1c4e5569$var$yr());
            this.register_once({
                distinct_id: o,
                $device_id: t ? o : n
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1);
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null == (i = this.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + i);
        if (null != t && t.withTimestamp && e) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!e) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, i) {
        return t === this.get_property($9052383c1c4e5569$var$Hi) ? ($9052383c1c4e5569$var$$i.critical("Attempting to create alias for existing People user - aborting."), -2) : this.ps("posthog.alias") ? ($9052383c1c4e5569$var$O(i) && (i = this.get_distinct_id()), t !== i ? (this.gs($9052383c1c4e5569$var$Bi, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($9052383c1c4e5569$var$$i.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var i = $9052383c1c4e5569$var$g({}, this.config);
        if ($9052383c1c4e5569$var$R(t)) {
            var e, r, s, n, o, a, l;
            $9052383c1c4e5569$var$Ri(this.config, $9052383c1c4e5569$var$Bo(t));
            var u = this.Qr();
            null == (e = this.persistence) || e.update_config(this.config, i, u), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $9052383c1c4e5569$var$On($9052383c1c4e5569$var$g({}, this.config, {
                persistence: "sessionStorage"
            }), u);
            var h = this.Kr(this.config.debug);
            $9052383c1c4e5569$var$U(h) && (this.config.debug = h), $9052383c1c4e5569$var$U(this.config.debug) && (this.config.debug ? ($9052383c1c4e5569$var$c.DEBUG = !0, $9052383c1c4e5569$var$Pr.H() && $9052383c1c4e5569$var$Pr.G("ph_debug", "true"), $9052383c1c4e5569$var$$i.info("set_config", {
                config: t,
                oldConfig: i,
                newConfig: $9052383c1c4e5569$var$g({}, this.config)
            })) : ($9052383c1c4e5569$var$c.DEBUG = !1, $9052383c1c4e5569$var$Pr.H() && $9052383c1c4e5569$var$Pr.V("ph_debug"))), null == (r = this.exceptionObserver) || r.onConfigChange(), null == (s = this.sessionRecording) || s.startIfEnabledOrStop(), null == (n = this.autocapture) || n.startIfEnabled(), null == (o = this.heatmaps) || o.startIfEnabled(), null == (a = this.exceptionObserver) || a.startIfEnabledOrStop(), this.surveys.loadIfEnabled(), this._s(), null == (l = this.externalIntegrations) || l.startIfEnabledOrStop();
        }
    }
    startSessionRecording(t) {
        var i = !0 === t, e = {
            sampling: i || !(null == t || !t.sampling),
            linked_flag: i || !(null == t || !t.linked_flag),
            url_trigger: i || !(null == t || !t.url_trigger),
            event_trigger: i || !(null == t || !t.event_trigger)
        };
        if (Object.values(e).some(Boolean)) {
            var r, s, n, o, a;
            if (null == (r = this.sessionManager) || r.checkAndGetSessionAndWindowId(), e.sampling) null == (s = this.sessionRecording) || s.overrideSampling();
            if (e.linked_flag) null == (n = this.sessionRecording) || n.overrideLinkedFlag();
            if (e.url_trigger) null == (o = this.sessionRecording) || o.overrideTrigger("url");
            if (e.event_trigger) null == (a = this.sessionRecording) || a.overrideTrigger("event");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, i) {
        var e = new Error("PostHog syntheticException"), r = this.exceptions.buildProperties(t, {
            handled: !0,
            syntheticException: e
        });
        return this.exceptions.sendExceptionEvent($9052383c1c4e5569$var$g({}, r, i));
    }
    startExceptionAutocapture(t) {
        this.set_config({
            capture_exceptions: null == t || t
        });
    }
    stopExceptionAutocapture() {
        this.set_config({
            capture_exceptions: !1
        });
    }
    loadToolbar(t) {
        return this.toolbar.loadToolbar(t);
    }
    get_property(t) {
        var i;
        return null == (i = this.persistence) ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null == (i = this.sessionPersistence) ? void 0 : i.props[t];
    }
    toString() {
        var t, i = null !== (t = this.config.name) && void 0 !== t ? t : $9052383c1c4e5569$var$Uo;
        return i !== $9052383c1c4e5569$var$Uo && (i = $9052383c1c4e5569$var$Uo + "." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null == (t = this.persistence) ? void 0 : t.get_property($9052383c1c4e5569$var$he)) || "identified" === (null == (i = this.sessionPersistence) ? void 0 : i.get_property($9052383c1c4e5569$var$he));
    }
    fs() {
        var t, i;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $9052383c1c4e5569$var$F(this.getGroups()) && (null == (t = this.persistence) || null == (t = t.props) || !t[$9052383c1c4e5569$var$Bi]) && (null == (i = this.persistence) || null == (i = i.props) || !i[$9052383c1c4e5569$var$ge]));
    }
    ds() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.fs() || this.ps("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    setInternalOrTestUser() {
        this.ps("posthog.setInternalOrTestUser") && this.setPersonProperties({
            $internal_or_test_user: !0
        });
    }
    ps(t) {
        return "never" === this.config.person_profiles ? ($9052383c1c4e5569$var$$i.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.gs($9052383c1c4e5569$var$ge, !0), !0);
    }
    Qr() {
        if ("always" === this.config.cookieless_mode) return !0;
        var t = this.consent.isOptedOut(), i = this.config.opt_out_persistence_by_default || "on_reject" === this.config.cookieless_mode;
        return this.config.disable_persistence || t && !!i;
    }
    _s() {
        var t, i, e, r, s = this.Qr();
        (null == (t = this.persistence) ? void 0 : t.ki) !== s && (null == (e = this.persistence) || e.set_disabled(s));
        (null == (i = this.sessionPersistence) ? void 0 : i.ki) !== s && (null == (r = this.sessionPersistence) || r.set_disabled(s));
        return s;
    }
    opt_in_capturing(t) {
        var i;
        if ("always" !== this.config.cookieless_mode) {
            var e, r, s;
            if ("on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) this.reset(!0), null == (e = this.sessionManager) || e.destroy(), null == (r = this.pageViewManager) || r.destroy(), this.sessionManager = new $9052383c1c4e5569$var$xo(this), this.pageViewManager = new $9052383c1c4e5569$var$xs(this), this.persistence && (this.sessionPropsManager = new $9052383c1c4e5569$var$yo(this, this.sessionManager, this.persistence)), this.sessionRecording = new $9052383c1c4e5569$var$Do(this), this.sessionRecording.startIfEnabledOrStop();
            if (this.consent.optInOut(!0), this._s(), this.us(), null == (i = this.sessionRecording) || i.startIfEnabledOrStop(), "on_reject" == this.config.cookieless_mode && this.surveys.loadIfEnabled(), $9052383c1c4e5569$var$O(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) this.capture(null !== (s = null == t ? void 0 : t.captureEventName) && void 0 !== s ? s : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            });
            this.config.capture_pageview && this.hs();
        } else $9052383c1c4e5569$var$$i.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    opt_out_capturing() {
        var t, i, e;
        "always" !== this.config.cookieless_mode ? ("on_reject" === this.config.cookieless_mode && this.consent.isOptedIn() && this.reset(!0), this.consent.optInOut(!1), this._s(), "on_reject" === this.config.cookieless_mode && (this.register({
            distinct_id: $9052383c1c4e5569$var$me,
            $device_id: null
        }), null == (t = this.sessionManager) || t.destroy(), null == (i = this.pageViewManager) || i.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, null == (e = this.sessionRecording) || e.stopRecording(), this.sessionRecording = void 0, this.hs())) : $9052383c1c4e5569$var$$i.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        var t = this.consent.consent;
        return t === $9052383c1c4e5569$var$Or.GRANTED ? "granted" : t === $9052383c1c4e5569$var$Or.DENIED ? "denied" : "pending";
    }
    is_capturing() {
        return "always" === this.config.cookieless_mode || ("on_reject" === this.config.cookieless_mode ? this.consent.isExplicitlyOptedOut() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this._s();
    }
    _is_bot() {
        return $9052383c1c4e5569$var$n ? $9052383c1c4e5569$var$ko($9052383c1c4e5569$var$n, this.config.custom_blocked_useragents) : void 0;
    }
    hs() {
        $9052383c1c4e5569$var$o && ("visible" === $9052383c1c4e5569$var$o.visibilityState ? this.Wr || (this.Wr = !0, this.capture("$pageview", {
            title: $9052383c1c4e5569$var$o.title
        }, {
            send_instantly: !0
        }), this.Gr && ($9052383c1c4e5569$var$o.removeEventListener("visibilitychange", this.Gr), this.Gr = null)) : this.Gr || (this.Gr = this.hs.bind(this), $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$o, "visibilitychange", this.Gr)));
    }
    debug(i) {
        !1 === i ? (null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.console.log("You've disabled debug mode."), this.set_config({
            debug: !1
        })) : (null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({
            debug: !0
        }));
    }
    M() {
        var t, i, e, r, s, n, o, a = this.Yr || {};
        return "advanced_disable_flags" in a ? !!a.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($9052383c1c4e5569$var$$i.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (e = "advanced_disable_decide", r = !1, s = $9052383c1c4e5569$var$$i, n = (i = "advanced_disable_flags") in (t = a) && !$9052383c1c4e5569$var$D(t[i]), o = e in t && !$9052383c1c4e5569$var$D(t[e]), n ? t[i] : o ? (s && s.warn("Config field '" + e + "' is deprecated. Please use '" + i + "' instead. The old field will be removed in a future major version."), t[e]) : r);
    }
    cs(t) {
        if ($9052383c1c4e5569$var$D(this.config.before_send)) return t;
        var i = $9052383c1c4e5569$var$I(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], e = t;
        for (var r of i){
            if (e = r(e), $9052383c1c4e5569$var$D(e)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return $9052383c1c4e5569$var$H(t.event) ? $9052383c1c4e5569$var$$i.warn(s + ". This can cause unexpected behavior.") : $9052383c1c4e5569$var$$i.info(s), null;
            }
            e.properties && !$9052383c1c4e5569$var$F(e.properties) || $9052383c1c4e5569$var$$i.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return e;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.Kt) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
    Kr(t) {
        var i = $9052383c1c4e5569$var$U(t) && !t, e = $9052383c1c4e5569$var$Pr.H() && "true" === $9052383c1c4e5569$var$Pr.q("ph_debug");
        return !i && (!!e || t);
    }
}
!function(t, i) {
    for(var e = 0; e < i.length; e++)t.prototype[i[e]] = $9052383c1c4e5569$var$Ai(t.prototype[i[e]]);
}($9052383c1c4e5569$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $9052383c1c4e5569$var$Go, $9052383c1c4e5569$export$8f14e1a0dc415d5d = {
    backgroundColor: "#ffffff",
    textColor: "#1d1f27",
    buttonColor: "#1d1f27",
    borderRadius: 8,
    buttonBorderRadius: 6,
    borderColor: "#e5e7eb",
    fontFamily: "system-ui",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    showOverlay: !0,
    whiteLabel: !1,
    dismissOnClickOutside: !0,
    zIndex: 2147483646
}, $9052383c1c4e5569$export$2e2bcd8739ae039 = ($9052383c1c4e5569$var$Go = $9052383c1c4e5569$var$Lo[$9052383c1c4e5569$var$Uo] = new $9052383c1c4e5569$export$a9d6b9cbf49b8241, function() {
    function i() {
        i.done || (i.done = !0, $9052383c1c4e5569$var$zo = !1, $9052383c1c4e5569$var$Ci($9052383c1c4e5569$var$Lo, function(t) {
            t._dom_loaded();
        }));
    }
    null != $9052383c1c4e5569$var$o && $9052383c1c4e5569$var$o.addEventListener ? "complete" === $9052383c1c4e5569$var$o.readyState ? i() : $9052383c1c4e5569$var$zi($9052383c1c4e5569$var$o, "DOMContentLoaded", i, {
        capture: !1
    }) : $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$$i.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), $9052383c1c4e5569$var$Go);


(0, $9052383c1c4e5569$export$2e2bcd8739ae039).init('phc_BV3TNdk0zHpKElNC6FC9FiLqRsBNVTFnMhGrMtJm2xm', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-11-30'
});

})();
//# sourceMappingURL=posthog.js.map
